<template>
    <div class="container">
        <div class="headline">
            <div class="left-container">
                <div class="back">
                    <img @click="backXnews" :src="$_syscfg.index_log" alt="">
                    <!-- <p>返回</p> -->
                </div>

                <div :class="{'title-container': true, on: release_config && release_config.title && release_config.title.need_input}">
                    <p v-if="!editTitle && selectPlatform != 'dy'" class="t">标题：</p>
                    <div v-if="!editTitle && articleId && selectPlatform != 'dy'" class="title">
                        <p :title="titleInput">{{titleInput}}</p>
                        <img @click="editTitle = true" src="@assets/img/mediaPublish/titleEdit.png" alt="">
                    </div>
                    <div v-if="editTitle && selectPlatform != 'b_plus' && selectPlatform != 'dy' && selectPlatform != 'five_star_sports_cms' && selectPlatform != 'bilibili' && selectPlatform != 'playlist'" :class="{input: true, un: wordNum > 22}">
                        <input @blur="closeInput" @keydown.enter="editTitle = false;renameTitle()" v-model="titleInput" placeholder="请输入标题…" type="text">
                        <p><span>{{wordNum}}</span>/22</p>
                    </div>
                    <div v-if="editTitle && (selectPlatform == 'dy')" :class="{input: true, un: wordNum > 60}">
                        <input @blur="closeInput" @keydown.enter="editTitle = false;renameTitle()" v-model="titleInput" placeholder="请输入标题…" type="text">
                        <p><span>{{wordNum}}</span>/60</p>
                    </div>
                    <div v-if="editTitle && (selectPlatform == 'b_plus')" :class="{input: true, un: wordNum > 50}">
                        <input @blur="closeInput" @keydown.enter="editTitle = false;renameTitle()" v-model="titleInput" placeholder="请输入标题…" type="text">
                        <p><span>{{wordNum}}</span>/50</p>
                    </div>
                    <div v-if="editTitle && (selectPlatform == 'five_star_sports_cms')" :class="{input: true, un: wordNum > 100}">
                        <input @blur="closeInput" @keydown.enter="editTitle = false;renameTitle()" v-model="titleInput" placeholder="请输入标题…" type="text">
                        <p><span>{{wordNum}}</span>/100</p>
                    </div>
                    <div v-if="editTitle && (selectPlatform == 'bilibili' || selectPlatform == 'playlist')" :class="{input: true, un: titleInput.length > 80}">
                        <input @blur="closeInput" @keydown.enter="editTitle = false;renameTitle()" v-model="titleInput" placeholder="请输入标题…" type="text">
                        <p><span>{{titleInput.length}}</span>/80</p>
                    </div>
                </div>
            </div>
            <div class="right-container">
                <div v-if="mediaPublishDetail.status != 1 && mediaPublishDetail.status != 3 && mediaPublishDetail.status != 7 && (selectPlatform != 'five_star_sports_cms' || (selectPlatform == 'five_star_sports_cms' && mediaType == 5))" @click="isSubmitUpload = !isSubmitUpload" class="auto-submit">
                    <i :class="{on: isSubmitUpload}"></i>
                    <p>传完自动提交</p>
                </div>
                <div @click="saveArticle" :class="{btn: true,grey: disabledSavedBtn}">{{mediaPublishDetail.status == 1 ? '修改' : '保存草稿'}}</div>
                <div @click="checkSubmit" :class="{btn: true, green: true, grey: disabledSavedBtn}">{{mediaPublishDetail.status == 1 ? '修改并通过' : '发布'}}</div>
                <!-- <div @click="showTips" class="btn green">{{mediaPublishDetail.status == 1 ? '修改并通过' : '发布'}}</div> -->
            </div>
        </div>

        <div class="content-container">
            <div class="left-container">
                <div @click="goCreate" :class="{addBtn: true,grey: mediaPublishDetail.status == 1 || mediaPublishDetail.status == 3 || mediaPublishDetail.status == 7,green: mediaPublishDetail.status != 1 && mediaPublishDetail.status != 3 && mediaPublishDetail.status != 7}">
                    <img v-if="mediaPublishDetail.status == 0" src="@assets/img/mediaPublish/addIcon.png" alt="">
                    <img v-if="mediaPublishDetail.status == 1 || mediaPublishDetail.status == 3 || mediaPublishDetail.status == 7" src="@assets/img/mediaPublish/addIconGrey.png" alt="">
                    <p>添加平台</p>
                </div>
                <ul :class="{'channel-container': true, auto: leftScroll}">
                    <li v-for="(item, index) in mediaPublishDetail.platforms" :key="index">
                        <div class="channel on">
                            <div class="left"> 
                                <img v-show="item.p_key != 'b_plus' && item.p_key != 'dy' && item.p_key != 'five_star_sports_cms' && item.p_key != 'bilibili' && item.p_key != 'playlist'" src="@assets/img/mediaPublish/kankanIcon.png" alt="">
                                <img v-show="item.p_key == 'b_plus'" src="@assets/img/mediaPublish/bIcon.png" alt="">
                                <img v-show="item.p_key == 'dy'" src="@assets/img/mediaPublish/dIcon.png" alt="">
                                <img v-show="item.p_key == 'five_star_sports_cms'" src="@assets/img/mediaPublish/sportIconMain.png" alt="">
                                <img v-show="item.p_key == 'bilibili'" src="@assets/img/mediaPublish/biliIcon.png" alt="">
                                <img v-show="item.p_key == 'playlist'" src="@assets/img/mediaPublish/cloudIcon.png" alt="">
                                <p>{{item.c_title}}<span style="color: red;" v-show="!item.status">(停用)</span></p>
                            </div>
                            <div v-if="mediaPublishDetail.status == 0" class="right">
                                <p>{{item.list.length}}篇</p>
                                <div class="btnIcon">
                                    <i class="add">
                                        <div>
                                            <p></p>
                                            <ul>
                                                <li v-for="(item1,index1) in item.content_types" :key="index1" @click="newArticle(item1.content_type, index)">{{item1.content_title}}</li>
                                            </ul>
                                        </div>
                                    </i>
                                    <!-- <i @click="newArticle(index)" class="add"></i> -->
                                    <i @click="delColumn(index)" class="del"></i>
                                </div>
                            </div>
                        </div>
                        <ul v-if="item.list.length > 0" class="article-container">
                            <li v-for="(val, key) in item.list" :key="key" :class="{on: val.showMenu || val.id == articleId}" @mouseleave.prevent="val.showMenu=false;leftScroll=true">
                                <div @click="isSubmitUpload = false;showUpload = true;autoSave(val.id,val.platform_key,val.column_key,val.type)" class="left">
                                    <i :class="{video: val.type == 5, pic: val.type == 7, voice: val.type == 8}"></i>
                                    <p v-if="val.title" :title="val.title">{{val.title}}</p>
                                    <p v-else>{{item.p_key == 'five_star_sports_cms' || item.p_key == 'bilibili' || item.p_key == 'playlist' ? '未命名标题' : '无作品描述'}}</p>
                                </div>
                                <div v-if="mediaPublishDetail.status == 0" class="right">
                                    <i @click="val.showMenu = !val.showMenu; leftScroll = !leftScroll"></i>
                                    <div @click="delArticle(val.id)" v-show="val.showMenu">删除</div>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div v-if="showEmpty" class="empty-container">
                <img src="@assets/img/mediaPublish/empty.png" alt="">
            </div>

            <div v-show="showEmpty == false" class="middle-container">
                    <div v-if="errMessage" :class="mediaType == 6 ? 'm6' : 'm5'" ref="notice">
                        <notice style="margin-bottom: 10px;" :message="errMessage" />
                    </div>
                <div v-if="mediaType == 6" @scroll="scrollEvent" class="write-container">
                    <div v-show="selectPlatform != 'five_star_sports_cms'" :style="'font-size:'+fontSizeWrite+'px'" class="writeVideoUpload-container">
                        <div v-if="!showWriteVideo" @dragover="allowDrop($event)" @drop="drop($event)" class="unUpload-container">
                            <div :style="'font-size:'+fontSize+'px'">
                                <div @click="showWriteUpload = true;uploadTitle = '上传视频';topPic = false" class="btn"><i></i>上传视频</div>
                                <span>或将临时素材栏处视频拖拽至此处</span>
                            </div>
                        </div>
                        <div v-if="showWriteVideo" class="Upload-container">
                            <div :style="'font-size:'+fontSize+'px'">
                                <div class="left">
                                    <div  :style="'background: url('+ videoDetail.cover +') no-repeat;background-size: 100% 100%;background-position: center center;'" class="cover">
                                        <div v-if="!videoDetail.transcode_finish && selectPlatform != 'b_plus' && selectPlatform != 'dy'" class="encode">
                                            <img src="../../assets/img/mediaPublish/Triangles.gif" alt="">
                                            <span>转码中</span>
                                        </div>
                                        <div v-show="isChrome" class="backDrop"></div>
                                        <div v-show="!isChrome" :style="'background: url('+ videoDetail.cover +') no-repeat;'" class="blur"></div>
                                        <img :src="videoDetail.cover || defaultImg" alt="">
                                        <p  v-if="videoDetail.transcode_finish" @click="showWriteUpload=true;uploadTitle = '上传图片';topPic = true" class="changeCover">
                                            <i>更换封面</i>
                                        </p>
                                    </div>
                                    <div class="info">
                                        <p class="top">{{videoDetail.title}}</p>
                                        <div v-if="showProgress" class="bottom">
                                            <div class="progress">
                                                <p :style="'width:'+uploadInfo.progress+'%'"></p>
                                            </div>
                                            <p class="num">{{uploadInfo.progress}}%</p>
                                            <i @click="cancelNewUpload(newUploadFileId);showWriteVideo = false;showProgress = false;" class="del"></i>
                                        </div>

                                        <div v-if="false" class="err-info">
                                            视频上传失败，请<i @click="showWriteUpload = true;topPic = false">重新上传</i>
                                        </div>

                                        <div v-if="!showProgress && selectPlatform != 'b_plus' && selectPlatform != 'dy'" class="water">
                                            <span v-show="selectName != '请选择'">已选水印：{{selectName}}</span>
                                            <span @click="changeMediaWater" class="g">修改水印</span>
                                            <!-- <div ref="middleWater" v-click-outside="hideWriteSelect" class="water-list">
                                                <span :class="{on: selectName != '请选择'}" @click="showWriteWater">{{selectName}}</span>
                                                <i :class="{rotate: showWriteSelect}" @click="showWriteWater"></i>
                                                <ul v-if="showWriteSelect" class="select-list">
                                                    <li :class="{on: selectIndex == index}" @click="selectIndex = index;showWriteSelect = false;" v-for="(item,index) in logoList" :key="index">
                                                        <p>{{item.logo_title}}</p><i></i>
                                                        <img :class="{slim: item.type == 2}" :src="item.code" alt="">
                                                    </li>
                                                </ul>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                                <div v-if="!showProgress" class="right">
                                    <div @click="delWriteVideo(videoDetail)" class="del">
                                        <i></i>
                                        <span>删除</span>
                                    </div>
                                    <div @click="showWriteUpload = true;uploadTitle = '上传视频';topPic = false" class="reload">
                                        <i></i>
                                        <span>重新上传</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ueditor normalWrapper" id="normalWrapper">
                        <vue-ueditor-wrap ref="ueditor" @ready="normalReady" v-model="normalContent" :config="normalConfig" :init="customUpload"></vue-ueditor-wrap>
                    </div>
                </div>
                <div v-if="showVideo == false && (mediaType == 5 || mediaType == 7 || mediaType == 8)" :style="'font-size:'+fontSize+'px'" class="upload-container" :class="[showUpload && libraryMediaList && libraryMediaList.length > 0 ? 'has-library-btn':'' ]">
                    <div v-if="showUpload" class="upload">
                        <div class="uploadIcon"></div>
                        <div class="uploadBtn">
                            <div @click="localUpload" class="btn">
                                <i></i>
                                <p>本地上传</p>
                            </div>
                            <div @click="isCover=false;materialChannel='materialBin';showMaterialListBox()" class="btn">
                                <i></i>
                                <p>素材库</p>
                            </div>
                            <div @click="isCover=false;materialChannel='myMaterial';showMaterialListBox()" class="btn">
                                <i></i>
                                <p>我的素材</p>
                            </div>
                            <div v-for="(v, i) in libraryMediaList" :key="i" @click="isCover=false;materialChannel='myMaterial';showLibraryMaterialListBox(v)" class="btn">
                                <i></i>
                                <p>{{ v.title }}</p>
                            </div>
                        </div>
                        <div @dragover="allowDrop($event)" @drop="drop($event)" class="uploadArea">
                            <i></i>
                            <p>可将临时素材栏中的素材拖拽至虚线内！</p>
                        </div>
                        <div class="bplusNotice" v-show="selectPlatform == 'b_plus'">
                            <i></i>
                            <p>视频文件大小不超过50G，分辨率为720p（1280x720）及以上；<br/>建议上传格式：mpg、avi、mp4、mkv、mxf、vob、wmv、mpeg、ts、m4a、wma、flv。</p>
                        </div>
                        <div class="bilibiliNotice" v-show="selectPlatform == 'bilibili'">
                            <div>
                                <i></i>
                                <div>
                                    <p>视频格式</p>
                                    <span>支持常用视频格式，推荐使用mp4、flv</span>
                                </div>
                            </div>
                            <div>
                                <i></i>
                                <div>
                                    <p>视频大小</p>
                                    <span>文件大小限制为4GB，时长小于5小时；</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="showUpload == false && showProgress" :style="'font-size:'+fontSize+'px'" class="progress-container">
                        <el-progress :width="1.3*fontSize" type="circle" color="#41B48C" :percentage="uploadInfo.progress"></el-progress>
                        <p :style="'width:'+3.6*fontSize+'px;line-height: '+0.2*fontSize+'px;margin: '+0.2*fontSize+'px 0 '+0.3*fontSize+'px;'" class="name">{{uploadInfo.title}}</p>
                        <p @click="cancelNewUpload(newUploadFileId)" :style="'font-size:'+0.14*fontSize+'px;width: '+0.88*fontSize+'px;height:'+0.32*fontSize+'px;line-height: '+0.32*fontSize+'px'" class="btn">取消上传</p>
                    </div>
                    <div v-if="showUpload == false && showUploadError" class="uploadError-container">
                        <img src="@assets/img/mediaPublish/uploadError.png" alt="">
                        <p :style="'width:'+3.6*fontSize+'px;line-height: '+0.2*fontSize+'px;margin:'+0.2*fontSize+'px 0 '+0.14*fontSize+'px'" class="name">我是上传文件的标题最多这是我最长能…显示的文字.mp4</p>
                        <div>
                            <p>视频上传失败，请</p>
                            <span>重新上传</span>
                        </div>
                    </div>
                </div>
                <div v-if="showVideo == false && selectPlatform == 'dy' && mediaType == 5" :style="'font-size:'+fontSize+'px'" class="dy-notice">
                    <ul>
                        <li>
                            <div>
                                <img src="../../assets/img/mediaPublish/notice.png" alt="">
                                <p :style="'line-height: '+0.22 * fontSize+'px;'">视频格式</p>
                            </div>
                            <p :style="'line-height: '+0.22 * fontSize+'px;padding-left: '+0.22 * fontSize+'px'">支持常用视频格式，<br />推荐使用mp4、webm</p>
                        </li>
                        <li>
                            <div>
                                <img src="../../assets/img/mediaPublish/notice.png" alt="">
                                <p :style="'line-height: '+0.22 * fontSize+'px;'">视频大小</p>
                            </div>
                            <p :style="'line-height: '+0.22 * fontSize+'px;padding-left: '+0.22 * fontSize+'px'">视频文件大小不超过{{articleDetail.has_dy_btn == 1 ? '128M' : '4G'}}，时长在15分钟以内</p>
                        </li>
                        <li>
                            <div>
                                <img src="../../assets/img/mediaPublish/notice.png" alt="">
                                <p :style="'line-height: '+0.22 * fontSize+'px;'">视频分辨率</p>
                            </div>
                            <p :style="'line-height: '+0.22 * fontSize+'px;padding-left: '+0.22 * fontSize+'px'">分辨率为720p<br />(1280x720)及以上</p>
                        </li>
                    </ul>
                </div>
                <div v-if="showVideo && (mediaType == 5 || mediaType == 7 || mediaType == 8)" :style="'font-size:'+fontSize+'px'" class="video-container">
                    <div :class="{videoPlayer: true, row: videoDetail && videoDetail.isRow, column: videoDetail && !videoDetail.isRow}">
                        <audio v-show="mediaType == 8" ref="audio" :src="videoDetail.content && videoDetail.content.url"></audio>
                        <video v-show="mediaType != 7 && mediaType != 8" ref="video" :src="videoDetail.content && videoDetail.content.url"></video>
                        <img v-if="showPlayBtn && videoDetail.transcode_finish && mediaType != 7" @click="playVideo" src="@assets/img/mediaPublish/playButton.png" alt="">
                        <div v-if="videoDetail.transcode_finish && mediaType == 8" class="audioMask"></div>
                        <img v-if="videoDetail.transcode_finish && mediaType == 7" :src="videoDetail && videoDetail.url" class="imgMask">
                        <div v-if="videoDetail && !videoDetail.transcode_finish && (selectPlatform == 'b_plus' || selectPlatform == 'dy')" class="encodeMask">
                            <p class="icon">
                                <img src="../../assets/img/mediaPublish/Triangles.gif" alt="">
                                <span>转码中…</span>
                            </p>
                            <span v-show="selectPlatform == 'dy' && selectName != '请选择'">已选水印：{{selectName}}</span>
                            <span></span>
                            <div class="btns">
                                <div @click="delWriteVideo(videoDetail)" class="btn g">
                                    <img src="../../assets/img/mediaPublish/whiteDel.png" alt="">
                                    <span>删除</span>
                                </div>
                                <div @click="showWriteUpload = true;uploadTitle = '上传视频';topPic = false" class="btn">
                                    <img src="../../assets/img/mediaPublish/whiteReload.png" alt="">
                                    <span>重新上传</span>
                                </div>
                            </div>
                        </div>
                        <div v-if="videoDetail && !videoDetail.transcode_finish && selectPlatform != 'b_plus' && selectPlatform != 'dy'" class="encodeMask">
                            <p class="icon">
                                <img src="../../assets/img/mediaPublish/Triangles.gif" alt="">
                                <span>转码中…</span>
                            </p>
                            <span v-show="selectName != '请选择'">已选水印：{{selectName}}</span>
                            <div class="btns">
                                <div @click="delWriteVideo(videoDetail)" class="btn g">
                                    <img src="../../assets/img/mediaPublish/whiteDel.png" alt="">
                                    <span>删除</span>
                                </div>
                                <div @click="showWriteUpload = true;uploadTitle = '上传视频';topPic = false" class="btn">
                                    <img src="../../assets/img/mediaPublish/whiteReload.png" alt="">
                                    <span>重新上传</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="showVideo && (mediaType == 5 || mediaType == 8) && videoDetail && videoDetail.transcode_finish" :style="'font-size:'+fontSize+'px'" class="tool-container">
                    <i @click="playVideo" v-show="showPlayBtn" class="playBtn"></i>
                    <i @click="pauseVideo" v-show="!showPlayBtn" class="pauseBtn"></i>
                    <p :style="'margin: 0 '+0.12*fontSize+'px'" class="time">{{currentTime}} / {{duration}}</p>
                    <div ref="line" class="progress">
                        <p @click="isMouseClick=true;clickJump($event)" class="progress-bg"></p>
                        <p @click="isMouseClick=true;clickJump($event)" class="progress-fill" :style="'width:' + audioPercent">
                        <i @mouseenter.prevent="isMouseClick=false" @mouseout.prevent="timeNavi();isMouseClick=false;" @mousedown.prevent="isMouseClick=true;timeStop();isPlayAudio=false" @mouseup.prevent="timeNavi();isMouseClick=false;"
                            @mousemove.prevent="slideMouseMove"></i>
                        </p>
                    </div>
                    <div v-click-outside="closeShowRate" class="speed">
                        <p @click="showRate = !showRate" :class="{one: rateSpeed == 1, two: rateSpeed == 2}"></p>
                        <ul v-if="showRate">
                            <li @click="setRate(1)">1倍</li>
                            <li @click="setRate(2)">2倍</li>
                        </ul>
                    </div>
                    <div v-click-outside="closeshowVoice" class="vol">
                        <i @click="showVoice = !showVoice"></i>
                        <div v-show="showVoice" class="volContent">
                            <div ref="volLine" class="line">
                                <p @click="isVolMouseClick=true;clickJumpHeight($event)" class="lineProgress"></p>
                                <p @click="isVolMouseClick=true;clickJumpHeight($event)" :style="'height:' + volPercent" class="lineCover">
                                    <i @mouseenter.prevent="isVolMouseClick=false" @mouseout.prevent="isVolMouseClick=false;" @mousedown.prevent="isVolMouseClick=true;" @mouseup.prevent="isVolMouseClick=false;" @mousemove.prevent="slideVolMouseMove"></i>
                                </p>
                            </div>
                            <p>{{volTop}}%</p>
                        </div>
                    </div>
                    <div @click="requestFullscreen" class="large"></div>
                </div>
                <div v-if="showVideo && (mediaType == 5 || mediaType == 7 || mediaType == 8)" class="btn-container">
                    <!-- <i title="复制" @click="share" class="copy"></i> -->
                    <i v-if="(platformNum1 > 1 && videoDetail && videoDetail.id && mediaType != 7 && mediaType != 8 && selectPlatform != 'playlist')" title="同步视频" @click="getCopyList();showTBContent = true" class="TB"></i>
                    <i title="上传" v-click-outside="closeMiniUpload" :class="{upload: true, on: showMiniUpload, unset: true}">
                        <p @click="showMiniUpload = !showMiniUpload"></p>
                        <ul v-if="showMiniUpload" class="materialList">
                            <li @click="localUpload">本地上传</li>
                            <li @click="isCover=false;materialChannel='materialBin';showMaterialListBox();showMiniUpload=false">素材库</li>
                            <li @click="isCover=false;materialChannel='myMaterial';showMaterialListBox();showMiniUpload=false">我的素材</li>
                            <li v-for="(v, i) in libraryMediaList" :key="i" @click="isCover=false;materialChannel='myMaterial';showLibraryMaterialListBox(v);showMiniUpload=false">{{v.title}}</li>
                        </ul>
                    </i>
                    <i v-show="selectPlatform != 'five_star_sports_cms' && selectPlatform != 'playlist' && mediaType != 7 && mediaType != 8" title="预览" @click="reviewMedia(materialList[articleId])" class="preview"></i>
                    <i v-show="selectPlatform != 'five_star_sports_cms' && selectPlatform != 'playlist' && selectPlatform != 'bilibili' && mediaType != 7 && mediaType != 8" title="分享" @click="share" class="share"></i>
                </div>
                <div v-if="mediaType == 6" class="btn-container">
                    <i v-if="platformNum1 > 1 && videoDetail && videoDetail.id" title="同步视频" @click="getCopyList();showTBContent = true" class="TB"></i>
                    <i title="复制" @click="writeCopy" class="copy"></i>
                    <!-- <i title="上传" v-click-outside="closeMiniUpload" :class="{upload: true, on: showMiniUpload}">
                        <p @click="showMiniUpload = !showMiniUpload"></p>
                        <ul v-if="showMiniUpload" class="materialList">
                            <li @click="localUpload">本地上传</li>
                            <li @click="isCover=false;materialChannel='materialBin';showMaterialListBox()">素材库</li>
                            <li @click="isCover=false;materialChannel='myMaterial';showMaterialListBox()">我的素材</li>
                        </ul>
                    </i> -->
                    <i title="预览" @click="reviewMedia(materialList[articleId])" class="preview"></i>
                    <i v-show="selectPlatform != 'bilibili'" title="分享" @click="share" class="share"></i>
                </div>
            </div>
            <div :style="'font-size: '+rightP+'px'" class="right-container">
                <div v-if="selectPlatform != 'playlist'" class="publish-setting">
                    <div class="title">
                        <p>发布设置</p>
                        <i @click="showSetting = !showSetting" :class="{arrow: true, rotate: showSetting}"></i>
                    </div>
                    <div v-show="showSetting" class="setting">
                        <!-- <div v-show="selectPlatform != 'b_plus' && selectPlatform != 'dy'" class="row">
                            <p class="title">栏目</p>
                            <div v-click-outside="closeWater1" :class="{select: true, on: selectIndex1 != 999 && showSelect1}">
                                <p @click="showSelect1=!showSelect1">{{selectName1}}</p>
                                <i @click="showSelect1=!showSelect1" :class="{arrow: true, rotate: showSelect1}"></i>
                                <ul v-if="showSelect1" class="select-list">
                                    <li :class="{on: selectIndex1 == index}" @click="selectIndex1 = index;showSelect1 = false;" v-for="(item,index) in knews_column" :key="index"><p>{{item.title}}</p><i></i>
                                    </li>
                                </ul>
                            </div>
                        </div> -->
                        <div class="row">
                            <p :class="{title: true, red:release_config && release_config.cover && release_config.cover.need_input}">封面</p>
                            <div @mouseleave="showCover = false" :style="'background-image: url('+cover+')'" class="cover">
                                <div v-show="isChrome" class="backDrop"></div>
                                <div v-show="!isChrome" :style="'background: url('+ cover +') no-repeat;'" class="blur"></div>
                                <img class="main" :src="cover" alt="pic">
                                <div @click="showCover = !showCover" class="change">更换</div>
                                <ul v-if="showCover" class="materialList">
                                    <li v-if="selectPlatform != 'dy'" @click="coverUpload">本地上传</li>
                                    <li v-if="selectPlatform != 'dy'" @click="isCover=true;materialChannel='materialBin';showMaterialListBox()">素材库</li>
                                    <li v-if="selectPlatform != 'dy'" @click="isCover=true;materialChannel='myMaterial';showMaterialListBox()">我的素材</li>
                                    <li v-if="selectPlatform != 'dy'" v-for="(v, i) in libraryMediaList" :key="i" @click="isCover=true;materialChannel='myMaterial';showLibraryMaterialListBox(v)">{{ v.title }}</li>
                                    <li v-if="selectPlatform == 'dy'" @click="showVideoClip">视频截取</li>
                                </ul>
                            </div>
                        </div>
                        <div v-show="selectPlatform == 'bilibili'" class="row">
                            <p :class="{title: true, red: true}">分区</p>
                            <div :class="{selectDom: true, num: true}">
                                <!-- <input placeholder="请选择分区" v-model="viceTitle" /> -->
                                 <!-- <el-select @change="partitionChange" v-model="partition_id" popper-class="publishSelectDom" placeholder="请选择分区">
                                    <el-option :value="item.id" :label="item.name" :key="item.id" v-for="item in biliPartition"></el-option>
                                 </el-select> -->
                                 <el-cascader v-model="partition_id" class="publishSelectDom" popper-class="publishSelectPoper" :options="biliPartition" :props="{label: 'name', value: 'id'}" placeholder="请选择分区" :show-all-levels="false"></el-cascader>
                            </div>
                        </div>
                        <div v-show="selectPlatform == 'bilibili'" class="row">
                            <p :class="{title: true, red: true}">类型</p>
                            <ul class="bq">
                                <li @click="b_type = 0" :class="{on: b_type == 0}">
                                    <p></p>
                                    <span>自制</span>
                                </li>
                                <li @click="b_type = 1" :class="{on: b_type == 1}">
                                    <p></p>
                                    <span>转载</span>
                                </li>
                            </ul>
                        </div>
                        <div v-show="selectPlatform == 'bilibili' && b_type == 1" class="column">
                            <div class="textarea">
                                <textarea v-model="share_text" :placeholder="'转载内容请注明来源、时间、地点。\n例：转自https://wwww.xxx/yyy'" :maxlength="200"></textarea>
                                <p>{{share_text.length}}/{{200}}</p>
                            </div>
                        </div>
                        <div v-show="selectPlatform == 'five_star_sports_cms'" class="column">
                            <p class="title">副标题</p>
                            <div :class="{input: true, num: true, unred: wordNum1 > 200}">
                                <input placeholder="请输入副标题" v-model="viceTitle" />
                                <div><span>{{wordNum1}}</span>/200</div>
                            </div>
                        </div>
                        <div v-show="selectPlatform == 'five_star_sports_cms'" class="column">
                            <p class="title">来源</p>
                            <div class="input">
                                <input placeholder="请输入" v-model="source" :maxlength="release_config.from && release_config.from.length ? release_config.from.length : 50" />
                            </div>
                        </div>
                        <div v-show="selectPlatform == 'five_star_sports_cms'" class="column">
                            <p class="title">作者</p>
                            <div :class="{input: true}">
                                <input :maxlength="selectPlatform == 'five_star_sports_cms' ? 20 : 255" placeholder="请输入作者" v-model="reporter" />
                            </div>
                        </div>
                        <div v-show="selectPlatform != 'b_plus' && selectPlatform != 'dy' && selectPlatform != 'five_star_sports_cms' && selectPlatform != 'bilibili'" class="column">
                            <p class="title">分发标题</p>
                            <div :class="{input: true, num: true, unred: wordNum1 > 35}">
                                <input placeholder="请输入分发标题" v-model="viceTitle" />
                                <div><span>{{wordNum1}}</span>/35</div>
                            </div>
                        </div>
                        <div v-show="selectPlatform != 'b_plus' && selectPlatform != 'dy' && selectPlatform != 'five_star_sports_cms' && selectPlatform != 'bilibili'" class="column">
                            <p class="title">记者</p>
                            <div :class="{input: true}">
                                <input maxlength="255" placeholder="多名记者请以逗号分割" v-model="reporter" />
                            </div>
                        </div>
                        <div v-show="selectPlatform != 'b_plus' && selectPlatform != 'dy' && selectPlatform != 'five_star_sports_cms' && selectPlatform != 'bilibili'" class="column">
                            <p class="title">新闻来源</p>
                            <div class="input">
                                <input placeholder="请输入" v-model="source" maxlength="50" />
                            </div>
                        </div>
                        <div v-show="selectPlatform != 'b_plus' && selectPlatform != 'dy' && selectPlatform != 'five_star_sports_cms' && selectPlatform != 'bilibili'" class="column">
                            <p :class="{title: true, red:release_config && release_config.editor && release_config.editor.need_input == 1}">编辑</p>
                            <div class="input">
                                <input placeholder="默认填写稿件创建人" v-model="editor" maxlength="50" />
                            </div>
                        </div>
                        <div v-show="selectPlatform != 'b_plus' && selectPlatform != 'dy' && selectPlatform != 'five_star_sports_cms' && selectPlatform != 'bilibili'" class="column">
                            <p :class="{title: true, red:release_config && release_config.responsible_editor && release_config.responsible_editor.need_input == 1}">责编</p>
                            <div class="input">
                                <input :class="{disabled: release_config && release_config.responsible_editor && release_config.responsible_editor.can_edit == 0}" :disabled="release_config && release_config.responsible_editor && release_config.responsible_editor.can_edit == 0" placeholder="流程终审老师可修改" v-model="responsible_editor" maxlength="50" />
                            </div>
                        </div>

                        <div v-show="selectPlatform != 'b_plus' && selectPlatform != 'dy' && selectPlatform != 'five_star_sports_cms' && selectPlatform != 'bilibili' && isEditorShowMore" class="column">
                            <p :class="{title: true, red:release_config && release_config.video_editor && release_config.video_editor.need_input == 1}">视频编辑</p>
                            <div class="input">
                                <input placeholder="多名视频编辑请以逗号分割" v-model="video_editor" maxlength="50" />
                            </div>
                        </div>
                        <div v-show="selectPlatform != 'b_plus' && selectPlatform != 'dy' && selectPlatform != 'five_star_sports_cms' && selectPlatform != 'bilibili' && isEditorShowMore" class="column">
                            <p :class="{title: true, red:release_config && release_config.art_editor && release_config.art_editor.need_input == 1}">美术编辑</p>
                            <div class="input">
                                <input placeholder="多名美术编辑请以逗号分割" v-model="art_editor" maxlength="50" />
                            </div>
                        </div>
                        <div v-show="selectPlatform != 'b_plus' && selectPlatform != 'dy' && selectPlatform != 'five_star_sports_cms' && selectPlatform != 'bilibili' && isEditorShowMore" class="column">
                            <p :class="{title: true, red:release_config && release_config.cameraman && release_config.cameraman.need_input == 1}">摄像</p>
                            <div class="input">
                                <input placeholder="多名摄像请以逗号分割" v-model="cameraman" maxlength="50" />
                            </div>
                        </div>
                        <div v-show="selectPlatform != 'b_plus' && selectPlatform != 'dy' && selectPlatform != 'five_star_sports_cms' && selectPlatform != 'bilibili' && isEditorShowMore" class="column">
                            <p :class="{title: true, red:release_config && release_config.courier && release_config.courier.need_input == 1}">通讯员</p>
                            <div class="input">
                                <input placeholder="多名通讯员请以逗号分割" v-model="courier" maxlength="50" />
                            </div>
                        </div>

                        <div v-show="selectPlatform != 'five_star_sports_cms' && selectPlatform != 'b_plus' && selectPlatform != 'bilibili'" @click="isEditorShowMore = !isEditorShowMore" :class="{showMore: true, on: isEditorShowMore}">
                            <p>{{isEditorShowMore ? '收起' : '展开更多'}}</p>
                            <i class="arrow"></i>
                        </div>
                        <!-- <div v-show="selectPlatform != 'b_plus' && selectPlatform != 'dy' && mediaType == 5" class="row">
                            <p :class="{title:true, red:release_config && release_config.logo_key && release_config.logo_key.need_input}">水印</p>
                            <div v-click-outside="closeWater" :class="{select: true, on: selectIndex != 999 && showSelect}">
                                <p @click="showSelect=!showSelect">{{selectName}}</p>
                                <i @click="showSelect=!showSelect" :class="{arrow: true, rotate: showSelect}"></i>
                                <ul v-if="showSelect" class="select-list">
                                    <li :class="{on: selectIndex == index}" @click="selectIndex = index;showSelect = false;" v-for="(item,index) in logoList" :key="index"><p>{{item.logo_title}}</p><i></i>
                                        <img :class="{slim: item.type == 2}" :src="item.code" alt="">
                                    </li>
                                </ul>
                            </div>
                        </div> -->
                        <div v-show="(selectPlatform != 'dy' && show_info) || (selectPlatform == 'five_star_sports_cms' && mediaType == 5) || (selectPlatform == 'bilibili' && mediaType == 5)" class="column">
                            <p class="title">{{ mediaType == 5 ? selectPlatform == 'bilibili' ? '视频描述' : '视频简介' : '简介'}}</p>
                            <div class="textarea">
                                <textarea v-model="videoSummary" :maxlength="selectPlatform == 'bilibili' ? 250 : 200"></textarea>
                                <p>{{videoSummary.length}}/{{selectPlatform == 'bilibili' ? 250 : 200}}</p>
                            </div>
                        </div>

                        <div v-if="mediaType == 6 && selectPlatform != 'five_star_sports_cms'" class="row">
                            <p class="title">版权</p>
                            <div @click="changeBqIndex" :class="{switch: true,on: bqIndex == 0}">
                                <p></p>
                            </div>
                            <!-- <ul class="bq">
                                <li @click="bqIndex = 1" :class="{on: bqIndex == 1}">
                                    <p></p>
                                    <span>有</span>
                                </li>
                                <li @click="bqIndex = 0" :class="{on: bqIndex == 0}">
                                    <p></p>
                                    <span>无</span>
                                </li>
                            </ul> -->
                        </div>

                        <div v-if="mediaType == 6 && bqIndex == 1 && selectPlatform != 'five_star_sports_cms'" class="row">
                            <p class="title">可分发至第三方</p>
                            <ul class="bq">
                                <li @click="push_third_publish = 1" :class="{on: push_third_publish == 1}">
                                    <p></p>
                                    <span>是</span>
                                </li>
                                <li @click="push_third_publish = 0" :class="{on: push_third_publish == 0}">
                                    <p></p>
                                    <span>否</span>
                                </li>
                            </ul>
                        </div>
                        
                        <div v-show="selectPlatform == 'dy'" class="column">
                            <p :class="{title: true, red:release_config && release_config.info && release_config.info.need_input == 1}">视频描述</p>
                            <div class="textarea">
                                <!-- <textarea v-model="videoSummary" maxlength="200"></textarea> -->
                                <div ref="specialContent" @blur="setNum($event)" @keydown="setNum($event)" @keyup="setNum($event)" contenteditable="true" v-html="videoSummary"></div>
                                <p>{{topicNumber}}/{{release_config && release_config.info && release_config.info.length}}</p>
                            </div>
                            <p @click="addTopic" class="topic">#推荐话题</p>
                        </div>

                        <div v-show="selectPlatform == 'dy'" class="column">
                            <p class="title">记者</p>
                            <div :class="{input: true}">
                                <input maxlength="255" placeholder="多名记者请以逗号分割" v-model="reporter" />
                            </div>
                        </div>

                        <div class="column last">
                            <p v-show="(selectPlatform == 'dy' && mediaType == '5') || selectPlatform == 'five_star_sports_cms' || selectPlatform == 'bilibili'" :class="{title: true, red: selectPlatform == 'bilibili'}">{{selectPlatform == 'five_star_sports_cms' || selectPlatform == 'bilibili' ? '自定义标签' : '标签'}}</p>
                            <input v-if="(selectPlatform == 'dy' && mediaType == '5') || selectPlatform == 'five_star_sports_cms' || selectPlatform == 'bilibili'" class="dyTag" :maxlength="release_config.tags && release_config.tags.length ? release_config.tags.length : 255" placeholder="输入自定义标签，回车添加" v-model="tagInput" @keydown.enter="tagClick" type="text">
                            <div :data-selectPlatform="selectPlatform" v-else-if="selectPlatform == 'b_plus'" style="display: flex;flex-direction: row;align-items: center;">
                                <p :class="{title: true, red:release_config && release_config.tags && release_config.tags.need_input}">标签</p>
                                <div @click="setBtag" class="tagBtn">设置标签</div>
                            </div>

                            <div :data-selectPlatform="selectPlatform" v-else-if="(selectPlatform != 'b_plus' && selectPlatform != 'dy' && selectPlatform != 'five_star_sports_cms' && selectPlatform != 'bilibili' && mediaType == 5) || (mediaType == 6 && selectPlatform != 'five_star_sports_cms')" style="display: flex;flex-direction: row;align-items: center;">
                                <p :class="{title: true, red:release_config && release_config.tags && release_config.tags.need_input}">标签</p>
                                <div @click="setBtag" class="tagBtn">{{tagName ? '修改标签' : '选择标签'}}</div>
                            </div>

                            <div v-show="(selectPlatform != 'b_plus' && selectPlatform != 'dy' && selectPlatform != 'five_star_sports_cms' && mediaType == 5) || (mediaType == 6 && selectPlatform != 'five_star_sports_cms')" class="bTagList">
                                <div v-if="tagName">
                                    <div class="left">地域标签：</div>
                                    <div class="right">
                                        <p>{{tagName}}</p>
                                    </div>
                                </div>
                                <div v-if="specialTagName">
                                    <div class="left">特色标签：</div>
                                    <div class="right">
                                        <p>{{specialTagName}}</p>
                                    </div>
                                </div>
                                <div v-if="inputTags.length > 0">
                                    <div class="left">自定义标签：</div>
                                    <div class="right">
                                        <p v-for="(item,index) in inputTags" :key="index">{{item}}</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div v-show="selectPlatform == 'b_plus'" class="bTagList">
                                <div v-if="tagName">
                                    <div class="left">分类标签：</div>
                                    <div class="right">
                                        <p>{{tagName}}</p>
                                    </div>
                                </div>
                                <div v-if="subTagName.length > 0">
                                    <div class="left">特色标签：</div>
                                    <div class="right">
                                        <p v-for="(item,index) in subTagName" :key="index">{{item}}</p>
                                    </div>
                                </div>
                                <div v-if="inputTags.length > 0">
                                    <div class="left">自定义标签：</div>
                                    <div class="right">
                                        <p v-for="(item,index) in inputTags" :key="index">{{item}}</p>
                                    </div>
                                </div>
                            </div>
                            <ul v-show="(selectPlatform == 'dy' && mediaType != 6) || selectPlatform == 'five_star_sports_cms' || selectPlatform == 'bilibili'">
                                <li v-for="(item,index) in tags" :key="index">
                                    <p>{{item}}</p>
                                    <i @click="delTag(index)"></i>
                                </li>
                            </ul>

                            <div v-show="selectPlatform != 'b_plus' && selectPlatform != 'dy' && selectPlatform != 'five_star_sports_cms' && show_poster" style="justify-content: space-between;margin-top: 0.14em" class="row">
                                <p style="margin-right: 0px !important" class="title">竖版海报</p>
                                <div class="hbContainer">
                                    <div @click="showPostUpload = true" class="l">
                                        <i v-if="!postCover" class="add"></i>
                                        <div v-if="postCover" class="pic" :style="'background: url('+ postCover +') no-repeat;background-size: 100% 100%;background-position: center center;'">
                                            <div v-show="isChrome" class="backDrop"></div>
                                            <div v-show="!isChrome" :style="'background: url('+ postCover +') no-repeat;'" class="blur"></div>
                                            <img class="main" :src="postCover" alt="pic">
                                            <p v-if="postCover" class="change">更换</p>
                                        </div>
                                        <!-- <p v-if="postCover" :style="'width: 100%;height: 100%;background-image: url('+postCover+');background-repeat:  no-repeat;background-size: contain;background-position: center center;'"></p>
                                        <p v-if="postCover" class="change">更换</p> -->
                                    </div>
                                    <div class="r">
                                        <p>建议尺寸：640*1140</p>
                                        <span>此图片将被用于转发时的海报分享图</span>
                                    </div>
                                    <div v-if="postCover" @click="delPost" class="del"></div>
                                </div>
                            </div>

                            <div v-show="selectPlatform == 'five_star_sports_cms'" style="margin-top: 0.14em" class="row">
                                <p style="margin-right: 0px !important" class="title">分享头图</p>
                                <div class="hbContainer column">
                                    <div @click="showPostUpload = true" class="l">
                                        <i v-if="!postCover" class="add"></i>
                                        <div v-if="postCover" class="pic" :style="'background: url('+ postCover +') no-repeat;background-size: 100% 100%;background-position: center center;'">
                                            <div v-show="isChrome" class="backDrop"></div>
                                            <div v-show="!isChrome" :style="'background: url('+ postCover +') no-repeat;'" class="blur"></div>
                                            <img class="main" :src="postCover" alt="pic">
                                            <p v-if="postCover" class="change">更换</p>
                                        </div>
                                        <!-- <p v-if="postCover" :style="'width: 100%;height: 100%;background-image: url('+postCover+');background-repeat:  no-repeat;background-size: contain;background-position: center center;'"></p>
                                        <p v-if="postCover" class="change">更换</p> -->
                                    </div>
                                    <div class="r">
                                        <p>建议尺寸：360*200</p>
                                        <span>此图片将被用于分享图</span>
                                    </div>
                                    <div v-if="postCover" @click="delPost" class="del"></div>
                                </div>
                            </div>

                            <div v-show="selectPlatform == 'five_star_sports_cms'" class="column">
                                <p class="title">分享标题</p>
                                <div class="input">
                                    <input placeholder="请输入分享标题" v-model="share_title" :maxlength="release_config.share_title && release_config.share_title.length ? release_config.share_title.length : 50" />
                                </div>
                            </div>

                            <div v-show="selectPlatform == 'five_star_sports_cms'" class="column">
                                <p class="title">分享描述</p>
                                <div class="textarea">
                                    <textarea v-model="share_content" :maxlength="release_config.share_content && release_config.share_content.length ? release_config.share_content.length : 200"></textarea>
                                    <p>{{share_content && share_content.length || 0}}/{{release_config.share_content && release_config.share_content.length || 200}}</p>
                                </div>
                            </div>
                        </div>

                        <div v-show="selectPlatform == 'bilibili'" class="row">
                            <p :class="{title: true}">允许转载</p>
                            <ul class="bq">
                                <li @click="is_share = 1" :class="{on: is_share == 1}">
                                    <p></p>
                                    <span>是</span>
                                </li>
                                <li @click="is_share = 0" :class="{on: is_share == 0}">
                                    <p></p>
                                    <span>否</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div v-else class="publish-setting">
                    <div class="title">
                        <p>发布设置</p>
                        <i @click="showSetting = !showSetting" :class="{arrow: true, rotate: showSetting}"></i>
                    </div>
                    <div v-show="showSetting" class="setting">
                        <div class="column">
                            <p class="title">备注描述</p>
                            <div class="textarea">
                                <textarea v-model="playlistRemark" placeholder="请输入备注描述…" :maxlength="250"></textarea>
                                <p>{{playlistRemark.length}}/{{250}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="publish-material">
                    <div class="title">
                        <div class="left">
                            <p>临时素材</p>
                            <div>
                                <i></i>
                                <p></p>
                            </div>
                        </div>
                        <div class="right">
                            <p class="num">{{mediaPublishDetail.files.length}}</p>
                            <i @click="showMaterial = !showMaterial" :class="{arrow: true, rotate: showMaterial}"></i>
                        </div>
                    </div>
                    <div v-show="showMaterial" class="tab">
                        <div @click="selectType = 1" :class="{on: selectType == 1}">
                            图片 {{mediaPublishDetail.files.filter((el) => {
                                return el.type == 1
                            }).length}}
                        </div>
                        <div @click="selectType = 2" :class="{on: selectType == 2}">
                            视频 {{mediaPublishDetail.files.filter((el) => {
                                return el.type == 2
                            }).length}}
                        </div>
                        <div @click="selectType = 3" :class="{on: selectType == 3}">
                            音频 {{mediaPublishDetail.files.filter((el) => {
                                return el.type == 3
                            }).length}}
                        </div>
                    </div>
                    <mediaPublishUpload ref="mediaPublishUpload" :videoDetail="videoDetail" :has_dy_btn="articleDetail.has_dy_btn" :selectPlatform="selectPlatform" :logoList="logoList" :uploadTitle="uploadTitle" :mediaType="mediaType" v-show="showMaterial" :fileConfig="fileConfig" :asperaConfig="asperaConfig" :selectType="selectType" :list="mediaPublishDetail.files" @delAssert="delAssert" @changeVideo="changeVideo" @insertImg="insertImg" @insertVideo="insertVideo" @handleStart="handleStart" @handleIndexComplete="handleIndexComplete" @handleComplete="handleComplete" @handleProgress="handleProgress" @insertCover="insertCover"></mediaPublishUpload>
                </div>
            </div>
        </div>
        <div v-show="showNotice" class="learnMask">
            <div class="learn">
                <div class="top">
                    <i></i>
                    <img src="@assets/img/mediaPublish/line.png" alt="">
                </div>
                <div class="content">
                    <div class="left">
                        <img src="@assets/img/mediaPublish/learn.png" alt="">
                    </div>
                    <div class="right">
                        <div class="title">
                            <img src="@assets/img/mediaPublish/learnPlay.png" alt="">
                            <p>如何创建新稿件？</p>
                        </div>
                        <div class="article">
                            把鼠标移至栏目上，
                            点击“<img src="@assets/img/mediaPublish/addOn.png" alt="">”添加新稿件。
                        </div>
                        <div @click="showNotice = false" class="btn">知道了</div>
                    </div>
                </div>
            </div>
        </div>
        <mediaPublishCoverUpload ref="coverUpload" :articleId="articleId" :mediaType="mediaType" :fileConfig="fileConfig" :asperaConfig="asperaConfig" @coverComplete="coverComplete" @libraryBind="onLibraryBind"/>
        <mediaPublishMulCoverUpload ref="mulCoverUpload" :articleId="articleId" :mediaType="mediaType" :fileConfig="fileConfig" :asperaConfig="asperaConfig" @mulCoverComplete="mulCoverComplete" @mulCoverAllComplete="mulCoverAllComplete"  @libraryBind="onLibraryBind"/>
        <mediaPublishPostUpload ref="postUpload" :articleId="articleId" :mediaType="mediaType" :fileConfig="fileConfig" :asperaConfig="asperaConfig" @postComplete="postComplete"  @libraryBind="onLibraryBind"/>
        <!-- <mediaPublishPreWaterUpload ref="preWaterUpload" :articleId="articleId" :mediaType="mediaType" :fileConfig="fileConfig" :asperaConfig="asperaConfig" @postComplete="postComplete" /> -->
        <mediaPublishPreWaterUpload ref="preWaterUpload" :videoDetail="videoDetail" :has_dy_btn="articleDetail.has_dy_btn" :selectPlatform="selectPlatform" :logoList="logoList" :uploadTitle="uploadTitle" :mediaType="mediaType" v-show="showMaterial" :fileConfig="fileConfig" :asperaConfig="asperaConfig" :selectType="selectType" :list="mediaPublishDetail.files" @delAssert="delAssert" @changeVideo="changeVideo" @insertImg="insertImg" @handleStart="handleStart1" @handleIndexComplete="handleIndexComplete" @handleComplete="handleComplete" @handleProgress="handleProgress" @insertCover="insertCover"   @libraryBind="onLibraryBind"></mediaPublishPreWaterUpload>
        <mediaPublishAudioUpload ref="audioUpload" :videoDetail="videoDetail" :has_dy_btn="articleDetail.has_dy_btn" :selectPlatform="selectPlatform" :logoList="logoList" :uploadTitle="uploadTitle" :mediaType="mediaType" v-show="showMaterial" :fileConfig="fileConfig" :asperaConfig="asperaConfig" :selectType="selectType" :list="mediaPublishDetail.files" @delAssert="delAssert" @changeVideo="changeVideo" @insertImg="insertImg" @handleStart="handleStart1" @handleIndexComplete="handleIndexComplete" @handleComplete="handleComplete" @handleProgress="handleProgress" @insertCover="insertCover"   @libraryBind="onLibraryBind"></mediaPublishAudioUpload>
        <mediaPublishImgUpload ref="imgUpload" :videoDetail="videoDetail" :has_dy_btn="articleDetail.has_dy_btn" :selectPlatform="selectPlatform" :logoList="logoList" :uploadTitle="uploadTitle" :mediaType="mediaType" v-show="showMaterial" :fileConfig="fileConfig" :asperaConfig="asperaConfig" :selectType="selectType" :list="mediaPublishDetail.files" @delAssert="delAssert" @changeVideo="changeVideo" @insertImg="insertImg" @handleStart="handleStart1" @handleIndexComplete="handleIndexComplete" @handleComplete="handleComplete" @handleProgress="handleProgress" @insertCover="insertCover"  @libraryBind="onLibraryBind"></mediaPublishImgUpload>
        <successTip ref="successTip" />
        <div v-if="showLarge" class="large-container">
            <video :style="'width:'+9.6*fontSize+'px;height:'+5.4 * fontSize+'px'" controls :src="videoDetail.content && videoDetail.content.url"></video>
            <div @click="showLarge = false" class="bg"></div>
        </div>
        <div class="showSave" v-show="showAutoSave">
            <img src="@assets/img/common/right.svg" alt="right">
            <span>已保存至草稿箱</span>
        </div>
        <div v-show="showWriteUpload" class="insertMedia-container">
            <div @click="showWriteUpload = false;topPic = false" class="bg"></div>
            <div class="media-container" :class="[libraryMediaList && libraryMediaList.length > 0 ? 'hasLibrary' : '']">
                <p class="title">{{uploadTitle}}</p>
                <span v-if="uploadTitle == '上传图片'" class="notice"><i></i>上传图片时，请确认图片版权！</span>
                <i @click="showWriteUpload = false;topPic = false" class="close"></i>
                <ul class="upload-f-list">
                    <li @click="localUpload">
                        <i></i>
                        <p>本地上传</p>
                    </li>
                    <li @click="isCover=false;materialChannel='materialBin';showMaterialListBox()">
                        <i></i>
                        <p>素材库</p>
                    </li>
                    <li @click="isCover=false;materialChannel='myMaterial';showMaterialListBox()">
                        <i></i>
                        <p>我的素材</p>
                    </li>
                    <li v-for="(v, i) in libraryMediaList" :key="i" @click="isCover=false;materialChannel='myMaterial';showLibraryMaterialListBox(v)">
                        <i></i>
                        <p>{{v.title}}</p>
                    </li>
                </ul>
            </div>
        </div>
        <div v-show="showPostUpload" class="insertMedia-container">
            <div @click="showPostUpload = false;" class="bg"></div>
            <div class="media-container" :class="[libraryMediaList && libraryMediaList.length > 0 ? 'hasLibrary' : '']">
                <p class="title">{{this.selectPlatform == 'five_star_sports_cms' ? '分享头图' : '上传海报图'}}</p>
                <span class="notice on"><i></i>上传图片时，请确认图片版权！</span>
                <i @click="showPostUpload = false;" class="close"></i>
                <ul class="upload-f-list">
                    <li @click="postUpload">
                        <i></i>
                        <p>本地上传</p>
                    </li>
                    <li @click="materialChannel='materialBin';showMaterialListPostBox()">
                        <i></i>
                        <p>素材库</p>
                    </li>
                    <li @click="materialChannel='myMaterial';showMaterialListPostBox()">
                        <i></i>
                        <p>我的素材</p>
                    </li>
                    <li v-for="(v, i) in libraryMediaList" :key="i" @click="materialChannel='myMaterial';showLibraryMaterialListPostBox(v)">
                        <i></i>
                        <p>{{v.title}}</p>
                    </li>
                </ul>
            </div>
        </div>
        <div v-show="showTipsContent" class="tips-container">
            <div class="bg"></div>
            <div class="tips-content">
                <p class="title">温馨提示</p>
                <div v-if="noKnewsArr" class="noKnews">此次稿件将直接发布至<span>{{noKnewsArr}}</span></div>
                <div v-if="knewsArr" class="Knews">此次稿件将进入审核，审核成功后发布至<span>{{knewsArr}}</span>，是否继续？</div>
                <div class="btns">
                    <p @click="showTipsContent = false;releaseArticle();" class="green">确定</p>
                    <p @click="showTipsContent = false;">取消</p>
                </div>
            </div>
        </div>
        <div v-show="showDescribeContent" class="describe-container">
            <div class="bg"></div>
            <div class="describe-content">
                <p class="title">图片描述</p>
                <i @click="showDescribeContent = false;" class="close"></i>
                <div class="content">
                    <textarea v-model="describeValue" placeholder="在这里输入图片描述"></textarea>
                    <!-- <span>{{describeValue.length}}/24</span> -->
                </div>
                <div class="btns">
                    <div @click="confirmDescribe" class="btn g">确定</div>
                    <div @click="describeValue = '';showDescribeContent = false" class="btn">取消</div>
                </div>
            </div>
        </div>
        <div v-show="showTBContent" class="TB-container">
            <div class="bg"></div>
            <div class="TB-content">
                <p class="title">当前视频可同步至</p>
                <i @click="showTBContent = false;" class="close"></i>
                <div class="content">
                    <ul>
                        <li v-for="item in copyList" :key="item.title">
                            <div class="t"><span>{{ item.title }}</span><div v-if="item.info"><p>文件大小需 < <span>{{ item.info }}</span></p></div></div>
                            <ul>
                                <li v-for="items in item && item.list" :key="items.id" :class="{article: items.type == '6',video: items.type == '5'}"><i></i><p>{{ items.title }}</p></li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div class="btns">
                    <div @click="tbVideo" class="btn g">确定</div>
                    <div @click="showTBContent = false" class="btn">取消</div>
                </div>
            </div>
        </div>
        <div v-show="showPreTipsContent" class="tips-container">
            <div class="bg"></div>
            <div class="tips-content">
                <p class="title">温馨提示</p>
                <div class="noKnews">{{ errMsg }}</div>
                <div class="btns">
                    <p @click="showPreTipsContent = false" class="green">知道了</p>
                </div>
            </div>
        </div>
        <input style="position: absolute;top: -1000000px;" ref="d" />
        <div class="setImgContainer" style="position: absolute;top: -1000000px;"></div>
        <div class="setImgContainer1" style="position: absolute;top: -1000000px;"></div>
        <div ref="unifiedContentLibraryCustomRef"></div>
    </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";
import { apis } from "@common/config";
import common from "@common/common";
import mediaPublishUpload from "./mediaPublishUpload.vue";
import mediaPublishCoverUpload from "./mediaPublishCoverUpload.vue";
import mediaPublishMulCoverUpload from "./mediaPublishMulCoverUpload.vue";
import mediaPublishPostUpload from "./mediaPublishPostUpload.vue";
import mediaPublishPreWaterUpload from "./mediaPublishPreWaterUpload.vue";
import mediaPublishAudioUpload from "./mediaPublishAudioUpload.vue";
import mediaPublishImgUpload from "./mediaPublishImgUpload.vue";
import successTip from "@components/successTip";
import vClickOutside from "v-click-outside";
import notice from "@components/notice";
import { Icon, Cascader } from "element-ui";
import 'element-ui/lib/theme-chalk/cascader.css';
import { loadMicroApp } from "qiankun";

export default {
    directives: {
        clickOutside: vClickOutside.directive
    },
    data() {
        return {
            newUploadFileId: '',
            disabledSavedBtn: false,
            editor: '',
            responsible_editor: '',
            video_editor: '',
            art_editor: '',
            cameraman: '',
            courier: '',
            isEditorShowMore: false,
            firstClick: true,
            isNowPage: true,
            task_id: 0,
            is_last_audit: 0,
            mulCoverInterval: null,
            auto_available: 0,
            copyList: [],
            platformNum1: 0,
            platformNum: 0,
            saveDescribeId: '',
            describeValue: '',
            showTBContent: false,
            showDescribeContent: false,
            errMsg: '',
            showPreTipsContent: false,
            show_info: false,
            show_poster: false,
            show_reporter: false,
            centerTxtSve: '',
            postCover: '',
            showPostUpload: false,
            rightP: 100,
            normalContent2: '',
            needWater: false,
            newIcon: require('../../assets/img/mediaPublish/new.png'),
            downIcon: require('../../assets/img/mediaPublish/down.png'),
            viceTitle: '',
            autoLockInterval: null,
            showTipsContent: false,
            writeTagList: {},
            bqIndex: 1,
            push_third_publish: 1,
            uploadTitle: '上传视频',
            showWriteVideo: false,
            showWriteSelect: false,
            showWriteUpload: false,
            normalConfig: {
                retainOnlyLabelPasted: true,
                autoHeightEnabled: true,
                initialFrameHeight: 640,
                initialFrameWidth: "100%",
                enableAutoSave: false,
                autoFloatEnabled: true,
                imageScaleEnabled: false,
                saveInterval: 24 * 60 * 60 * 1000,
                topOffset: 52,
                autotypeset: {
                mergeEmptyline: true, //合并空行
                removeClass: true, //去掉冗余的class
                removeEmptyline: false, //去掉空行 todo
                // textAlign: "left", //段落的排版方式，可以是 left,right,center,justify 去掉这个属性表示不执行排版
                // imageBlockLine: "center", //图片的浮动方式，独占一行剧中,左右浮动，默认: center,left,right,none 去掉这个属性表示不执行排版
                pasteFilter: false, //根据规则过滤没事粘贴进来的内容
                clearFontSize: false, //去掉所有的内嵌字号，使用编辑器默认的字号
                clearFontFamily: false, //去掉所有的内嵌字体，使用编辑器默认的字体
                removeEmptyNode: true, // 去掉空节点
                //可以去掉的标签
                removeTagNames: { br: 1, hr: 1 },
                indent: false, // 行首缩进
                indentValue: "4px", //行首缩进的大小
                bdc2sb: false,
                tobdc: false
                },
                toolbars: [
                [
                    "undo",
                    "redo",
                    "|",
                    "fontsize",
                    "|",
                    "blockquote",
                    "horizontal",
                    "|",
                    "removeformat",
                    "formatmatch",
                    "|",
                    "link",
                    "unlink",
                    "bold",
                    "italic",
                    "underline",
                    "forecolor",
                    "backcolor",
                    "|",
                    "indent",
                    "justifyleft",
                    "justifycenter",
                    "justifyright",
                    "justifyjustify",
                    "|",
                    "rowspacingtop",
                    "rowspacingbottom",
                    "lineheight",
                    "fontborder",
                    "customImg",
                    "|"
                    // "|",
                    // "imagenone",
                    // "imageleft",
                    // "imageright",
                    // "imagecenter"
                ]
                ]
            },
            normalInstance: null,
            normalWindow: {},
            normalContent: "",
            mediaType: 5,
            showAutoSave: false,
            tagName: '',
            subTagName: [],
            inputTags: [],
            selectPlatform: '',
            selectColumn: '',
            showMiniUpload: false,
            fileId: 0,
            articleDetail: {},
            source: '',
            reporter: '',
            uploadInfo: {
                title: '',
                progress: 0
            },
            articleId: null,
            release_config: {

            },
            tagInput: '',
            rateSpeed: 1,
            currentTime: '00:00',
            duration: '00:00',
            defaultCover: require("@assets/img/common/default.png"),
            cover: require("@assets/img/common/default.png"),
            tags: [],
            videoDetail: {},
            videoSummary: '',
            selectType: 1,
            materialChannel: '',
            id: '',
            mediaPublishDetail: {
                files: []
            },
            logoList: [],
            knews_column: [],
            materialList: {},
            selectIndex: 999,
            selectIndex1: 999,
            selectName: '请选择',
            selectName1: '请选择',
            topicNumber: 0,
            topicNum: 1,
            canAddTopic: true,
            showLarge: false,
            isSubmitUpload: false,
            firstShow: true,
            isCover: false,
            showSetting: false,
            showMaterial: false,
            showRate: false,
            showPlayBtn: true,
            showVideo: false,
            showCover: false,
            showSelect: false,
            showSelect1: false,
            showEmpty: true,
            showNotice: false,
            showUpload: false,
            showUploadError: false,
            showProgress: false,
            showVoice: false,
            leftScroll: true,
            titleInput: '',
            originInput: '',
            saveTitleInput: '',
            wordNum: 0,
            wordNum1: 0,
            editTitle: false,
            fontSizeWrite: 100,
            fontSize: 100,
            isMouseClick: false,
            isPlay: false,
            nowTime: "00:00",
            endTime: "00:00",
            percent: 0,
            audioPercent: "0%",
            volPercent: "50%",
            volTop: 50,
            isVolMouseClick: false,
            platformList: [
                {
                    name: '看看新闻-国内视频最长123123',
                    list: []
                }
            ],
            timeInterval: null,
            autoSaveInterval: null,
            fileConfig: {},
            asperaConfig: {},
            defaultImg: require("@assets/img/common/default.png"),
            specialTagName: '',
            topPic: false,
            top_video_cover: '',
            knewsArr: '',
            noKnewsArr: '',
            errMessage: '',
            firstLoad: true,
            cover_tsp: 0,
            autoClickInterval: null,
            isChrome: true,
            share_title: '',
            share_content: '',
            partition_id: '',
            partition_name: '',
            b_type: 0,
            is_share: 1,
            share_text: '',
            biliPartition: [],
            playlistRemark: '',
            // 统一内容按钮
            libraryMediaList: [],
            libraryDirInstance: null, // 统一内容库目录选择实例，子应用会覆盖此方法
            libraryDirInfo: null, // 统一内容库目录选择信息
        }
    },
    components:{mediaPublishUpload, mediaPublishCoverUpload, mediaPublishMulCoverUpload, successTip, VueUeditorWrap, notice, mediaPublishPostUpload, mediaPublishPreWaterUpload, 'el-cascader': Cascader, mediaPublishAudioUpload, mediaPublishImgUpload},
    watch: {
        partition_id(to) {
            let partition_id = ''
            if(to && to.length == 2){
                partition_id = to[1]
            }
            this.materialList[this.articleId].partition_id = partition_id
        },
        partition_name(to) {
            this.materialList[this.articleId].partition_name = this.partition_name
        },
        b_type(to) {
            this.materialList[this.articleId].b_type = this.b_type
        },
        is_share(to) {
            this.materialList[this.articleId].is_share = this.is_share
        },
        share_text(to) {
            this.materialList[this.articleId].share_text = this.share_text
        },
        playlistRemark(to) {
            this.materialList[this.articleId].playlistRemark = this.playlistRemark
        },
        editor(to) {
            this.materialList[this.articleId].editor = this.editor
        },
        responsible_editor(to) {
            this.materialList[this.articleId].responsible_editor = this.responsible_editor
        },
        video_editor(to) {
            this.materialList[this.articleId].video_editor = this.video_editor
        },
        art_editor(to) {
            this.materialList[this.articleId].art_editor = this.art_editor
        },
        cameraman(to) {
            this.materialList[this.articleId].cameraman = this.cameraman
        },
        courier(to) {
            this.materialList[this.articleId].courier = this.courier
        },
        cover_tsp(to) {
            this.materialList[this.articleId].cover_tsp = this.cover_tsp
        },
        viceTitle(to) {
            this.materialList[this.articleId].second_title = this.viceTitle
            this.watchViceTitle();
        },
        isSubmitUpload(to) {
            if(to){
                let columnArr = []
                this.mediaPublishDetail.platforms.forEach(el => {
                    columnArr.push(el.p_title+'-'+el.c_title)
                })
                columnArr = columnArr.join(',')
                let config = {
                    title: '视频上传完成将自动送审，是否继续？',
                    content: '此次内容将发布至'+columnArr+'',
                    btn1: '确定',
                    btn2: '取消',
                    showIcon: true
                }

                this.$MediaPlatformNotify(config).then(e => {
                    if(!e) {
                        this.isSubmitUpload = false;
                    }
                })
            }
        },
        titleInput() {
            if(this.articleId){
                this.materialList[this.articleId].title = this.titleInput
                this.watchTitle();
            }
        },
        selectIndex(to) {
            if(to != 999){
                this.materialList[this.articleId].logo_key = this.logoList[to].logo_key
                this.selectName = this.logoList[to].logo_title;

                this.$nextTick(() => {
                    this.handleSaved()
                })
                    
            }else{
                this.materialList[this.articleId].logo_key = ''
            }
        },
        selectIndex1(to) {
            if(to != 999){
                this.materialList[this.articleId].column_id = this.knews_column[to].key
                this.selectName1 = this.knews_column[to].title;
                // console.log(this.materialList[this.articleId].logo_key)
            }
        },
        videoSummary(to) {
            this.materialList[this.articleId].info = this.videoSummary
        },
        tags(to) {
            this.materialList[this.articleId].tags = this.tags.join(',')
        },
        source(to) {
            this.materialList[this.articleId].from = this.source
        },
        reporter(to) {
            this.materialList[this.articleId].reporter = this.reporter
        },
        normalContent(to) {
            this.materialList[this.articleId].content = this.normalContent
        },
        selectType() {
            this.mediaPublishDetail.files.forEach(el => {
                el.showBtn = false;
            })
        },
        volTop(to) {
            if(this.mediaType == 8){
                this.$refs.audio.volume  = to/100
            }else{
                this.$refs.video.volume  = to/100
            }
        },
        bqIndex(to) {
            this.materialList[this.articleId].has_copyright = this.bqIndex
        },
        push_third_publish(to) {
            this.materialList[this.articleId].push_third_publish = this.push_third_publish
        },
        top_video_cover(to) {
            this.materialList[this.articleId].top_video_cover = this.top_video_cover
        },
        postCover(){
            this.materialList[this.articleId].share_cover = this.postCover
        },
        share_title(){
            this.materialList[this.articleId].share_title = this.share_title
        },
        share_content(){
            this.materialList[this.articleId].share_content = this.share_content
        }
    },
    methods: { 
        partitionChange(e) {
            this.biliPartition.forEach(el => {
                if(el.id == e){
                    this.partition_name = el.name
                }
            })
        },
        getBiliPartition(column_key) {
            return new Promise((resolve, reject) => {
                let info = {
                    column_key: column_key
                }
                common
                .myFetch(apis.getBiliPartition, info)
                .then(r => {
                    if (r) {
                        this.biliPartition = r.data
                        this.$nextTick(() => {
                            resolve(true)
                        })
                    }
                });
            })
        },
        changeMediaWater() {
            console.log(this.videoDetail)
            let videoInfo = ''
            if(this.videoDetail.content && this.videoDetail.content.resolution){
                let arr = this.videoDetail.content.resolution.split('x')
                if(arr[0] > arr[1]){
                    videoInfo = '16:9'
                }else{
                    videoInfo = '9:16'
                }
            }else if(this.materialList[this.articleId].logo_key){
                this.logoList.forEach(el => {
                    if(el.logo_key == this.materialList[this.articleId].logo_key){
                        videoInfo = el.display_ratio
                    }
                })
            }

            this.$MediaPlatformWater(this.logoList,videoInfo,this.selectPlatform).then(res => {
                console.log(res)
                if(res != 99999){
                    let info = {
                        content_id: this.$route.query.d,
                        file_id: this.videoDetail.id,
                        logo_key: this.logoList[res].logo_key
                    }
                    common
                    .myFetch(apis.knewstranscode, info)
                    .then(r => {
                        if (r) {
                            this.materialList[this.articleId].file_id = r.id
                            this.selectIndex = res
                            this.getPlatform(r.id)
                            
                        }
                    });
                    // console.log(logo_key,logo_title, this.videoDetail)
                }
            })
        },
        requestFullscreen() {
            const docElm = this.$refs.video
            if (docElm.requestFullscreen) {
                docElm.requestFullscreen()
            } else if (docElm.msRequestFullscreen) {
                docElm.msRequestFullscreen()
            } else if (docElm.mozRequestFullScreen) {
                docElm.mozRequestFullScreen()
            } else if (docElm.webkitRequestFullScreen) {
                docElm.webkitRequestFullScreen()
            }
        },
        exitFullScreen() {
            if (document.exitFullscreen) {
                document.exitFullscreen()
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen()
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen()
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen()
            }
        },
        delPost() {
            let info = {
                id: this.articleId
            }

            common
            .myFetch(apis.delposter, info)
            .then(r => {
                if (r) {
                    this.postCover = ''
                }
            });
        },
        changeBqIndex() {
            if(this.bqIndex == 1){
                this.bqIndex = 0
            }else{
                this.bqIndex = 1
            }
        },
        getCopyList() {
            this.handleAutoSave()
            let info = {
                main_id: this.$route.query.d,
                cur_id: this.articleId
            }

            common
            .myFetch(apis.copylist, info)
            .then(r => {
                if (r) {
                    console.log(r)
                    this.copyList = r
                }
            });
        },
        tbVideo() {
            let info = {
                main_id: this.$route.query.d,
                cur_id: this.articleId,
                file_id: this.materialList[this.articleId].file_id,
                subject_type: this.mediaType
            }

            common
            .myFetch(apis.copyto, info)
            .then(r => {
                if (r) {
                    console.log(r)
                    let su = 0
                    let fa = 0
                    let arr = []
                    r.forEach(el => {
                        if(el.code == '10000'){
                            // su ++
                            let str = '<span>已同步至 <i>'+el.title+'</i></span>'
                            arr.push(str)
                        }else{
                            // fa ++
                            let str = '<span><i>'+el.title+'</i>同步失败!</span>'
                            arr.push(str)
                        }
                    })
                    if(arr.length > 0){
                        this.$toastHtml(arr.join(''))
                    }
                    this.showTBContent = false;
                    // this.copyList = r
                }
            });
        },
        confirmDescribe() {
            let dom = this.normalWindow.document.querySelectorAll('.centerTxt[data-fileid="'+this.saveDescribeId+'"]')[0]
            let dom1 = this.normalWindow.document.querySelectorAll('.imgContainer[data-fileid="'+this.saveDescribeId+'"] img')[0]
            // console.log(dom1.getBoundingClientRect().width)
            dom.style.maxWidth = dom1.getBoundingClientRect().width + 'px'
            dom.innerText = this.describeValue
            dom.setAttribute('title',this.describeValue)
            dom1.setAttribute('title',this.describeValue)
            this.showDescribeContent = false;
            this.describeValue = ''
        },
        insertCover(config) {
            console.log(config)
            this.$MediaPlatformPhoto(config).then(e => {
                if(e) {
                    let info = {
                        id: this.articleId,
                        file_id: e.list[0].file_id,
                        delete_file_id: ''
                    }
                    common
                    .myFetch(apis.newMediaPlatformSetCover, info)
                    .then(r => {
                        if (r) {
                            this.cover = e.list[0].cover
                            this.getPlatform()
                            console.log(r)
                        }
                    });
                }
            })
        },
        closeShowRate() {
            this.showRate = false
        },
        closeshowVoice() {
            this.showVoice = false
        },
        hideWriteSelect() {
            // console.log(this.showWriteSelect)
            // this.showWriteSelect = false
        },
        setVideoContent() {
            this.$nextTick(() => {
                let ueditorDocument = this.normalWindow.document;
                if(ueditorDocument){
                    let uploadVideo = ueditorDocument.querySelectorAll('.uploadVideo.mask');
                    if(uploadVideo && uploadVideo.length > 0){
                        uploadVideo.forEach(el => {
                            if(el){
                                let codeProgress = el.querySelector('.codeProgress')
                                let progress = el.querySelector('.progress')
                                if(codeProgress){
                                    let id = el.getAttribute('data-fileId')
                                    if(this.mediaPublishDetail.files && this.mediaPublishDetail.files.length > 0){
                                        this.mediaPublishDetail.files.forEach(els => {
                                            if(els && els.type == 2 && els.transcode_finish && els.id == id){
                                                codeProgress.remove()
                                                el.classList.remove('mask')
                                                el.setAttribute('contenteditable', true)
                                                el.innerHTML += `<video controls controlsList="nodownload" contextmenu="none" src="${els.url}"></video>`
                                            }
                                        })
                                    }
                                }else if(progress){
                                    el.remove()
                                }
                            }
                        })
                    }
                }
            })
        },
        setImgContent(content) {
            
            this.$nextTick(() => {
                let ueditorDocument = this.normalWindow.document;
                if(ueditorDocument){
                    let imgContainer = ueditorDocument.getElementsByClassName('imgContainer');
                    if(imgContainer.length > 0){
                        for (let index = 0; index < imgContainer.length; index++) {
                            const element = imgContainer[index];
                            let fileid = element.getAttribute('data-fileid')
                            let imgDom = element.getElementsByClassName('relative')[0]
                            if(imgDom){
                                let hasTxt = element.getElementsByClassName('centerTxt')[0]
                                if(hasTxt){
                                    let btnHtml = `<span class="imgBtnsEdit" data-fileid="${fileid}"><i>1</i>编辑</span><span class="imgBtnsAdd" data-fileid="${fileid}"><i>1</i>加水印</span><span class="imgDescribe" data-fileid="${fileid}"><i>1</i>图片描述</span>`
                                    imgDom.innerHTML += btnHtml
                                    let txtDom = element.getElementsByClassName('centerTxt')[0]
                                    txtDom.setAttribute('contentEditable',false)
                                    if(element.querySelectorAll('img')[0].title){
                                        txtDom.innerText = element.querySelectorAll('img')[0].title
                                    }
                                }else{
                                    let btnHtml = `<span class="imgBtnsEdit" data-fileid="${fileid}"><i>1</i>编辑</span><span class="imgBtnsAdd" data-fileid="${fileid}"><i>1</i>加水印</span><span class="imgDescribe" data-fileid="${fileid}"><i>1</i>图片描述</span><span data-fileid="${fileid}" class="centerTxt" style="max-width: 512px"></span>`
                                    imgDom.innerHTML += btnHtml
                                    let txtDom = element.getElementsByClassName('centerTxt')[0]
                                    txtDom.setAttribute('contentEditable',false)
                                    if(element.querySelectorAll('img')[0].title){
                                        txtDom.innerText = element.querySelectorAll('img')[0].title
                                    }
                                }
                            }else{
                                let imgDom = document.createElement('span')
                                imgDom.classList.add('img')
                                imgDom.setAttribute('contentEditable',false)
                                let img = element.getElementsByTagName('img')[0]
                                let btnHtml = `<span class="imgBtnsEdit" data-fileid="${fileid}"><i>1</i>编辑</span><span class="imgBtnsAdd" data-fileid="${fileid}"><i>1</i>加水印</span><span class="imgDescribe" data-fileid="${fileid}"><i>1</i>图片描述</span><span data-fileid="${fileid}" class="centerTxt" style="max-width: 512px"></span>`
                                let relativeDom = document.createElement('span')
                                relativeDom.classList.add('relative')
                                relativeDom.setAttribute('contentEditable',false)
                                relativeDom.appendChild(img)
                                relativeDom.innerHTML += btnHtml
                                imgDom.appendChild(relativeDom)
                                element.appendChild(imgDom)
                                let txtDom = element.getElementsByClassName('centerTxt')[0]
                                txtDom.setAttribute('contentEditable',false)
                                if(element.querySelectorAll('img')[0].title){
                                    txtDom.innerText = element.querySelectorAll('img')[0].title
                                }
                            }
                            // console.log(element)
                            
                            // let dom = `<span class="relative">${imgDom.innerHTML}</span>`
                            // imgDom.innerHTML += btnHtml
                            // imgDom.innerHTML = dom
                            
                            
                            
                        }
                    }
                }
                // console.log(imgContainer.length)
            })
            

            
            // let fragment = ueditorDocument.createElement("p");
            // fragment.innerHTML = this.normalContent;
            // let imgContainer = fragment.getElementsByClassName('imgContainer');
            // if(imgContainer.length > 0){
            //     for (let index = 0; index < imgContainer.length; index++) {
            //         const element = imgContainer[index];
            //         let fileid = element.getAttribute('data-fileid')
            //         // console.log(element)
            //         let btnHtml = `<span class="imgBtnsEdit" data-fileid="${fileid}"><i>1</i>编辑</span><span class="imgBtnsAdd" data-fileid="${fileid}"><i>1</i>加水印</span>`
            //         element.innerHTML += btnHtml
            //     }
            //     console.log(fragment.innerHTML)

            //     // this.normalInstance.execCommand(
            //     //     "inserthtml",
            //     //     fragment.innerHTML
            //     //     // await this.handleGrabWXimg(clipboardRealData)
            //     // );
            // }
        },
        showTips() {
            let info = {
                id: this.id
            }

            common
            .myFetch(apis.newMediaCheckProcess, info)
            .then(r => {
                if (r) {
                    console.log(r)
                    this.knewsArr = r.verify
                    this.noKnewsArr = r.release
                    this.showTipsContent = true;
                }
            });
        },
        async copyJSON(text) {
            let target = document.createElement('input') //创建input节点
            target.style.position = 'absolute'
            target.style.top = '-1000000px'
            target.value = text // 给input的value赋值
            document.body.appendChild(target) // 向页面插入input节点
            target.select() // 选中input
            await document.execCommand('Copy') // 执行浏览器复制命令
            console.log('复制成功')
            this.$toast('复制成功')
        },
        copyRichText(htmlContent){
            const blob = new Blob([htmlContent], { type: 'text/html' });
            const clipboardItem = new ClipboardItem({ [blob.type]: blob });

            navigator.clipboard.write([clipboardItem])
            .then(() => {
                this.$toast('复制成功')
            })
            .catch(err => {
                console.error('Failed to copy rich text: ', err);
            });
        },
        writeCopy() {
            if(this.selectPlatform == 'five_star_sports_cms'){
                // this.copyJSON(this.normalWindow.document.querySelector('body').innerHTML)

                // this.normalInstance.execCommand('selectall');
                // this.normalInstance.execCommand('copy');
                // this.$refs.d.focus();                
                // this.$toast('复制成功')
                this.copyRichText(this.normalWindow.document.querySelector('body').innerHTML)
            }else{
                this.normalInstance.execCommand('selectall');
                this.normalInstance.execCommand('copy');
                this.$refs.d.focus();
                this.$toast('复制成功')
            }
            // this.copyJSON(this.normalInstance.getContent())
        },
        delWriteVideo(videoDetail) {
            this.materialList[this.articleId].file_id = 0
            this.showWriteVideo = false;
            this.showProgress = false;
            if(this.mediaType == 5){
                this.showVideo = false;
                this.showUpload = true;
            }
            
            let info = {
                idstring: videoDetail.idstring,
                subject_id: this.articleId,
                subject_type: 5
            }

            common
            .myFetch(apis.File_delete, info)
            .then(r => {
                console.log(r)
                if (r) {
                    this.handleAutoSave()
                }
            });
        
        },
        showWriteWater() {
            // console.log(999,this.showWriteSelect)
            let showWriteSelect = this.showWriteSelect
            showWriteSelect = !showWriteSelect
            this.showWriteSelect = showWriteSelect
            // console.log(showWriteSelect,this.showWriteSelect,this.logoList)
            // this.showWriteSelect = !this.showWriteSelect;
            // this.$forceUpdate()
        },
        customUpload() {
            let that = this;
            this.$refs.ueditor.registerButton({
                name: 'customImg',
                icon: '/UEditor/themes/default/images/pic.png',
                tip: '点击上传图片'
            })

            if(this.selectPlatform == 'five_star_sports_cms'){
                this.$refs.ueditor.registerButton({
                    name: 'customVideo',
                    icon: '/UEditor/themes/default/images/pic.png',
                    tip: '点击上传视频'
                })
            }
        },
        getConfig() {
            return common.getFileConfigs().then(r => {
                if(r){
                    this.fileConfig = r;
                    return true;
                }
            });
        },
        getAsperaConfig() {
            // 获取aspera上传配置
            return common.myFetch(apis.File_Aspera).then(r => {
                if (r) {
                    this.asperaConfig = r;
                    return true;
                }
            });
        },
        loadConfig() {
            return Promise.all([this.getConfig(), this.getAsperaConfig()]);
        },
        loadNewConfig() {
            return new Promise((resolve,reject) => {
                common.myFetch(apis.newUploadConfig).then(r => {
                    console.log('getNewConfig',r)
                    if(r) {
                        resolve(r)
                    }else{
                        reject('上传组件加载失败')
                    }
                })
            })
        },
        scrollEvent(e) {
            let _this = this

            let read = document.getElementsByClassName('write-container')[0]
            
            if(read.scrollTop <= 100) {
                let moreDiv = document.querySelectorAll('.edui-editor.edui-default > div')[0]
                // console.log(moreDiv.style.height)
                if(moreDiv.style.height){
                    moreDiv.remove()
                }
                // moreDiv.remove()
                let edui1_toolbarbox = document.getElementsByClassName('edui-editor-toolbarbox')[0]
                edui1_toolbarbox.style.position = 'unset';
                edui1_toolbarbox.style.top = 0;
            }else{
                let eduiEditor = document.getElementsByClassName('edui-editor')[0];
                let edui1_toolbarbox = document.getElementsByClassName('edui-editor-toolbarbox')[0]
                let width = eduiEditor.getBoundingClientRect().width;
                edui1_toolbarbox.style.width = width + 'px'
                edui1_toolbarbox.style.position = 'fixed';
                edui1_toolbarbox.style.top = '52px';
                edui1_toolbarbox.style.zIndex = 999999999;
                edui1_toolbarbox.style.background = '#FFF';
            }
            // console.log(read.scrollTop)
        },
        changeTxtSrc(fileid, r) {
            let setImgContainer = document.getElementsByClassName('setImgContainer1')[0]
            setImgContainer.innerHTML = this.normalInstance.getContent()
            let dom = setImgContainer.querySelectorAll('.imgContainer[data-fileid="'+fileid+'"]')
            for (let index = 0; index < dom.length; index++) {
                const element = dom[index];
                element.setAttribute('data-value', r)
            }
        },
        changeImgSrc(fileid, r) {
            let setImgContainer = document.getElementsByClassName('setImgContainer')[0]
            setImgContainer.innerHTML = this.normalInstance.getContent()
            let dom = setImgContainer.querySelectorAll('.imgBtnsEdit[data-fileid="'+fileid+'"]')
            let dom1 = setImgContainer.querySelectorAll('.imgBtnsAdd[data-fileid="'+fileid+'"]')
            let dom2 = setImgContainer.querySelectorAll('.imgContainer[data-fileid="'+fileid+'"]')
            let dom3 = setImgContainer.querySelectorAll('.centerTxt[data-fileid="'+fileid+'"]')
            let dom4 = setImgContainer.querySelectorAll('.imgDescribe[data-fileid="'+fileid+'"]')
            // console.log(dom)
            for (let index = 0; index < dom.length; index++) {
                const element = dom[index];
                console.log(element.parentNode.firstChild,element.parentNode.firstChild.src)
                element.parentNode.firstChild.setAttribute('src', r.url)
                element.setAttribute('data-fileid', r.id)
            }
            for (let index = 0; index < dom1.length; index++) {
                const element = dom1[index];
                element.setAttribute('data-fileid', r.id)
            }
            for (let index = 0; index < dom2.length; index++) {
                const element = dom2[index];
                element.setAttribute('data-fileid', r.id)
            }
            for (let index = 0; index < dom3.length; index++) {
                const element = dom3[index];
                element.setAttribute('data-fileid', r.id)
            }
            for (let index = 0; index < dom4.length; index++) {
                const element = dom4[index];
                element.setAttribute('data-fileid', r.id)
            }
            this.normalContent = ''
            this.normalInstance.execCommand(
                "inserthtml",
                setImgContainer.innerHTML
                // await this.handleGrabWXimg(clipboardRealData)
            );
            this.normalContent = setImgContainer.innerHTML
        },
        filterVideoAndAudio(html) {
            let p = this.normalWindow.document.createElement("p");
            p.innerHTML = html;
            let videos = p.querySelectorAll("video");
            let audios = p.querySelectorAll("audio");
            videos.forEach(e => {
                e.parentNode.removeChild(e);
                e = null;
            });
            audios.forEach(e => {
                e.parentNode.removeChild(e);
                e = null;
            });
            return p.innerHTML;
        },
        call() {

        },
        async handleGrabWXimg(html) {
            console.log("handleGrabWXimg html", html);
            let ueditorDocument = this.normalWindow.document;
            let fragment = ueditorDocument.createElement("p");
            fragment.innerHTML = html;
            // 过滤掉已经是smg的图片;过滤掉base64的图片
            // todo 过滤阿基米德平台的url前缀
            let imgs = [...fragment.querySelectorAll("img")].filter(
                img =>
                img.src.indexOf("media.smgtech.net") < 0 &&
                img.src.indexOf("base64") < 0
            );
            console.log(imgs)
            if(imgs.length > 0){
                let data = {
                    imgs: JSON.stringify(imgs.map(img => img.src)),
                    subject_id:
                    this.$route.query.d,
                    subject_type: 5     
                };
                const postUrls = await common.myFetch(apis.grabwximg, {
                    data,
                    hideLoading: true
                });

                if(postUrls.length > 0){
                    postUrls.forEach(item => {
                        let imageDom = this.normalWindow.document.querySelectorAll('p img')
                        for (let index = 0; index < imageDom.length; index++) {
                            const element = imageDom[index];
                            if(element.src == item.original_url){
                                element.setAttribute('data-src',item.replace_url)
                                element.setAttribute('_src',item.replace_url)
                                element.src = item.replace_url
                            }
                        }
                        this.getPlatform()
                    })


                }
                console.log(postUrls)
            }
        },
        async normalReady(i) {
            let that = this
            console.log('ready------------')
            this.firstLoad = false;
            // console.log(i.registerUI)
            this.normalInstance = i;
            this.normalWindow = i.window;
            if(this.selectPlatform != 'five_star_sports_cms') {
                this.setImgContent()
            }
            
            this.setVideoContent()
            // this.normalInstance.addListener('afterinserthtml', (html) => {
            //     html=html.replace(/<video[^>]*>/i,'');
            // })
            this.normalInstance.addListener('beforepaste', async (eventName, htmlObj) => {
                let html = htmlObj.html;
                html = this.filterVideoAndAudio(html);
                htmlObj.html = "";
                this.handleGrabWXimg(html);
                let ueditorDocument = this.normalWindow.document;
                let fragment = ueditorDocument.createElement("p");
                fragment.innerHTML = html;
                // console.log(fragment.innerHTML)
                this.normalInstance.execCommand(
                    "inserthtml",
                    fragment.innerHTML
                    // await this.handleGrabWXimg(clipboardRealData)
                );
            })
            this.normalInstance.addListener('selectionchange', (e) => {
                if(this.normalWindow.getSelection().anchorNode){
                    var selectionObj = this.normalWindow.getSelection();
                    var rangeObj = selectionObj.getRangeAt(0);
                    var docFragment = rangeObj.cloneContents();
                    var tempDiv = document.createElement("div");
                    tempDiv.appendChild(docFragment);
                    // console.log(tempDiv)
                    // let div = document.createElement('div')
                    // div.innerHTML = this.normalWindow.getSelection().anchorNode.innerHTML
                    let img = tempDiv.querySelectorAll('img')
                    if(img.length > 0){
                        let dom = document.getElementsByClassName('edui-for-customImg')[0]
                        let dom1 = document.getElementsByClassName('edui-for-indent')[0]
                        let dom2 = document.getElementsByClassName('edui-for-fontborder')[0]
                        let dom3 = document.getElementsByClassName('edui-for-rowspacingtop')[0]
                        let dom4 = document.getElementsByClassName('edui-for-rowspacingbottom')[0]
                        let dom5 = document.getElementsByClassName('edui-for-lineheight')[0]
                        let dom6 = document.getElementsByClassName('edui-for-underline')[0]
                        let dom7 = document.getElementsByClassName('edui-for-removeformat')[0]
                        let dom8 = document.getElementsByClassName('edui-for-formatmatch')[0]
                        let dom9 = document.getElementsByClassName('edui-for-fontsize')[0]
                        let dom10 = document.getElementsByClassName('edui-for-blockquote')[0]
                        let dom11 = document.getElementsByClassName('edui-for-horizontal')[0]
                        let dom12 = document.getElementsByClassName('edui-for-link')[0]
                        let dom13 = document.getElementsByClassName('edui-for-unlink')[0]
                        let dom14 = document.getElementsByClassName('edui-for-bold')[0]
                        let dom15 = document.getElementsByClassName('edui-for-italic')[0]
                        let dom16 = document.getElementsByClassName('edui-for-forecolor')[0]
                        let dom17 = document.getElementsByClassName('edui-for-backcolor')[0]
                        let dom18 = document.getElementsByClassName('edui-for-customVideo')[0]
                        dom.classList.add('pichide1')
                        dom1.classList.add('pichide1')
                        dom2.classList.add('pichide1')
                        dom3.classList.add('pichide1')
                        dom4.classList.add('pichide1')
                        dom5.classList.add('pichide1')
                        dom6.classList.add('pichide1')
                        dom7.classList.add('pichide1')
                        dom8.classList.add('pichide1')
                        dom9.classList.add('pichide1')
                        dom10.classList.add('pichide1')
                        dom11.classList.add('pichide1')
                        dom12.classList.add('pichide1')
                        dom13.classList.add('pichide1')
                        dom14.classList.add('pichide1')
                        dom15.classList.add('pichide1')
                        dom16.classList.add('pichide1')
                        dom17.classList.add('pichide1')
                        dom18.classList.add('pichide1')
                    }else{
                        let dom = document.getElementsByClassName('edui-for-customImg')[0]
                        let dom1 = document.getElementsByClassName('edui-for-indent')[0]
                        let dom2 = document.getElementsByClassName('edui-for-fontborder')[0]
                        let dom3 = document.getElementsByClassName('edui-for-rowspacingtop')[0]
                        let dom4 = document.getElementsByClassName('edui-for-rowspacingbottom')[0]
                        let dom5 = document.getElementsByClassName('edui-for-lineheight')[0]
                        let dom6 = document.getElementsByClassName('edui-for-underline')[0]
                        let dom7 = document.getElementsByClassName('edui-for-removeformat')[0]
                        let dom8 = document.getElementsByClassName('edui-for-formatmatch')[0]
                        let dom9 = document.getElementsByClassName('edui-for-fontsize')[0]
                        let dom10 = document.getElementsByClassName('edui-for-blockquote')[0]
                        let dom11 = document.getElementsByClassName('edui-for-horizontal')[0]
                        let dom12 = document.getElementsByClassName('edui-for-link')[0]
                        let dom13 = document.getElementsByClassName('edui-for-unlink')[0]
                        let dom14 = document.getElementsByClassName('edui-for-bold')[0]
                        let dom15 = document.getElementsByClassName('edui-for-italic')[0]
                        let dom16 = document.getElementsByClassName('edui-for-forecolor')[0]
                        let dom17 = document.getElementsByClassName('edui-for-backcolor')[0]
                        let dom18 = document.getElementsByClassName('edui-for-customVideo')[0]
                        dom.classList.remove('pichide1')
                        dom1.classList.remove('pichide1')
                        dom2.classList.remove('pichide1')
                        dom3.classList.remove('pichide1')
                        dom4.classList.remove('pichide1')
                        dom5.classList.remove('pichide1')
                        dom6.classList.remove('pichide1')
                        dom7.classList.remove('pichide1')
                        dom8.classList.remove('pichide1')
                        dom9.classList.remove('pichide1')
                        dom10.classList.remove('pichide1')
                        dom11.classList.remove('pichide1')
                        dom12.classList.remove('pichide1')
                        dom13.classList.remove('pichide1')
                        dom14.classList.remove('pichide1')
                        dom15.classList.remove('pichide1')
                        dom16.classList.remove('pichide1')
                        dom17.classList.remove('pichide1')
                        dom18.classList.remove('pichide1')
                    }
                }else{
                    // console.log(456)
                    let dom = document.getElementsByClassName('edui-for-customImg')[0]
                    let dom1 = document.getElementsByClassName('edui-for-indent')[0]
                    let dom2 = document.getElementsByClassName('edui-for-fontborder')[0]
                    let dom3 = document.getElementsByClassName('edui-for-rowspacingtop')[0]
                    let dom4 = document.getElementsByClassName('edui-for-rowspacingbottom')[0]
                    let dom5 = document.getElementsByClassName('edui-for-lineheight')[0]
                    let dom6 = document.getElementsByClassName('edui-for-underline')[0]
                    let dom7 = document.getElementsByClassName('edui-for-removeformat')[0]
                    let dom8 = document.getElementsByClassName('edui-for-formatmatch')[0]
                    let dom9 = document.getElementsByClassName('edui-for-fontsize')[0]
                    let dom10 = document.getElementsByClassName('edui-for-blockquote')[0]
                    let dom11 = document.getElementsByClassName('edui-for-horizontal')[0]
                    let dom12 = document.getElementsByClassName('edui-for-link')[0]
                    let dom13 = document.getElementsByClassName('edui-for-unlink')[0]
                    let dom14 = document.getElementsByClassName('edui-for-bold')[0]
                    let dom15 = document.getElementsByClassName('edui-for-italic')[0]
                    let dom16 = document.getElementsByClassName('edui-for-forecolor')[0]
                    let dom17 = document.getElementsByClassName('edui-for-backcolor')[0]
                    let dom18 = document.getElementsByClassName('edui-for-customVideo')[0]
                    dom.classList.remove('pichide1')
                    dom1.classList.remove('pichide1')
                    dom2.classList.remove('pichide1')
                    dom3.classList.remove('pichide1')
                    dom4.classList.remove('pichide1')
                    dom5.classList.remove('pichide1')
                    dom6.classList.remove('pichide1')
                    dom7.classList.remove('pichide1')
                    dom8.classList.remove('pichide1')
                    dom9.classList.remove('pichide1')
                    dom10.classList.remove('pichide1')
                    dom11.classList.remove('pichide1')
                    dom12.classList.remove('pichide1')
                    dom13.classList.remove('pichide1')
                    dom14.classList.remove('pichide1')
                    dom15.classList.remove('pichide1')
                    dom16.classList.remove('pichide1')
                    dom17.classList.remove('pichide1')
                    dom18.classList.remove('pichide1')
                }
            })
            this.normalInstance.addListener('contentChange',() => {
                // let nearEm = this.normalWindow.document.querySelectorAll('.imgContainer > em')
                // let nearSpanLine = this.normalWindow.document.querySelectorAll('.imgContainer > span[style="text-decoration: underline;"]')
                // let nearSpanNone = this.normalWindow.document.querySelectorAll('.imgContainer > span[style="text-decoration: none;"]')
                // let nearSpanstyle = this.normalWindow.document.querySelectorAll('.imgContainer > span[style]')
                // for (let index = 0; index < nearEm.length; index++) {
                //     const element = nearEm[index];
                //     element.remove()
                // }
                // for (let index = 0; index < nearSpanstyle.length; index++) {
                //     const element = nearSpanstyle[index];
                //     element.remove()
                // }
                // for (let index = 0; index < nearSpanLine.length; index++) {
                //     const element = nearSpanLine[index];
                //     element.remove()
                // }
                // for (let index = 0; index < nearSpanNone.length; index++) {
                //     const element = nearSpanNone[index];
                //     element.remove()
                // }
                let imgContainer = this.normalWindow.document.querySelectorAll('.imgContainer')
                if(imgContainer.length > 0){
                    let pcenterTxt = this.normalWindow.document.querySelectorAll('p > .centerTxt')
                    if(pcenterTxt.length > 0){
                        for (let index = 0; index < pcenterTxt.length; index++) {
                            const element = pcenterTxt[index];
                            element.remove()
                        }
                    }
                    for (let index = 0; index < imgContainer.length; index++) {
                        const element = imgContainer[index];
                        let textDom = element.innerHTML.replace('1编辑1加水印1图片描述','')
                        // if(element.querySelectorAll('img')[0].title){
                        //     textDom = element.innerHTML.replace(element.querySelectorAll('img')[0].title,'')
                        // }
                        element.innerHTML = textDom
                        let img = element.querySelectorAll('img')
                        let txt = element.querySelectorAll('span')
                        // let strong = element.querySelectorAll('strong')
                        if(img.length == 0){
                            element.remove()
                        }
                        // if(strong.length > 0){
                        //     for (let index1 = 0; index1 < strong.length; index1++) {
                        //         const element1 = strong[index1];
                        //         element1.remove()
                        //     }
                        // }
                        if(txt.length > 0){
                            for (let index1 = 0; index1 < txt.length; index1++) {
                                const element1 = txt[index1];
                                if(element1.innerText == '1编辑1加水印1图片描述'){
                                    element1.remove()
                                }
                            }
                        }
                        let checkImgDom = element.getElementsByClassName('relative')[0]
                        console.log(checkImgDom)
                        if(!checkImgDom){
                            let fileid = element.getAttribute('data-fileid')
                            let imgDom = document.createElement('span')
                            imgDom.classList.add('img')
                            imgDom.setAttribute('contentEditable',false)
                            let img = element.getElementsByTagName('img')[0]
                            let btnHtml = `<span class="imgBtnsEdit" data-fileid="${fileid}"><i>1</i>编辑</span><span class="imgBtnsAdd" data-fileid="${fileid}"><i>1</i>加水印</span><span class="imgDescribe" data-fileid="${fileid}"><i>1</i>图片描述</span><span data-fileid="${fileid}" class="centerTxt"></span>`
                            let relativeDom = document.createElement('span')
                            relativeDom.classList.add('relative')
                            relativeDom.setAttribute('contentEditable',false)
                            if(img){
                                relativeDom.appendChild(img)
                                relativeDom.innerHTML += btnHtml
                                imgDom.appendChild(relativeDom)
                                element.innerHTML = ''
                                element.appendChild(imgDom)
                                let txtDom = element.getElementsByClassName('centerTxt')[0]
                                txtDom.setAttribute('contentEditable',false)
                                if(element.querySelectorAll('img')[0].title){
                                    txtDom.innerText = element.querySelectorAll('img')[0].title
                                }
                            }
                        }else{
                            // if(!element.querySelectorAll('.centerTxt')[0]){
                            //     let fileid = element.getAttribute('data-fileid')
                            //     let centerTxt = `<span data-fileid="${fileid}" class="centerTxt"></span>`
                            //     let imgDom = element.getElementsByClassName('relative')[0]
                            //     if(imgDom){
                            //         imgDom.innerHTML += centerTxt
                            //         let txtDom = element.getElementsByClassName('centerTxt')[0]
                            //         txtDom.setAttribute('contentEditable',false)
                            //         if(element.querySelectorAll('img')[0].title){
                            //             txtDom.innerText = element.querySelectorAll('img')[0].title
                            //         }
                            //     }   
                            // }
                        }
                    }
                }
            })
            // let c = await this.setImgContent()
            // let ueditorDocument = this.normalWindow.document;
            // let fragment = ueditorDocument.createElement("p");
            // fragment.innerHTML = c;
            // this.normalContent = ''
            // i.execCommand(
            //     "inserthtml",
            //     fragment.innerHTML
            //     // await this.handleGrabWXimg(clipboardRealData)
            // );
            // this.normalContent = fragment.innerHTML
            // this.normalInstance.execCommand(
            //         "inserthtml",
            //         fragment.innerHTML
            //         // await this.handleGrabWXimg(clipboardRealData)
            //     );
            // this.normalWindow.addEventListener('blur',(e) => {
            //     // console.log(this.normalWindow)
            //     let centerTxt = this.normalWindow.document.querySelectorAll('.centerTxt')
            //     for (let index = 0; index < centerTxt.length; index++) {
            //         const element = centerTxt[index];
            //         element.setAttribute('contenteditable', false)
            //     }
            // })
            // this.normalWindow.addEventListener('keydown',(e) => {
            //     // console.log(e)
            //     if(e && e.path && e.path.length > 0){
            //         if(e.path[0].className == 'centerTxt'){
            //             // console.log(99)
            //             if(e.key == 'Enter'){
            //                 // console.log(123)
            //                 e.preventDefault()
            //                 e.stopPropagation()
            //             }
            //         }
            //     }else if(e && e.target){
            //         if(e.target.className == 'centerTxt'){
            //             if(e.key == 'Enter'){
            //                 // console.log(123)
            //                 e.preventDefault()
            //                 e.stopPropagation()
            //             }
            //         }
            //     }
            // })
            // this.normalWindow.addEventListener('input',(e) => {
            //     // console.log(e)
            //     if(e && e.path && e.path.length > 0){
            //         if(e.path[0].className == 'centerTxt'){
            //             // console.log(99)
            //             // if(e.inputType == 'insertParagraph'){
            //             //     console.log(123)
            //             //     e.preventDefault()
            //             //     e.stopPropagation()
            //             // }
            //             if(e.path[0].innerText.length <= 24){
            //                 this.centerTxtSve = e.path[0].innerText
            //             }else{
            //                 e.path[0].innerText = this.centerTxtSve
            //             }
            //         }
            //     }else if(e && e.target){
            //         if(e.target.className == 'centerTxt'){
            //             // console.log(99)
            //             // if(e.inputType == 'insertParagraph'){
            //             //     console.log(123)
            //             //     e.preventDefault()
            //             //     e.stopPropagation()
            //             // }
            //             if(e.target.innerText.length <= 24){
            //                 this.centerTxtSve = e.target.innerText
            //             }else{
            //                 e.target.innerText = this.centerTxtSve
            //             }
            //         }
            //     }
            // })
            this.normalWindow.addEventListener('click',(e) => {
                // console.log(e)
                this.showWriteSelect = false
                if(e && e.path && e.path.length > 0){
                    if(e.path[0].className == 'imgBtnsEdit'){
                        let fileid = e.path[0].dataset.fileid
                        let setImgContainer = document.getElementsByClassName('setImgContainer')[0]
                        setImgContainer.innerHTML = this.normalInstance.getContent()
                        let dom1 = setImgContainer.querySelectorAll('.imgBtnsAdd[data-fileid="'+fileid+'"]')[0]
                        let url = dom1.parentNode.firstChild.src
                        let info = {}
                        info.t = 5;
                        info.d = this.articleId;
                        info.url = url;
                        info.isMedia = true
                        info.canEdit = true

                        this.$picEditType1(info,this.call).then(el => {
                            console.log(el) 
                            el.url = el.cover
                            el.id = el.file_id
                            this.changeImgSrc(fileid,el)
                            this.getPlatform()
                        });
                    }else if(e.path[0].className == 'imgBtnsAdd'){
                        let fileid = e.path[0].dataset.fileid
                        this.$WaterEdit(this.selectPlatform).then(el => {
                            if(el) {
                                el.file_id = fileid
                                el.id = this.$route.query.d
                                common
                                .myFetch(apis.addwatermark, el)
                                .then(r => {
                                    if (r) {
                                        console.log(r)
                                        this.changeImgSrc(fileid,r)
                                        // this.normalInstance.execCommand(
                                        //     "inserthtml",
                                        //     `<p contenteditable="false" class="imgContainer"><img src="${
                                        //         r.url
                                        //         }" style="max-width: 100%; height: auto;"/><span data-fileId="${e.list[0].file_id}" class="imgBtnsEdit"><i>1</i>编辑</span><span data-fileId="${e.list[0].file_id}" class="imgBtnsAdd"><i>1</i>加水印</span></span><p></p></p>`
                                        // );
                                        this.getPlatform()
                                        this.showWriteUpload = false;
                                        this.topPic = false
                                    }
                                });
                            }else{
                                this.showWriteUpload = false;
                                this.topPic = false
                            }
                        })
                    }else if(e.path[0].className == 'imgDescribe'){
                        let fileid = e.path[0].dataset.fileid
                        this.saveDescribeId = fileid
                        if(this.normalWindow.document.querySelectorAll('.imgContainer[data-fileid="'+fileid+'"] img')[0].title){
                            this.describeValue = this.normalWindow.document.querySelectorAll('.imgContainer[data-fileid="'+fileid+'"] img')[0].title
                        } 
                        this.showDescribeContent = true
                        // console.log(123321)
                    }else if(e.path[0].className == 'centerTxt'){
                        let dom = document.getElementsByClassName('edui-for-customImg')[0]
                        let dom1 = document.getElementsByClassName('edui-for-indent')[0]
                        let dom2 = document.getElementsByClassName('edui-for-fontborder')[0]
                        let dom3 = document.getElementsByClassName('edui-for-rowspacingtop')[0]
                        let dom4 = document.getElementsByClassName('edui-for-rowspacingbottom')[0]
                        let dom5 = document.getElementsByClassName('edui-for-lineheight')[0]
                        let dom6 = document.getElementsByClassName('edui-for-underline')[0]
                        let dom7 = document.getElementsByClassName('edui-for-removeformat')[0]
                        let dom8 = document.getElementsByClassName('edui-for-formatmatch')[0]
                        let dom9 = document.getElementsByClassName('edui-for-fontsize')[0]
                        let dom10 = document.getElementsByClassName('edui-for-blockquote')[0]
                        let dom11 = document.getElementsByClassName('edui-for-horizontal')[0]
                        let dom12 = document.getElementsByClassName('edui-for-link')[0]
                        let dom13 = document.getElementsByClassName('edui-for-unlink')[0]
                        let dom14 = document.getElementsByClassName('edui-for-bold')[0]
                        let dom15 = document.getElementsByClassName('edui-for-italic')[0]
                        let dom16 = document.getElementsByClassName('edui-for-forecolor')[0]
                        let dom17 = document.getElementsByClassName('edui-for-backcolor')[0]
                        let dom18 = document.getElementsByClassName('edui-for-customVideo')[0]
                        dom.classList.add('pichide1')
                        dom1.classList.add('pichide1')
                        dom2.classList.add('pichide1')
                        dom3.classList.add('pichide1')
                        dom4.classList.add('pichide1')
                        dom5.classList.add('pichide1')
                        dom6.classList.add('pichide1')
                        dom7.classList.add('pichide1')
                        dom8.classList.add('pichide1')
                        dom9.classList.add('pichide1')
                        dom10.classList.add('pichide1')
                        dom11.classList.add('pichide1')
                        dom12.classList.add('pichide1')
                        dom13.classList.add('pichide1')
                        dom14.classList.add('pichide1')
                        dom15.classList.add('pichide1')
                        dom16.classList.add('pichide1')
                        dom17.classList.remove('pichide1')
                        dom18.classList.remove('pichide1')
                        // this.normalInstance.setDisabled()
                    }else if(e.path[0].nodeName == 'IMG'){
                        let dom = document.getElementsByClassName('edui-for-customImg')[0]
                        let dom1 = document.getElementsByClassName('edui-for-indent')[0]
                        let dom2 = document.getElementsByClassName('edui-for-fontborder')[0]
                        let dom3 = document.getElementsByClassName('edui-for-rowspacingtop')[0]
                        let dom4 = document.getElementsByClassName('edui-for-rowspacingbottom')[0]
                        let dom5 = document.getElementsByClassName('edui-for-lineheight')[0]
                        let dom6 = document.getElementsByClassName('edui-for-underline')[0]
                        let dom7 = document.getElementsByClassName('edui-for-removeformat')[0]
                        let dom8 = document.getElementsByClassName('edui-for-formatmatch')[0]
                        let dom9 = document.getElementsByClassName('edui-for-fontsize')[0]
                        let dom10 = document.getElementsByClassName('edui-for-blockquote')[0]
                        let dom11 = document.getElementsByClassName('edui-for-horizontal')[0]
                        let dom12 = document.getElementsByClassName('edui-for-link')[0]
                        let dom13 = document.getElementsByClassName('edui-for-unlink')[0]
                        let dom14 = document.getElementsByClassName('edui-for-bold')[0]
                        let dom15 = document.getElementsByClassName('edui-for-italic')[0]
                        let dom16 = document.getElementsByClassName('edui-for-forecolor')[0]
                        let dom17 = document.getElementsByClassName('edui-for-backcolor')[0]
                        let dom18 = document.getElementsByClassName('edui-for-customVideo')[0]
                        dom.classList.add('pichide1')
                        dom1.classList.add('pichide1')
                        dom2.classList.add('pichide1')
                        dom3.classList.add('pichide1')
                        dom4.classList.add('pichide1')
                        dom5.classList.add('pichide1')
                        dom6.classList.add('pichide1')
                        dom7.classList.add('pichide1')
                        dom8.classList.add('pichide1')
                        dom9.classList.add('pichide1')
                        dom10.classList.add('pichide1')
                        dom11.classList.add('pichide1')
                        dom12.classList.add('pichide1')
                        dom13.classList.add('pichide1')
                        dom14.classList.add('pichide1')
                        dom15.classList.add('pichide1')
                        dom16.classList.add('pichide1')
                        dom17.classList.add('pichide1')
                        dom18.classList.add('pichide1')
                    }else if(e.path[0].className == 'imgContainer'){
                        let dom = document.getElementsByClassName('edui-for-customImg')[0]
                        let dom1 = document.getElementsByClassName('edui-for-indent')[0]
                        let dom2 = document.getElementsByClassName('edui-for-fontborder')[0]
                        let dom3 = document.getElementsByClassName('edui-for-rowspacingtop')[0]
                        let dom4 = document.getElementsByClassName('edui-for-rowspacingbottom')[0]
                        let dom5 = document.getElementsByClassName('edui-for-lineheight')[0]
                        let dom6 = document.getElementsByClassName('edui-for-underline')[0]
                        let dom7 = document.getElementsByClassName('edui-for-removeformat')[0]
                        let dom8 = document.getElementsByClassName('edui-for-formatmatch')[0]
                        let dom9 = document.getElementsByClassName('edui-for-fontsize')[0]
                        let dom10 = document.getElementsByClassName('edui-for-blockquote')[0]
                        let dom11 = document.getElementsByClassName('edui-for-horizontal')[0]
                        let dom12 = document.getElementsByClassName('edui-for-link')[0]
                        let dom13 = document.getElementsByClassName('edui-for-unlink')[0]
                        let dom14 = document.getElementsByClassName('edui-for-bold')[0]
                        let dom15 = document.getElementsByClassName('edui-for-italic')[0]
                        let dom16 = document.getElementsByClassName('edui-for-forecolor')[0]
                        let dom17 = document.getElementsByClassName('edui-for-backcolor')[0]
                        let dom18 = document.getElementsByClassName('edui-for-customVideo')[0]
                        dom.classList.add('pichide1')
                        dom1.classList.add('pichide1')
                        dom2.classList.add('pichide1')
                        dom3.classList.add('pichide1')
                        dom4.classList.add('pichide1')
                        dom5.classList.add('pichide1')
                        dom6.classList.add('pichide1')
                        dom7.classList.add('pichide1')
                        dom8.classList.add('pichide1')
                        dom9.classList.add('pichide1')
                        dom10.classList.add('pichide1')
                        dom11.classList.add('pichide1')
                        dom12.classList.add('pichide1')
                        dom13.classList.add('pichide1')
                        dom14.classList.add('pichide1')
                        dom15.classList.add('pichide1')
                        dom16.classList.add('pichide1')
                        dom17.classList.add('pichide1')
                        dom18.classList.add('pichide1')
                    }else if(e.path[0].className == 'img'){
                        let dom = document.getElementsByClassName('edui-for-customImg')[0]
                        let dom1 = document.getElementsByClassName('edui-for-indent')[0]
                        let dom2 = document.getElementsByClassName('edui-for-fontborder')[0]
                        let dom3 = document.getElementsByClassName('edui-for-rowspacingtop')[0]
                        let dom4 = document.getElementsByClassName('edui-for-rowspacingbottom')[0]
                        let dom5 = document.getElementsByClassName('edui-for-lineheight')[0]
                        let dom6 = document.getElementsByClassName('edui-for-underline')[0]
                        let dom7 = document.getElementsByClassName('edui-for-removeformat')[0]
                        let dom8 = document.getElementsByClassName('edui-for-formatmatch')[0]
                        let dom9 = document.getElementsByClassName('edui-for-fontsize')[0]
                        let dom10 = document.getElementsByClassName('edui-for-blockquote')[0]
                        let dom11 = document.getElementsByClassName('edui-for-horizontal')[0]
                        let dom12 = document.getElementsByClassName('edui-for-link')[0]
                        let dom13 = document.getElementsByClassName('edui-for-unlink')[0]
                        let dom14 = document.getElementsByClassName('edui-for-bold')[0]
                        let dom15 = document.getElementsByClassName('edui-for-italic')[0]
                        let dom16 = document.getElementsByClassName('edui-for-forecolor')[0]
                        let dom17 = document.getElementsByClassName('edui-for-backcolor')[0]
                        let dom18 = document.getElementsByClassName('edui-for-customVideo')[0]
                        dom.classList.add('pichide1')
                        dom1.classList.add('pichide1')
                        dom2.classList.add('pichide1')
                        dom3.classList.add('pichide1')
                        dom4.classList.add('pichide1')
                        dom5.classList.add('pichide1')
                        dom6.classList.add('pichide1')
                        dom7.classList.add('pichide1')
                        dom8.classList.add('pichide1')
                        dom9.classList.add('pichide1')
                        dom10.classList.add('pichide1')
                        dom11.classList.add('pichide1')
                        dom12.classList.add('pichide1')
                        dom13.classList.add('pichide1')
                        dom14.classList.add('pichide1')
                        dom15.classList.add('pichide1')
                        dom16.classList.add('pichide1')
                        dom17.classList.add('pichide1')
                        dom18.classList.add('pichide1')
                    }else{
                        let dom = document.getElementsByClassName('edui-for-customImg')[0]
                        let dom1 = document.getElementsByClassName('edui-for-indent')[0]
                        let dom2 = document.getElementsByClassName('edui-for-fontborder')[0]
                        let dom3 = document.getElementsByClassName('edui-for-rowspacingtop')[0]
                        let dom4 = document.getElementsByClassName('edui-for-rowspacingbottom')[0]
                        let dom5 = document.getElementsByClassName('edui-for-lineheight')[0]
                        let dom6 = document.getElementsByClassName('edui-for-underline')[0]
                        let dom7 = document.getElementsByClassName('edui-for-removeformat')[0]
                        let dom8 = document.getElementsByClassName('edui-for-formatmatch')[0]
                        let dom9 = document.getElementsByClassName('edui-for-fontsize')[0]
                        let dom10 = document.getElementsByClassName('edui-for-blockquote')[0]
                        let dom11 = document.getElementsByClassName('edui-for-horizontal')[0]
                        let dom12 = document.getElementsByClassName('edui-for-link')[0]
                        let dom13 = document.getElementsByClassName('edui-for-unlink')[0]
                        let dom14 = document.getElementsByClassName('edui-for-bold')[0]
                        let dom15 = document.getElementsByClassName('edui-for-italic')[0]
                        let dom16 = document.getElementsByClassName('edui-for-forecolor')[0]
                        let dom17 = document.getElementsByClassName('edui-for-backcolor')[0]
                        let dom18 = document.getElementsByClassName('edui-for-customVideo')[0]
                        dom.classList.remove('pichide1')
                        dom1.classList.remove('pichide1')
                        dom2.classList.remove('pichide1')
                        dom3.classList.remove('pichide1')
                        dom4.classList.remove('pichide1')
                        dom5.classList.remove('pichide1')
                        dom6.classList.remove('pichide1')
                        dom7.classList.remove('pichide1')
                        dom8.classList.remove('pichide1')
                        dom9.classList.remove('pichide1')
                        dom10.classList.remove('pichide1')
                        dom11.classList.remove('pichide1')
                        dom12.classList.remove('pichide1')
                        dom13.classList.remove('pichide1')
                        dom14.classList.remove('pichide1')
                        dom15.classList.remove('pichide1')
                        dom16.classList.remove('pichide1')
                        dom17.classList.remove('pichide1')
                        dom18.classList.remove('pichide1')
                    }
                }else if(e && e.target){
                    if(e.target.className == 'imgBtnsEdit'){
                        let fileid = e.target.dataset.fileid
                        let setImgContainer = document.getElementsByClassName('setImgContainer')[0]
                        setImgContainer.innerHTML = this.normalInstance.getContent()
                        let dom1 = setImgContainer.querySelectorAll('.imgBtnsAdd[data-fileid="'+fileid+'"]')[0]
                        let url = dom1.parentNode.firstChild.src
                        let info = {}
                        info.t = 5;
                        info.d = this.articleId;
                        info.url = url;
                        info.isMedia = true
                        info.canEdit = true

                        this.$picEditType1(info,this.call).then(el => {
                            console.log(el) 
                            el.url = el.cover
                            el.id = el.file_id
                            this.changeImgSrc(fileid,el)
                            this.getPlatform()
                        });
                    }else if(e.target.className == 'imgBtnsAdd'){
                        let fileid = e.target.dataset.fileid
                        this.$WaterEdit(this.selectPlatform).then(el => {
                            if(el) {
                                el.file_id = fileid
                                el.id = this.$route.query.d
                                common
                                .myFetch(apis.addwatermark, el)
                                .then(r => {
                                    if (r) {
                                        console.log(r)
                                        this.changeImgSrc(fileid,r)
                                        // this.normalInstance.execCommand(
                                        //     "inserthtml",
                                        //     `<p contenteditable="false" class="imgContainer"><img src="${
                                        //         r.url
                                        //         }" style="max-width: 100%; height: auto;"/><span data-fileId="${e.list[0].file_id}" class="imgBtnsEdit"><i>1</i>编辑</span><span data-fileId="${e.list[0].file_id}" class="imgBtnsAdd"><i>1</i>加水印</span></span><p></p></p>`
                                        // );
                                        this.getPlatform()
                                        this.showWriteUpload = false;
                                        this.topPic = false
                                    }
                                });
                            }else{
                                this.showWriteUpload = false;
                                this.topPic = false
                            }
                        })
                    }else if(e.target.className == 'imgDescribe'){
                        let fileid = e.target.dataset.fileid
                        this.saveDescribeId = fileid
                        if(this.normalWindow.document.querySelectorAll('.imgContainer[data-fileid="'+fileid+'"] img')[0].title){
                            this.describeValue = this.normalWindow.document.querySelectorAll('.imgContainer[data-fileid="'+fileid+'"] img')[0].title
                        }   
                        this.showDescribeContent = true
                        // console.log(123321)
                    }else if(e.target.className == 'centerTxt'){
                        let dom = document.getElementsByClassName('edui-for-customImg')[0]
                        let dom1 = document.getElementsByClassName('edui-for-indent')[0]
                        let dom2 = document.getElementsByClassName('edui-for-fontborder')[0]
                        let dom3 = document.getElementsByClassName('edui-for-rowspacingtop')[0]
                        let dom4 = document.getElementsByClassName('edui-for-rowspacingbottom')[0]
                        let dom5 = document.getElementsByClassName('edui-for-lineheight')[0]
                        let dom6 = document.getElementsByClassName('edui-for-underline')[0]
                        let dom7 = document.getElementsByClassName('edui-for-removeformat')[0]
                        let dom8 = document.getElementsByClassName('edui-for-formatmatch')[0]
                        let dom9 = document.getElementsByClassName('edui-for-fontsize')[0]
                        let dom10 = document.getElementsByClassName('edui-for-blockquote')[0]
                        let dom11 = document.getElementsByClassName('edui-for-horizontal')[0]
                        let dom12 = document.getElementsByClassName('edui-for-link')[0]
                        let dom13 = document.getElementsByClassName('edui-for-unlink')[0]
                        let dom14 = document.getElementsByClassName('edui-for-bold')[0]
                        let dom15 = document.getElementsByClassName('edui-for-italic')[0]
                        let dom16 = document.getElementsByClassName('edui-for-forecolor')[0]
                        let dom17 = document.getElementsByClassName('edui-for-backcolor')[0]
                        let dom18 = document.getElementsByClassName('edui-for-customVideo')[0]
                        dom.classList.add('pichide1')
                        dom1.classList.add('pichide1')
                        dom2.classList.add('pichide1')
                        dom3.classList.add('pichide1')
                        dom4.classList.add('pichide1')
                        dom5.classList.add('pichide1')
                        dom6.classList.add('pichide1')
                        dom7.classList.add('pichide1')
                        dom8.classList.add('pichide1')
                        dom9.classList.add('pichide1')
                        dom10.classList.add('pichide1')
                        dom11.classList.add('pichide1')
                        dom12.classList.add('pichide1')
                        dom13.classList.add('pichide1')
                        dom14.classList.add('pichide1')
                        dom15.classList.add('pichide1')
                        dom16.classList.add('pichide1')
                        dom17.classList.add('pichide1')
                        dom18.classList.add('pichide1')
                        // this.normalInstance.setDisabled('textarea')
                    }else if(e.target.className == 'imgContainer'){
                        let dom = document.getElementsByClassName('edui-for-customImg')[0]
                        let dom1 = document.getElementsByClassName('edui-for-indent')[0]
                        let dom2 = document.getElementsByClassName('edui-for-fontborder')[0]
                        let dom3 = document.getElementsByClassName('edui-for-rowspacingtop')[0]
                        let dom4 = document.getElementsByClassName('edui-for-rowspacingbottom')[0]
                        let dom5 = document.getElementsByClassName('edui-for-lineheight')[0]
                        let dom6 = document.getElementsByClassName('edui-for-underline')[0]
                        let dom7 = document.getElementsByClassName('edui-for-removeformat')[0]
                        let dom8 = document.getElementsByClassName('edui-for-formatmatch')[0]
                        let dom9 = document.getElementsByClassName('edui-for-fontsize')[0]
                        let dom10 = document.getElementsByClassName('edui-for-blockquote')[0]
                        let dom11 = document.getElementsByClassName('edui-for-horizontal')[0]
                        let dom12 = document.getElementsByClassName('edui-for-link')[0]
                        let dom13 = document.getElementsByClassName('edui-for-unlink')[0]
                        let dom14 = document.getElementsByClassName('edui-for-bold')[0]
                        let dom15 = document.getElementsByClassName('edui-for-italic')[0]
                        let dom16 = document.getElementsByClassName('edui-for-forecolor')[0]
                        let dom17 = document.getElementsByClassName('edui-for-backcolor')[0]
                        let dom18 = document.getElementsByClassName('edui-for-customVideo')[0]
                        dom.classList.add('pichide1')
                        dom1.classList.add('pichide1')
                        dom2.classList.add('pichide1')
                        dom3.classList.add('pichide1')
                        dom4.classList.add('pichide1')
                        dom5.classList.add('pichide1')
                        dom6.classList.add('pichide1')
                        dom7.classList.add('pichide1')
                        dom8.classList.add('pichide1')
                        dom9.classList.add('pichide1')
                        dom10.classList.add('pichide1')
                        dom11.classList.add('pichide1')
                        dom12.classList.add('pichide1')
                        dom13.classList.add('pichide1')
                        dom14.classList.add('pichide1')
                        dom15.classList.add('pichide1')
                        dom16.classList.add('pichide1')
                        dom17.classList.add('pichide1')
                        dom18.classList.add('pichide1')
                    }else if(e.target.className == 'img'){
                        let dom = document.getElementsByClassName('edui-for-customImg')[0]
                        let dom1 = document.getElementsByClassName('edui-for-indent')[0]
                        let dom2 = document.getElementsByClassName('edui-for-fontborder')[0]
                        let dom3 = document.getElementsByClassName('edui-for-rowspacingtop')[0]
                        let dom4 = document.getElementsByClassName('edui-for-rowspacingbottom')[0]
                        let dom5 = document.getElementsByClassName('edui-for-lineheight')[0]
                        let dom6 = document.getElementsByClassName('edui-for-underline')[0]
                        let dom7 = document.getElementsByClassName('edui-for-removeformat')[0]
                        let dom8 = document.getElementsByClassName('edui-for-formatmatch')[0]
                        let dom9 = document.getElementsByClassName('edui-for-fontsize')[0]
                        let dom10 = document.getElementsByClassName('edui-for-blockquote')[0]
                        let dom11 = document.getElementsByClassName('edui-for-horizontal')[0]
                        let dom12 = document.getElementsByClassName('edui-for-link')[0]
                        let dom13 = document.getElementsByClassName('edui-for-unlink')[0]
                        let dom14 = document.getElementsByClassName('edui-for-bold')[0]
                        let dom15 = document.getElementsByClassName('edui-for-italic')[0]
                        let dom16 = document.getElementsByClassName('edui-for-forecolor')[0]
                        let dom17 = document.getElementsByClassName('edui-for-backcolor')[0]
                        let dom18 = document.getElementsByClassName('edui-for-customVideo')[0]
                        dom.classList.add('pichide1')
                        dom1.classList.add('pichide1')
                        dom2.classList.add('pichide1')
                        dom3.classList.add('pichide1')
                        dom4.classList.add('pichide1')
                        dom5.classList.add('pichide1')
                        dom6.classList.add('pichide1')
                        dom7.classList.add('pichide1')
                        dom8.classList.add('pichide1')
                        dom9.classList.add('pichide1')
                        dom10.classList.add('pichide1')
                        dom11.classList.add('pichide1')
                        dom12.classList.add('pichide1')
                        dom13.classList.add('pichide1')
                        dom14.classList.add('pichide1')
                        dom15.classList.add('pichide1')
                        dom16.classList.add('pichide1')
                        dom17.classList.add('pichide1')
                        dom18.classList.add('pichide1')
                    }else if(e.target.nodeName == 'IMG'){
                        let dom = document.getElementsByClassName('edui-for-customImg')[0]
                        let dom1 = document.getElementsByClassName('edui-for-indent')[0]
                        let dom2 = document.getElementsByClassName('edui-for-fontborder')[0]
                        let dom3 = document.getElementsByClassName('edui-for-rowspacingtop')[0]
                        let dom4 = document.getElementsByClassName('edui-for-rowspacingbottom')[0]
                        let dom5 = document.getElementsByClassName('edui-for-lineheight')[0]
                        let dom6 = document.getElementsByClassName('edui-for-underline')[0]
                        let dom7 = document.getElementsByClassName('edui-for-removeformat')[0]
                        let dom8 = document.getElementsByClassName('edui-for-formatmatch')[0]
                        let dom9 = document.getElementsByClassName('edui-for-fontsize')[0]
                        let dom10 = document.getElementsByClassName('edui-for-blockquote')[0]
                        let dom11 = document.getElementsByClassName('edui-for-horizontal')[0]
                        let dom12 = document.getElementsByClassName('edui-for-link')[0]
                        let dom13 = document.getElementsByClassName('edui-for-unlink')[0]
                        let dom14 = document.getElementsByClassName('edui-for-bold')[0]
                        let dom15 = document.getElementsByClassName('edui-for-italic')[0]
                        let dom16 = document.getElementsByClassName('edui-for-forecolor')[0]
                        let dom17 = document.getElementsByClassName('edui-for-backcolor')[0]
                        let dom18 = document.getElementsByClassName('edui-for-customVideo')[0]
                        dom.classList.add('pichide1')
                        dom1.classList.add('pichide1')
                        dom2.classList.add('pichide1')
                        dom3.classList.add('pichide1')
                        dom4.classList.add('pichide1')
                        dom5.classList.add('pichide1')
                        dom6.classList.add('pichide1')
                        dom7.classList.add('pichide1')
                        dom8.classList.add('pichide1')
                        dom9.classList.add('pichide1')
                        dom10.classList.add('pichide1')
                        dom11.classList.add('pichide1')
                        dom12.classList.add('pichide1')
                        dom13.classList.add('pichide1')
                        dom14.classList.add('pichide1')
                        dom15.classList.add('pichide1')
                        dom16.classList.add('pichide1')
                        dom17.classList.add('pichide1')
                        dom18.classList.add('pichide1')
                    }else{
                        let dom = document.getElementsByClassName('edui-for-customImg')[0]
                        let dom1 = document.getElementsByClassName('edui-for-indent')[0]
                        let dom2 = document.getElementsByClassName('edui-for-fontborder')[0]
                        let dom3 = document.getElementsByClassName('edui-for-rowspacingtop')[0]
                        let dom4 = document.getElementsByClassName('edui-for-rowspacingbottom')[0]
                        let dom5 = document.getElementsByClassName('edui-for-lineheight')[0]
                        let dom6 = document.getElementsByClassName('edui-for-underline')[0]
                        let dom7 = document.getElementsByClassName('edui-for-removeformat')[0]
                        let dom8 = document.getElementsByClassName('edui-for-formatmatch')[0]
                        let dom9 = document.getElementsByClassName('edui-for-fontsize')[0]
                        let dom10 = document.getElementsByClassName('edui-for-blockquote')[0]
                        let dom11 = document.getElementsByClassName('edui-for-horizontal')[0]
                        let dom12 = document.getElementsByClassName('edui-for-link')[0]
                        let dom13 = document.getElementsByClassName('edui-for-unlink')[0]
                        let dom14 = document.getElementsByClassName('edui-for-bold')[0]
                        let dom15 = document.getElementsByClassName('edui-for-italic')[0]
                        let dom16 = document.getElementsByClassName('edui-for-forecolor')[0]
                        let dom17 = document.getElementsByClassName('edui-for-backcolor')[0]
                        let dom18 = document.getElementsByClassName('edui-for-customVideo')[0]
                        dom.classList.remove('pichide1')
                        dom1.classList.remove('pichide1')
                        dom2.classList.remove('pichide1')
                        dom3.classList.remove('pichide1')
                        dom4.classList.remove('pichide1')
                        dom5.classList.remove('pichide1')
                        dom6.classList.remove('pichide1')
                        dom7.classList.remove('pichide1')
                        dom8.classList.remove('pichide1')
                        dom9.classList.remove('pichide1')
                        dom10.classList.remove('pichide1')
                        dom11.classList.remove('pichide1')
                        dom12.classList.remove('pichide1')
                        dom13.classList.remove('pichide1')
                        dom14.classList.remove('pichide1')
                        dom15.classList.remove('pichide1')
                        dom16.classList.remove('pichide1')
                        dom17.classList.remove('pichide1')
                        dom18.classList.remove('pichide1')
                    }
                }
            })
            // this.normalWindow.addEventListener('paste', async e => {
            //     if(e && e.target){
            //         if(e.target.className == 'centerTxt'){
            //             e.preventDefault()
            //         }
            //     }
            // })
            // i.window.addEventListener('paste', async e => {
            //     e.preventDefault()
            //     let clipboardData = e.clipboardData.items
            //     // var val = clipboardData.getData('text');
            //     console.log(clipboardData)
            //     for (let index = 0; index < clipboardData.length; index++) {
            //         let kind = clipboardData[index].getAsFile();
            //         console.log(kind)
            //     }
            // })
            let edui73 = document.getElementsByClassName('edui-for-customImg')[0];
            let edui42 = document.querySelectorAll('.edui-for-indent .edui-button-body')[0];
            let edui41 = document.querySelectorAll('.edui-for-backcolor .edui-button-body')[0];
            let edui744 = document.getElementsByClassName('edui-for-customVideo')[0];
            // console.log(edui42)
            if(edui744){
                edui744.style.position = 'relative'
                edui744.style.overflow = 'unset'
                let img1 = document.createElement('img');
                img1.style.width = '16px'
                img1.style.height = '8px'
                img1.style.position = 'absolute'
                img1.style.top = '-2px'
                img1.style.right = '-8px'
                img1.src = this.newIcon
                edui744.append(img1)
                edui744.addEventListener('click', async e => {
                    let ueditorDocument = this.normalWindow.document;
                    let uploadVideoDom = ueditorDocument.querySelectorAll('.uploadVideo')

                    if(uploadVideoDom && uploadVideoDom.length >= 20){
                        this.$toast('正文视频不能超过20个')
                    }else{
                        this.uploadTitle = '上传视频';
                        this.showWriteUpload = true;
                        this.topPic = false
                        this.needWater = false
                    }
                })
            }
            
            if(edui73){
                edui73.style.position = 'relative'
                edui73.style.overflow = 'unset'
                let img1 = document.createElement('img');
                img1.style.width = '16px'
                img1.style.height = '8px'
                img1.style.position = 'absolute'
                img1.style.top = '-2px'
                img1.style.right = '-8px'
                img1.src = this.newIcon
                let img2 = document.createElement('img');
                img2.style.width = '6px'
                img2.style.height = '4px'
                img2.style.position = 'absolute'
                img2.style.top = '50%'
                img2.style.right = '-8px'
                img2.style.marginTop = '-2px'
                img2.src = this.downIcon
                let div = `<div class="domList"><span></span><p data-index='1'>上传图片</p><p data-index='2'>上传图片并添加水印</p></div>`
                if(this.selectPlatform == 'five_star_sports_cms'){
                    div = `<div class="domList"><span></span><p data-index='1'>上传图片</p></div>`
                }
                // edui73.append(img1)
                // edui73.append(img2)
                edui73.innerHTML += div
                let pDom = document.querySelectorAll('.edui-for-customImg .domList p');
                for (let index = 0; index < pDom.length; index++) {
                    const element = pDom[index];
                    element.addEventListener('click',(e) => {
                        if(e.target.dataset.index == 1){
                            this.uploadTitle = '上传图片';
                            this.showWriteUpload = true;
                            this.topPic = false
                            this.needWater = false
                        }else{
                            this.uploadTitle = '上传图片';
                            this.showWriteUpload = true;
                            this.topPic = false
                            this.needWater = true
                        }
                    })
                }
                // edui73.addEventListener('click',() => {
                //     this.uploadTitle = '上传图片';
                //     this.showWriteUpload = true;
                //     this.topPic = false
                // })
            }
            if(edui42){
                // console.log(123)
                edui42.addEventListener('click',(e) => {
                    console.log(111)
                    let ueditorDocument = this.normalWindow.document;
                    let imgBtnsEdit = ueditorDocument.querySelectorAll('.imgBtnsEdit')
                    console.log(imgBtnsEdit)
                    for (let index = 0; index < imgBtnsEdit.length; index++) {
                        const element = imgBtnsEdit[index];
                        element.parentNode.parentNode.setAttribute('contenteditable', true)
                        element.parentNode.parentNode.setAttribute('data-fileid', element.getAttribute('data-fileid'))
                        element.parentNode.parentNode.classList.add('imgContainer')
                        console.log(element.parentNode.parentNode)
                    }
                })
            }
            if(edui41){
                // console.log(999)
                edui41.addEventListener('click',(e) => {
                    console.log(111)
                    let ueditorDocument = this.normalWindow.document;
                    let imgContainer = ueditorDocument.querySelectorAll('.imgContainer')
                    console.log(imgContainer)
                    for (let index = 0; index < imgContainer.length; index++) {
                        const element = imgContainer[index];
                        let img = element.querySelectorAll('img')[0]
                        let imgBtnsEdit = `<span class="imgBtnsEdit" data-fileid="${element.getAttribute('data-fileid')}"><i>1</i>编辑</span>`
                        let imgBtnsAdd = `<span class="imgBtnsAdd" data-fileid="${element.getAttribute('data-fileid')}"><i>1</i>加水印</span>`
                        let imgBtnsDescribe = `<span class="imgDescribe" data-fileid="${element.getAttribute('data-fileid')}"><i>1</i>图片描述</span>`
                        let centerTxt = `<span data-fileid="${element.getAttribute('data-fileid')}" class="centerTxt"></span>`
                        let imgDom = element.querySelectorAll('.relative')
                        // console.log(img)
                        imgDom[0].innerHTML = ''
                        imgDom[0].append(img)
                        imgDom[0].innerHTML += imgBtnsEdit + imgBtnsAdd + imgBtnsDescribe + centerTxt
                        let txtDom = element.getElementsByClassName('centerTxt')[0]
                        txtDom.setAttribute('contentEditable',false)
                        if(element.querySelectorAll('img')[0].title){
                            txtDom.innerText = element.querySelectorAll('img')[0].title
                        }
                    }
                })
            }
            let eduiEditor = document.getElementsByClassName('edui-editor')[0];
            let edui1_toolbarbox = document.getElementsByClassName('edui-editor-toolbarbox')[0]
            if(eduiEditor) {
                let width = eduiEditor.getBoundingClientRect().width;
                edui1_toolbarbox.style.width = width + 'px'
            }
        },
        closeInput() {
            this.editTitle = false;
            this.renameTitle()
        },
        setNum($event) {
            // console.log(1)
            console.log($event.which)
            if(this.selectPlatform != 'dy') return
            if($event.which != 8 && $event.which != 46 && this.$refs.specialContent.innerText.length >= this.release_config.info.length){
                $event.preventDefault();
            }else{
                if(this.timeInterval){
                    clearTimeout(this.timeInterval)
                }

                this.timeInterval = null;

                this.timeInterval = setTimeout(() => {
                    console.log(this.$refs.specialContent.innerHTML)
                    if(this.$refs.specialContent.innerText.length > this.release_config.info.length){
                        this.$refs.specialContent.innerText = this.$refs.specialContent.innerText.substr(0,this.release_config.info.length) 
                    }
                    // this.videoSummary = this.$refs.specialContent.innerHTML;
                    this.materialList[this.articleId].title = this.$refs.specialContent.innerText || '无作品描述'
                    this.topicNumber = this.$refs.specialContent.innerText.length;
                    if(this.selectPlatform != 'dy') return
                    this.mediaPublishDetail.platforms.forEach(el => {
                        el.list.forEach(val => {
                            if(val.id == this.articleId){
                                val.title = this.$refs.specialContent.innerText
                            }
                        })
                    })
                });
            }
            // console.log(this.$refs.specialContent.innerText)
        },
        addTopic() {
            if(this.canAddTopic){
                this.canAddTopic = false;
                let topicNum = this.topicNum;
                let content = `<em data-topic="${topicNum}" contenteditable="true">#</em>`;
                this.$refs.specialContent.focus();
                this.insertHtml(content)
            }
        },
        insertHtml(html) {
            var sel, range, frag
            if (window.getSelection) {
                sel = window.getSelection()
                if (sel.getRangeAt && sel.rangeCount) {
                    range = sel.getRangeAt(0)
                    range.deleteContents()
                    var el = document.createElement('div')
                    el.innerHTML = html
                    frag = document.createDocumentFragment()
                    var node
                    var lastNode
                    while ((node = el.firstChild)) {
                        lastNode = frag.appendChild(node)
                    } range.insertNode(frag)
                    if (lastNode) {
                        range = range.cloneRange()
                        range.setStartAfter(lastNode)
                        range.collapse(true)
                        sel.removeAllRanges()
                        sel.addRange(range)
                    }
                }
            }
        },
        closeMiniUpload() {
            // this.showMiniUpload = false;
        },
        closeWater() {
            this.showSelect = false;
        },
        closeWater1() {
            this.showSelect1 = false;
        },
        backXnews() {
            this.$router.push({
                path: "/index"
            });
        },
        showLargeVideo() {
            this.$refs.video.pause();
            this.showPlayBtn = true;
            this.showLarge = true
        },
        cancelUpload(id) {
            this.$refs.mediaPublishUpload.cancelOne(id)
            this.showEmpty = false;
            this.showVideo = false;
            this.showUpload = true;
            this.showProgress = false;
        },
        cancelNewUpload(id) {
            if(this.mediaType == 8){
                this.$refs.audioUpload.cancelOne(id)
            }else if(this.mediaType == 7){
                this.$refs.imgUpload.cancelOne(id)
            }else{
                this.$refs.preWaterUpload.cancelOne(id)
            }
            
            this.showEmpty = false;
            this.showVideo = false;
            this.showUpload = true;
            this.showProgress = false;
        },
        share() {
            this.$MediaPlatformShare(this.articleId)
        },
        async reviewMedia(item) {
            // console.log(this.articleDetail.platforms,item)
            if(this.articleDetail.platforms[0].p_key == 'new_media_knews' || this.articleDetail.platforms[0].p_key == 'five_star_sports_cms'){
                await this.autoSaveNoLoad()
                this.$PreviewKnews(item.id)
            }else if(this.articleDetail.platforms[0].p_key == 'bilibili'){
                await this.autoSaveNoLoad()
                this.$PreviewBili(item.id)
            }else{
                let platform = this.articleDetail.platforms[0].p_title+'-'+this.articleDetail.platforms[0].c_title
                let info = {
                    title: item.title,
                    info: item.info,
                    raw_update_time: '',
                    platform_title: platform,
                    video_url: this.videoDetail.content && this.videoDetail.content.url || '',
                    platformType: this.articleDetail.platforms[0].p_key,
                    content: this.normalContent || '',
                    type: this.mediaType,
                    has_copyright: this.bqIndex,
                    push_third_publish: this.push_third_publish
                }
                this.$PreviewBox(info)
            }
        },
        async checkSubmit() {
            if(this.disabledSavedBtn) return

            this.disabledSavedBtn = true
            // console.log(999)
            if(this.selectPlatform == 'dy'){
                this.videoSummary = this.$refs.specialContent.innerHTML;
            }
            let columnArr = []
            let errStatus = false;
            let errWord = []
            this.mediaPublishDetail.platforms.forEach(el => {
                columnArr.push(el.p_title+'-'+el.c_title)
                if(el.status == false){
                    errStatus = true
                    errWord.push(el.p_title+'-'+el.c_title)
                }
            })

            let hasVideoTrans = false;

            if(this.mediaType == 6 && this.selectPlatform == 'five_star_sports_cms'){ 
                let video = this.normalWindow.document.querySelectorAll('body .uploadVideo')
                if(video && video.length > 0){
                    video.forEach(el => {
                        let fileid = el.getAttribute('data-fileid')
                        this.mediaPublishDetail.files.forEach(el => {
                            console.log(el.id)
                            if(el.type == 2 && !el.transcode_finish && el.id == fileid){
                                hasVideoTrans = true
                            }
                        })
                    })
                }
                
            }

            if(hasVideoTrans){
                let config = {
                    title: '温馨提示',
                    content: '需要等待视频转码完成才可发布',
                    btn1: '确定',
                    btn2: '取消',
                    showIcon: false
                }
                this.$MediaPlatformNotify(config)
                
                this.disabledSavedBtn = false

                return false;
            }

            if(errStatus){
                errWord = errWord.join(',')
                let config = {
                    title: '温馨提示',
                    content: errWord+'已停用，请删除平台后发布',
                    btn1: '确定',
                    btn2: '取消',
                    showIcon: false
                }
                this.$MediaPlatformNotify(config)

                this.disabledSavedBtn = false
            }else{

                columnArr = columnArr.join(',')

                if(this.articleId){
                    if(this.isSubmitUpload){
                        let contents = []

                        if(this.mediaType == 6){
                            this.materialList[this.articleId].content = this.normalContent
                        }

                        if(this.selectPlatform == 'new_media_knews'){
                            this.materialList[this.articleId].editor = this.editor
                            this.materialList[this.articleId].responsible_editor = this.responsible_editor
                            this.materialList[this.articleId].video_editor = this.video_editor
                            this.materialList[this.articleId].art_editor = this.art_editor
                            this.materialList[this.articleId].cameraman = this.cameraman
                            this.materialList[this.articleId].courier = this.courier
                        }

                        if(this.selectPlatform == 'five_star_sports_cms'){
                            this.materialList[this.articleId].editor = this.editor
                            if(this.mediaType == 6){
                                this.materialList[this.articleId].content = this.normalWindow.document.querySelector('body').innerHTML
                            }
                        }

                        contents.push(this.materialList[this.articleId])

                        contents = JSON.stringify(contents)

                        let contentsInfo = {
                            submit_action: 'save',
                            contents,
                            status: this.mediaPublishDetail.status == 1 ? 1 : 0
                        }

                        common
                        .myFetch(apis.newMediaPlatformEdit, contentsInfo)
                        .then(r => {
                            if (r) {
                                let info = {
                                    id: this.id
                                }
                                common.myFetch(apis.newMediaPlatformReleasecheck, info).then(res => {
                                    if(res){
                                        this.disabledSavedBtn = false
                                        if(res.showErr){
                                            this.errMsg = res.msg
                                            this.showPreTipsContent = true
                                        }else if(res.needReBind){
                                            let p_key = JSON.parse(this.materialList[this.articleId].push_platform)[0].p_key
                                            this.$MediaPlatformAccount(p_key)
                                        }else{
                                            if(this.mediaPublishDetail.status == 1 && this.selectPlatform == 'dy' && this.is_last_audit == 1 && this.articleDetail.has_dy_btn == 0){
                                                this.$ConfirmDy({title: this.articleDetail.title,column: this.articleDetail.platforms[0].c_title}).then(res => {
                                                    if(res){
                                                        this.releaseArticle()
                                                    }
                                                })
                                            }else if(this.mediaPublishDetail.status == 1 && this.selectPlatform != 'dy' && this.is_last_audit == 1){
                                                // console.log(this.articleDetail.platforms[0])
                                                this.$auditDialog({type: 'notice', title: '温馨提示', content1: '<span>'+this.articleDetail.title+'</span>'+'将被推送至'+'<span>'+this.articleDetail.platforms[0].p_title+'-'+this.articleDetail.platforms[0].c_title+'</span>', content2: '', btn1: '确定通过', btn2: '取消'}).then(res => {
                                                    if(res){
                                                        this.releaseArticle()
                                                    }
                                                })
                                            }else{
                                                this.showTips()
                                            }
                                        }
                                    }
                                })
                            }
                        });
                    }else{
                        let contents = []

                        if(this.mediaType == 6){
                            this.materialList[this.articleId].content = this.normalContent
                        }

                        if(this.selectPlatform == 'new_media_knews'){
                            this.materialList[this.articleId].editor = this.editor
                            this.materialList[this.articleId].responsible_editor = this.responsible_editor
                            this.materialList[this.articleId].video_editor = this.video_editor
                            this.materialList[this.articleId].art_editor = this.art_editor
                            this.materialList[this.articleId].cameraman = this.cameraman
                            this.materialList[this.articleId].courier = this.courier
                        }

                        if(this.selectPlatform == 'five_star_sports_cms'){
                            this.materialList[this.articleId].editor = this.editor
                            if(this.mediaType == 6){
                                this.materialList[this.articleId].content = this.normalWindow.document.querySelector('body').innerHTML
                            }
                        }

                        contents.push(this.materialList[this.articleId])

                        contents = JSON.stringify(contents)

                        let contentsInfo = {
                            submit_action: 'save',
                            contents,
                            status: this.mediaPublishDetail.status == 1 ? 1 : 0
                        }

                        common
                        .myFetch(apis.newMediaPlatformEdit, contentsInfo)
                        .then(r => {
                            if (r) {
                                let info = {
                                    id: this.id
                                }
                                common.myFetch(apis.newMediaPlatformReleasecheck, info).then(res => {
                                    if(res){
                                        this.disabledSavedBtn = false
                                        if(res.showErr){
                                            this.errMsg = res.msg
                                            this.showPreTipsContent = true
                                        }else if(res.needReBind){
                                            let p_key = JSON.parse(this.materialList[this.articleId].push_platform)[0].p_key
                                            this.$MediaPlatformAccount(p_key)
                                        }else{
                                            if(this.mediaPublishDetail.status == 1 && this.selectPlatform == 'dy' && this.is_last_audit == 1 && this.articleDetail.has_dy_btn == 0){
                                                this.$ConfirmDy({title: this.articleDetail.title,column: this.articleDetail.platforms[0].c_title}).then(res => {
                                                    if(res){
                                                        this.releaseArticle()
                                                    }
                                                })
                                            }else if(this.mediaPublishDetail.status == 1 && this.selectPlatform != 'dy' && this.is_last_audit == 1){
                                                // console.log(this.articleDetail.platforms[0])
                                                this.$auditDialog({type: 'notice', title: '温馨提示', content1: '<span>'+this.articleDetail.title+'</span>'+'将被推送至'+'<span>'+this.articleDetail.platforms[0].p_title+'-'+this.articleDetail.platforms[0].c_title+'</span>', content2: '', btn1: '确定通过', btn2: '取消'}).then(res => {
                                                    if(res){
                                                        this.releaseArticle()
                                                    }
                                                })
                                            }else{
                                                this.showTips()
                                            }
                                        }
                                    }
                                })
                            }
                        });
                    }
                }else{
                    this.showPreTipsContent = true;
                    this.errMsg = '检查到平台内并没有稿件，请先添加稿件'
                    this.disabledSavedBtn = false
                    // this.$toast('检测到平台没有稿件，请先添加稿件')
                }
            }
        },
        async releaseArticle() {
            if(this.selectPlatform == 'dy'){
                this.videoSummary = this.$refs.specialContent.innerHTML;
            }
            let columnArr = []
            let errStatus = false;
            let errWord = []
            this.mediaPublishDetail.platforms.forEach(el => {
                columnArr.push(el.p_title+'-'+el.c_title)
                if(el.status == false){
                    errStatus = true
                    errWord.push(el.p_title+'-'+el.c_title)
                }
            })
            if(errStatus){
                errWord = errWord.join(',')
                let config = {
                    title: '温馨提示',
                    content: errWord+'已停用，请删除平台后发布',
                    btn1: '确定',
                    btn2: '取消',
                    showIcon: false
                }
                this.$MediaPlatformNotify(config)
            }else{
                if(this.autoSaveInterval){
                    clearInterval(this.autoSaveInterval)
                    this.autoSaveInterval = null
                }

                columnArr = columnArr.join(',')

                if(this.articleId){
                    if(this.isSubmitUpload){
                        let contents = []

                        if(this.mediaType == 6){
                            this.materialList[this.articleId].content = this.normalContent

                            if(this.selectPlatform == 'five_star_sports_cms'){
                                this.materialList[this.articleId].content = this.normalWindow.document.querySelector('body').innerHTML
                            }
                        }

                        contents.push(this.materialList[this.articleId])

                        contents = JSON.stringify(contents)

                        let contentsInfo = {
                            submit_action: 'save',
                            contents,
                            status: this.mediaPublishDetail.status == 1 ? 1 : 0
                        }

                        common
                        .myFetch(apis.newMediaPlatformEdit, contentsInfo)
                        .then(r => {
                            if (r) {
                                let info = {
                                    id: this.id
                                }

                                let info1 = {
                                    status: 0,
                                    content: JSON.stringify([{id: this.id,remark: ""}])
                                }

                                if(this.mediaPublishDetail.status == 1){
                                    common
                                    .myFetch(apis.newMediaVerify, info1)
                                    .then(r => {
                                        console.log(r)
                                        if (r) {
                                            if(r.needReBind){
                                                this.setAutoSave()
                                                let p_key = JSON.parse(this.materialList[this.articleId].push_platform)[0].p_key
                                                this.$MediaPlatformAccount(p_key)
                                                // this.$BPlus(p_key)
                                            }else{
                                                if(this.autoSaveInterval){
                                                    clearInterval(this.autoSaveInterval)
                                                    this.autoSaveInterval = null
                                                }

                                                const successInfo = {
                                                    msg: "提交成功",
                                                    tip: "页面即将关闭"
                                                };

                                                this.$refs.successTip.open(successInfo);
                                            }
                                        }
                                    });
                                }else{
                                    common
                                    .myFetch(apis.newMediaPlatformRelease, info)
                                    .then(r => {
                                        console.log(r)
                                        if (r) {
                                            if(r.needReBind){
                                                this.setAutoSave()
                                                let p_key = JSON.parse(this.materialList[this.articleId].push_platform)[0].p_key
                                                this.$MediaPlatformAccount(p_key)
                                                // this.$BPlus(p_key)
                                            }else{
                                                if(this.autoSaveInterval){
                                                    clearInterval(this.autoSaveInterval)
                                                    this.autoSaveInterval = null
                                                }
                                                
                                                const successInfo = {
                                                    msg: "提交成功",
                                                    tip: "页面即将关闭"
                                                };

                                                this.$refs.successTip.open(successInfo);
                                            }
                                        }
                                    });
                                }
                            }
                        });
                    }else{
                        // let config = {
                        //     title: '温馨提示',
                        //     content: '此次内容将发布至'+columnArr+'，是否继续？',
                        //     btn1: '确定',
                        //     btn2: '取消',
                        //     showIcon: false
                        // }
                        // this.$MediaPlatformNotify(config).then(e => {
                            // if(e) {
                                let contents = []

                                if(this.mediaType == 6){
                                    this.materialList[this.articleId].content = this.normalContent
                                
                                    if(this.selectPlatform == 'five_star_sports_cms'){
                                        this.materialList[this.articleId].content = this.normalWindow.document.querySelector('body').innerHTML
                                    }
                                }

                                contents.push(this.materialList[this.articleId])

                                contents = JSON.stringify(contents)

                                let contentsInfo = {
                                    submit_action: 'save',
                                    contents,
                                    status: this.mediaPublishDetail.status == 1 ? 1 : 0
                                }

                                common
                                .myFetch(apis.newMediaPlatformEdit, contentsInfo)
                                .then(r => {
                                    if (r) {
                                        let info = {
                                            id: this.id
                                        }

                                        let info1 = {
                                            status: 0,
                                            content: JSON.stringify([{id: this.id,remark: ""}])
                                        }

                                        if(this.mediaPublishDetail.status == 1){
                                            common
                                            .myFetch(apis.newMediaVerify, info1)
                                            .then(r => {
                                                console.log(r)
                                                if (r) {
                                                    if(r.needReBind){
                                                        this.setAutoSave()
                                                        let p_key = JSON.parse(this.materialList[this.articleId].push_platform)[0].p_key
                                                        this.$MediaPlatformAccount(p_key)
                                                        // this.$BPlus(p_key)
                                                    }else{
                                                        if(this.autoSaveInterval){
                                                            clearInterval(this.autoSaveInterval)
                                                            this.autoSaveInterval = null
                                                        }
                                                        const successInfo = {
                                                            msg: "提交成功",
                                                            tip: "页面即将关闭"
                                                        };

                                                        this.$refs.successTip.open(successInfo);
                                                    }
                                                }
                                            });
                                        }else{
                                            common
                                            .myFetch(apis.newMediaPlatformRelease, info)
                                            .then(r => {
                                                console.log(r)
                                                if (r) {
                                                    if(r.needReBind){
                                                        this.setAutoSave()
                                                        let p_key = JSON.parse(this.materialList[this.articleId].push_platform)[0].p_key
                                                        this.$MediaPlatformAccount(p_key)
                                                        // this.$BPlus(p_key)
                                                    }else{
                                                        if(this.autoSaveInterval){
                                                            clearInterval(this.autoSaveInterval)
                                                            this.autoSaveInterval = null
                                                        }
                                                        const successInfo = {
                                                            msg: "提交成功",
                                                            tip: "页面即将关闭"
                                                        };

                                                        this.$refs.successTip.open(successInfo);
                                                    }
                                                }
                                            });
                                        }
                                    }
                                });
                            // }
                        // })
                    }
                }else{
                    if(this.isSubmitUpload){
                        let info = {
                            id: this.id
                        }

                        let info1 = {
                            status: 0,
                            content: JSON.stringify([{id: this.id,remark: ""}])
                        }

                        if(this.mediaPublishDetail.status == 1){
                            common
                            .myFetch(apis.newMediaVerify, info1)
                            .then(r => {
                                if (r) {
                                    if(r.needReBind){
                                        this.setAutoSave()
                                        let p_key = JSON.parse(this.materialList[this.articleId].push_platform)[0].p_key
                                        this.$MediaPlatformAccount(p_key)
                                        // this.$BPlus(p_key)
                                    }else{
                                        if(this.autoSaveInterval){
                                            clearInterval(this.autoSaveInterval)
                                            this.autoSaveInterval = null
                                        }
                                        const successInfo = {
                                            msg: "提交成功",
                                            tip: "页面即将关闭"
                                        };

                                        this.$refs.successTip.open(successInfo);
                                    }
                                }
                            });
                        }else{
                            common
                            .myFetch(apis.newMediaPlatformRelease, info)
                            .then(r => {
                                if (r) {
                                    if(r.needReBind){
                                        this.setAutoSave()
                                        let p_key = JSON.parse(this.materialList[this.articleId].push_platform)[0].p_key
                                        this.$MediaPlatformAccount(p_key)
                                        // this.$BPlus(p_key)
                                    }else{
                                        if(this.autoSaveInterval){
                                            clearInterval(this.autoSaveInterval)
                                            this.autoSaveInterval = null
                                        }
                                        const successInfo = {
                                            msg: "提交成功",
                                            tip: "页面即将关闭"
                                        };

                                        this.$refs.successTip.open(successInfo);
                                    }
                                }
                            });
                        }
                    }else{
                        let config = {
                            title: '温馨提示',
                            content: '此次内容将发布至'+columnArr+'，是否继续？',
                            btn1: '确定',
                            btn2: '取消',
                            showIcon: false
                        }
                        this.$MediaPlatformNotify(config).then(e => {
                            console.log(e)
                            if(e) {
                                let info = {
                                    id: this.id
                                }

                                let info1 = {
                                    status: 0,
                                    content: JSON.stringify([{id: this.id,remark: ""}])
                                }

                                if(this.mediaPublishDetail.status == 1){
                                    common
                                    .myFetch(apis.newMediaVerify, info1)
                                    .then(r => {
                                        if (r) {
                                            if(r.needReBind){
                                                this.setAutoSave()
                                                let p_key = JSON.parse(this.materialList[this.articleId].push_platform)[0].p_key
                                                this.$MediaPlatformAccount(p_key)
                                                // this.$BPlus(p_key)
                                            }else{
                                                if(this.autoSaveInterval){
                                                    clearInterval(this.autoSaveInterval)
                                                    this.autoSaveInterval = null
                                                }
                                                const successInfo = {
                                                    msg: "提交成功",
                                                    tip: "页面即将关闭"
                                                };

                                                this.$refs.successTip.open(successInfo);
                                            }
                                        }
                                    });
                                }else{
                                    common
                                    .myFetch(apis.newMediaPlatformRelease, info)
                                    .then(r => {
                                        if (r) {
                                            if(r.needReBind){
                                                this.setAutoSave()
                                                let p_key = JSON.parse(this.materialList[this.articleId].push_platform)[0].p_key
                                                this.$MediaPlatformAccount(p_key)
                                                // this.$BPlus(p_key)
                                            }else{
                                                if(this.autoSaveInterval){
                                                    clearInterval(this.autoSaveInterval)
                                                    this.autoSaveInterval = null
                                                }
                                                const successInfo = {
                                                    msg: "提交成功",
                                                    tip: "页面即将关闭"
                                                };

                                                this.$refs.successTip.open(successInfo);
                                            }
                                        }
                                    });
                                }
                            }
                        })
                    }
                }
            }
        },
        uploadSave() {
            return new Promise((resolve, reject) => {
                let contents = []

                for( let key in this.materialList) {
                    contents.push(this.materialList[key])
                }

                if(contents.length > 0){
                    if(this.selectPlatform == 'dy'){
                        this.videoSummary = this.$refs.specialContent.innerHTML;
                    }
                    contents = JSON.stringify(contents)

                    let info = {
                        submit_action: 'save',
                        contents,
                        status: this.mediaPublishDetail.status == 1 ? 1 : 0
                    }

                    common
                    .myFetch(apis.newMediaPlatformEdit, info)
                    .then(r => {
                        if (r) {
                            resolve(true)
                            this.getCover()
                        }
                    });
                }  
            })
        },
        saveArticle() {
            // console.log(this.materialList)
            if(this.disabledSavedBtn) return
            let contents = []

            if(this.selectPlatform == 'new_media_knews'){
                this.materialList[this.articleId].editor = this.editor
                this.materialList[this.articleId].responsible_editor = this.responsible_editor
                this.materialList[this.articleId].video_editor = this.video_editor
                this.materialList[this.articleId].art_editor = this.art_editor
                this.materialList[this.articleId].cameraman = this.cameraman
                this.materialList[this.articleId].courier = this.courier
            }

            if(this.selectPlatform == 'five_star_sports_cms'){
                this.materialList[this.articleId].editor = this.editor
                if(this.mediaType == 6){
                    this.materialList[this.articleId].content = this.normalWindow.document.querySelector('body').innerHTML
                }
            }

            this.$nextTick(() => {
                for( let key in this.materialList) {
                    contents.push(this.materialList[key])
                }

                if(contents.length > 0){
                    if(this.selectPlatform == 'dy'){
                        this.videoSummary = this.$refs.specialContent.innerHTML;
                    }
                    let config = {
                        title: '是否保存当前所有稿件至草稿箱？',
                        content: '',
                        btn1: '保存',
                        btn2: '不保存',
                        showIcon: true
                    }
                    if(this.mediaPublishDetail.status == 1){
                        config = {
                            title: '是否保存并覆盖原稿件？',
                            content: '',
                            btn1: '保存',
                            btn2: '不保存',
                            showIcon: true
                        }
                    }
                    this.$MediaPlatformNotify(config).then(e => {
                        console.log(e)
                        if(e) {
                            contents = JSON.stringify(contents)

                            let info = {
                                submit_action: 'save',
                                contents,
                                status: this.mediaPublishDetail.status == 1 ? 1 : 0
                            }

                            common
                            .myFetch(apis.newMediaPlatformEdit, info)
                            .then(r => {
                                if (r) {
                                    console.log(r)
                                    this.$toast(r)
                                }
                            });
                        }
                    })
                }else{
                    this.$toast('请先编辑稿件')
                }
            })
        },
        handleAutoLock() {
            let info = {
                id: this.id
            }

            common
            .myFetch(apis.newMediaLock, {data: info,hideLoading: true})
            .then(r => {
                if (r) {
                    // this.showSaveTip()
                }
            });
        },
        handleAutoSave() {
            if(this.articleId){

                if(this.selectPlatform == 'dy'){
                    this.materialList[this.articleId].title = this.$refs.specialContent.innerText;
                    this.materialList[this.articleId].info = this.$refs.specialContent.innerHTML;
                }

                if(this.mediaType == 6){
                    this.materialList[this.articleId].content = this.normalContent;

                    if(this.selectPlatform == 'five_star_sports_cms') {
                        this.materialList[this.articleId].content = this.normalWindow.document.querySelector('body').innerHTML
                    }
                }

                let contents = []

                contents.push(this.materialList[this.articleId])

                contents = JSON.stringify(contents)

                let info = {
                    submit_action: 'auto',
                    contents,
                    status: this.mediaPublishDetail.status == 1 ? 1 : 0
                }

                common
                .myFetch(apis.newMediaPlatformEdit, {data: info, hideLoading: true})
                .then(r => {
                    if (r) {
                        this.showSaveTip()
                    }
                });
            }
        },
        handleSaved() {
            if(this.articleId){

                if(this.selectPlatform == 'dy'){
                    this.materialList[this.articleId].title = this.$refs.specialContent.innerText;
                    this.materialList[this.articleId].info = this.$refs.specialContent.innerHTML;
                }

                if(this.mediaType == 6){
                    this.materialList[this.articleId].content = this.normalContent;

                    if(this.selectPlatform == 'five_star_sports_cms'){
                        this.materialList[this.articleId].content = this.normalWindow.document.querySelector('body').innerHTML
                    }
                }

                // this.materialList[this.articleId].from = this.source;

                this.$nextTick(() => {
                    let contents = []

                    contents.push(this.materialList[this.articleId])

                    contents = JSON.stringify(contents)

                    let info = {
                        submit_action: 'save',
                        contents,
                        status: this.mediaPublishDetail.status == 1 ? 1 : 0
                    }

                    common
                    .myFetch(apis.newMediaPlatformEdit, {data: info, hideLoading: true})
                    .then(r => {
                        if (r) {
                            this.showSaveTip()
                        }
                    });
                })
                
            }
        },
        autoSaveNoLoad(id,platform,column) {
            console.log(this.articleId)
            // this.videoDetail = {}
            if(this.selectPlatform == 'dy' && this.articleId){
                console.log(this.$refs.specialContent.innerHTML)
                this.materialList[this.articleId].info = this.$refs.specialContent.innerHTML;
            }
            if(this.mediaType == 6 && this.articleId){
                this.materialList[this.articleId].content = this.normalContent;

                if(this.selectPlatform == 'five_star_sports_cms') {
                    this.materialList[this.articleId].content = this.normalWindow.document.querySelector('body').innerHTML
                }
            }
            this.tagInput = ''
            if(platform){
                this.selectPlatform = platform
            }
            if(column){
                this.selectColumn = column
            }
            if(this.articleId){
                let contents = []

                contents.push(this.materialList[this.articleId])

                contents = JSON.stringify(contents)

                let info = {
                    submit_action: 'auto',
                    contents,
                    status: this.mediaPublishDetail.status == 1 ? 1 : 0
                }

                common
                .myFetch(apis.newMediaPlatformEdit, info)
                .then(r => {
                    if (r) {
                        console.log(r)
                        if(this.selectPlatform == 'dy'){
                            this.$refs.specialContent.innerHTML = '';
                            // this.videoSummary = ''
                        }
                    }
                });
            }
        },
        autoSave(id,platform,column,type) {
            console.log('autoSave', id, platform, column, type)
            // console.log(this.selectPlatform)
            if(id == this.articleId) return
            if(this.autoClickInterval){
                clearTimeout(this.autoClickInterval)
            }

            this.autoClickInterval = setTimeout(() => {
                if(this.timeInterval){
                    clearTimeout(this.timeInterval)
                }
                if(this.autoSaveInterval){
                    clearInterval(this.autoSaveInterval)
                    this.autoSaveInterval = null
                }
                this.videoDetail = {}
                if(this.selectPlatform == 'new_media_knews'){
                    
                    if(type == 6){
                        this.materialList[this.articleId].editor = this.editor
                    }
                    
                    this.materialList[this.articleId].responsible_editor = this.responsible_editor
                    this.materialList[this.articleId].video_editor = this.video_editor
                    this.materialList[this.articleId].art_editor = this.art_editor
                    this.materialList[this.articleId].cameraman = this.cameraman
                    this.materialList[this.articleId].courier = this.courier
                }
                if(this.selectPlatform == 'dy' && this.articleId){
                    console.log(this.$refs.specialContent.innerHTML)
                    this.materialList[this.articleId].title = this.$refs.specialContent.innerText;
                    this.materialList[this.articleId].info = this.$refs.specialContent.innerHTML;
                }
                if(this.mediaType == 6 && this.articleId){
                    this.materialList[this.articleId].content = this.normalContent;

                    if(this.selectPlatform == 'five_star_sports_cms') {
                        this.materialList[this.articleId].content = this.normalWindow.document.querySelector('body').innerHTML
                    }
                }
                this.tagInput = ''
                if(platform){
                    this.selectPlatform = platform
                }
                if(column){
                    this.selectColumn = column
                }
                if(this.articleId){
                    this.firstClick = false;
                    let contents = []

                    contents.push(this.materialList[this.articleId])

                    contents = JSON.stringify(contents)

                    let info = {
                        submit_action: 'save',
                        contents,
                        status: this.mediaPublishDetail.status == 1 ? 1 : 0
                    }

                    common
                    .myFetch(apis.newMediaPlatformEdit, info)
                    .then(r => {
                        if (r) {
                            console.log('t-1209', r)
                            if(this.selectPlatform == 'dy'){
                                this.$refs.specialContent.innerHTML = '';
                                // this.videoSummary = ''
                            }
                            this.getArticle(id)
                        }
                    });
                }else{
                            console.log('t-1209222222')

                    this.firstClick = false;
                    this.getArticle(id)
                }
            }, 300);
            // console.log(this.articleId)
        },
        setCover(file_id,cover) {
            let title = cover.split('/')
            title = title[title.length - 1]
            let config = {
                id: this.id,
                url: cover,
                title: title,
                type: this.selectPlatform
            }
            this.$MediaPlatformPhoto(config).then(e => {
                console.log(e)
                if(e) {
                    let info = {
                        id: this.articleId,
                        file_id: e.list[0].file_id,
                        delete_file_id: file_id
                    }
                    common
                    .myFetch(apis.newMediaPlatformSetCover, info)
                    .then(r => {
                        if (r) {
                            this.cover = e.list[0].cover
                            this.getPlatform()
                            console.log(r)
                        }
                    });
                }else{
                    // let info = {
                    //     id: this.articleId,
                    //     file_id: file_id
                    // }
                    // common
                    // .myFetch(apis.newMediaPlatformSetCover, info)
                    // .then(r => {
                    //     if (r) {
                    //         this.cover = cover
                    //         this.getPlatform()
                    //         console.log(r)
                    //     }
                    // });
                }
            })
        },
        postComplete(e) {
            this.postCover = e.list[0].cover
            this.showPostUpload = false;
            this.setposter(e.list[0].file_id)
        },
        mulCoverComplete(e) {
            // console.log(e)
            if(this.selectPlatform == 'five_star_sports_cms'){
                this.normalInstance.execCommand(
                "inserthtml",
                `<p></p><p data-fileId="${e.list[0].file_id}" contenteditable="false" class="imgContainer"><span contenteditable="false" class='img'><span contenteditable="false" class="relative"><img contenteditable="false" src="${
                    e.list[0].cover
                    }" style="max-width: 100%; height: auto;" draggable="false"/></span></span></span><p></p></p>`
            );
            }else{
                this.normalInstance.execCommand(
                "inserthtml",
                `<p></p><p data-fileId="${e.list[0].file_id}" contenteditable="false" class="imgContainer"><span contenteditable="false" class='img'><span contenteditable="false" class="relative"><img contenteditable="false" src="${
                    e.list[0].cover
                    }" style="max-width: 100%; height: auto;" draggable="false"/><span class="imgBtnsEdit" data-fileId="${e.list[0].file_id}"><i>1</i>编辑</span><span class="imgBtnsAdd" data-fileId="${e.list[0].file_id}"><i>1</i>加水印</span><span class="imgDescribe" data-fileId="${e.list[0].file_id}"><i>1</i>图片描述</span><span contenteditable="false" data-fileId="${e.list[0].file_id}" class=centerTxt></span></span></span></span><p></p></p>`
            );
            }
        },
        mulCoverAllComplete() {
            
            this.showWriteUpload = false;
            this.topPic = false

            if(this.mulCoverInterval){
                clearTimeout(this.mulCoverInterval)
                this.mulCoverInterval = null
            }

            this.mulCoverInterval = setTimeout(() => {
                this.getPlatform()
            }, 500);
        },
        coverComplete(e) {
            console.log(e.list[0],this.mediaType,this.showWriteUpload,this.topPic)
            if(this.mediaType == 6 && this.showWriteUpload && !this.topPic){
                if(this.needWater){
                    this.$WaterEdit(this.selectPlatform).then(el => {
                        if(el) {
                            el.file_id = e.list[0].file_id
                            el.id = this.$route.query.d
                            common
                            .myFetch(apis.addwatermark, el)
                            .then(r => {
                                if (r) {
                                    console.log(r)
                                    this.normalInstance.execCommand(
                                        "inserthtml",
                                        `<p></p><p data-fileId="${r.id}" contenteditable="false" class="imgContainer"><span contenteditable="false" class='img'><span contenteditable="false" class="relative"><img contenteditable="false" src="${
                                            r.url
                                            }" style="max-width: 100%; height: auto;" draggable="false"/><span class="imgBtnsEdit" data-fileId="${r.id}"><i>1</i>编辑</span><span class="imgBtnsAdd" data-fileId="${r.id}"><i>1</i>加水印</span><span class="imgDescribe" data-fileId="${r.id}"><i>1</i>图片描述</span><span contenteditable="false" data-fileId="${r.id}" class=centerTxt></span></span></span></span><p></p></p>`
                                    );
                                    this.getPlatform()
                                    this.showWriteUpload = false;
                                    this.topPic = false
                                }
                            });
                        }else{
                            this.showWriteUpload = false;
                            this.topPic = false
                        }
                    })
                }else{
                    if(this.selectPlatform == 'five_star_sports_cms'){
                        this.normalInstance.execCommand(
                        "inserthtml",
                        `<p></p><p data-fileId="${e.list[0].file_id}" contenteditable="false" class="imgContainer"><span contenteditable="false" class='img'><span contenteditable="false" class="relative"><img contenteditable="false" src="${
                            e.list[0].cover
                            }" style="max-width: 100%; height: auto;" draggable="false"/></span></span></span><p></p></p>`
                    );
                    }else{
                        this.normalInstance.execCommand(
                        "inserthtml",
                        `<p></p><p data-fileId="${e.list[0].file_id}" contenteditable="false" class="imgContainer"><span contenteditable="false" class='img'><span contenteditable="false" class="relative"><img contenteditable="false" src="${
                            e.list[0].cover
                            }" style="max-width: 100%; height: auto;" draggable="false"/><span class="imgBtnsEdit" data-fileId="${e.list[0].file_id}"><i>1</i>编辑</span><span class="imgBtnsAdd" data-fileId="${e.list[0].file_id}"><i>1</i>加水印</span><span class="imgDescribe" data-fileId="${e.list[0].file_id}"><i>1</i>图片描述</span><span contenteditable="false" data-fileId="${e.list[0].file_id}" class=centerTxt></span></span></span></span><p></p></p>`
                    );
                    }
                    
                    this.getPlatform()
                    this.showWriteUpload = false;
                    this.topPic = false
                }
                this.needWater = false;
            }else if(this.mediaType == 6 && this.showWriteUpload && this.topPic){
                this.top_video_cover = e.list[0].cover
                this.videoDetail.cover = e.list[0].cover
                this.getPlatform()
                this.showWriteUpload = false;
                this.topPic = false
            }else{
                this.setCover(e.list[0].file_id,e.list[0].cover)
            }
        },
        mulCoverUpload() {
            if(this.libraryMediaList && this.libraryMediaList.length > 0) {
                // 有统一内容库权限
                this.libraryDirInstance.open({
                    folderType: '0'
                }).then(res=>{
                    this.libraryDirInfo = res
                    let btn = document.getElementById('httpUpBtn11');
                    btn.click()
                })
            }else {
                let btn = document.getElementById('httpUpBtn11');
                btn.click()
            }
        },
        coverUpload() {
            if(this.libraryMediaList && this.libraryMediaList.length > 0) {
                // 有统一内容库权限
                this.libraryDirInstance.open({
                    folderType: '0'
                }).then(res=>{
                    this.libraryDirInfo = res
                    let btn = document.getElementById('httpUpBtn1');
                    btn.click()
                })
            }else {
                let btn = document.getElementById('httpUpBtn1');
                btn.click()
            }
        },
        postUpload() {
            
            if(this.libraryMediaList && this.libraryMediaList.length > 0) {
                // 有统一内容库权限
                this.libraryDirInstance.open({
                    folderType: '0'
                }).then(res=>{
                    this.libraryDirInfo = res
                    let btn = document.getElementById('httpUpBtn2');
                    btn.click()
                })
            }else {
                let btn = document.getElementById('httpUpBtn2');
                btn.click()
            }
        },
        delTag(index) {
            this.tags = this.tags.filter((el,key) => {
                return index != key
            })
        },
        tagClick() {
            if(this.tagInput){
                this.tags.push(this.tagInput)
                this.tagInput = ''
            }
        },
        setRate(rate) {
            this.rateSpeed = rate
            if(this.mediaType == 8){
                this.$refs.audio.playbackRate = rate
            }else{
                this.$refs.video.playbackRate = rate
            }
            
            this.showRate = false
        },
        
        playVideo() {
            if(this.mediaType == 8){
                this.$refs.audio.play()
            }else{
                this.$refs.video.play()
            }
            
            this.showPlayBtn = false
        },
        pauseVideo() {
            if(this.mediaType == 8){
                this.$refs.audio.pause()
            }else{
                this.$refs.video.pause()
            }
            
            this.showPlayBtn = true
        },
        delAssert(idstring) {
            let info = {
                subject_id: this.id,
                subject_type: 5,
                idstring: idstring
            }
            common
            .myFetch(apis.File_delete, info)
            .then(r => {
                if (r) {
                    this.getPlatform()
                }
            });
        },
        insertImg(id){
            let data=id;
            this.mediaPublishDetail.files.forEach(el => {
                if(el.id == data){
                    // console.log(el)
                    let info = {
                        file_ids: el.id,
                        subject_type: 5,
                        subject_id: this.articleId
                    };
                    common.myFetch(apis.File_bind, info).then(r => {
                        if (r) {
                            if(this.selectPlatform == 'five_star_sports_cms'){
                                this.normalInstance.execCommand(
                                    "inserthtml",
                                    `<p></p><p data-fileId="${el.id}" contenteditable="false" class="imgContainer"><span contenteditable="false" class='img'><span contenteditable="false" class=relative><img contenteditable="false" src="${
                                        el.url
                                        }" style="max-width: 100%; height: auto;" draggable="false"/></span></span></span><p></p></p>`
                                );
                            }else{  
                                this.normalInstance.execCommand(
                                "inserthtml",
                                `<p></p><p data-fileId="${el.id}" contenteditable="false" class="imgContainer"><span contenteditable="false" class='img'><span contenteditable="false" class=relative><img contenteditable="false" src="${
                                    el.url
                                    }" style="max-width: 100%; height: auto;" draggable="false"/><span class="imgBtnsEdit" data-fileId="${el.id}"><i>1</i>编辑</span><span class="imgBtnsAdd" data-fileId="${el.id}"><i>1</i>加水印</span><span class="imgDescribe" data-fileId="${el.id}"><i>1</i>图片描述</span><span contenteditable="false" data-fileId="${el.id}" class=centerTxt></span></span></span></span><p></p></p>`
                            );
                            }
                        }
                    });
                }
            })
        },
        insertVideo(id) {
            let ueditorDocument = this.normalWindow.document;
            let uploadVideoDom = ueditorDocument.querySelectorAll('.uploadVideo')
            if(uploadVideoDom && uploadVideoDom.length >= 20){
                this.$toast('正文视频不能超过20个')
                return
            }
            let data=id;
            this.mediaPublishDetail.files.forEach(el => {
                if(el.id == data){
                    // console.log(el)
                    let info = {
                        file_ids: el.id,
                        subject_type: 5,
                        subject_id: this.articleId
                    };
                    common.myFetch(apis.File_bind, info).then(r => {
                        if (r) {
                            if(this.selectPlatform == 'five_star_sports_cms'){
                                this.normalInstance.execCommand(
                                    "inserthtml",
                                    `<p></p><p data-type="video" data-fileId="${el.id}" contenteditable="true" class="uploadVideo"><video controls controlsList="nodownload" contextmenu="none" src="${el.url}"></video></p><p></p>`
                                );
                            }
                        }
                    });
                }
            })
        },
        changeVideo(id){
            var data=id;

            this.mediaPublishDetail.files.forEach(el => {
                if(el.id == data && el.type == 2){
                    console.log(el)
                    let info = JSON.parse(this.materialList[this.articleId].push_platform)
                    if(info[0].p_key == 'new_media_knews' || info[0].p_key == 'five_star_sports_cms'){
                        let videoInfo = ''
                        if(el.content && el.content.resolution){
                            let arr = el.content.resolution.split('x')
                            if(arr[0] > arr[1]){
                                videoInfo = '16:9'
                            }else{
                                videoInfo = '9:16'
                            }
                        }
                        this.$MediaPlatformWater(this.logoList,videoInfo,this.selectPlatform, this.mediaType).then(res1 => {
                            if(res1 != 99999){
                                let info = {
                                    content_id: this.$route.query.d,
                                    file_id: data,
                                    logo_key: this.logoList[res1].logo_key
                                }
                                common
                                .myFetch(apis.knewstranscode, info)
                                .then(r => {
                                    if (r) {
                                        this.materialList[this.articleId].file_id = r.id
                                        this.selectIndex = res1
                                        this.getPlatformDrop(r.id)
                                    }
                                });
                            }
                        })
                    }else{
                        if(info[0].p_key == 'dy'){
                            let info = {
                                content_id: this.$route.query.d,
                                file_id: data
                            }
                            common
                            .myFetch(apis.dytranscode, info)
                            .then(r => {
                                if (r) {
                                    console.log(r)
                                    this.materialList[this.articleId].file_id = r.id
                                    this.selectIndex = 0
                                    this.getPlatformDrop(r.id)
                                }
                            });
                        }else{
                            this.materialList[this.articleId].file_id = data
                            this.showEmpty = false;
                            this.showUpload = false;
                            this.showProgress = false;
                            this.showVideo = true
                            console.log(el,this.materialList[this.articleId])
                            
                            let isRow = false;
                            let duration = this.hms2s(el.content.duration)
                            this.duration = this.s2hms(duration)
                            if(el.content && el.content.resolution){
                                let resolution = el.content.resolution.split('x')
                                if(Number(resolution[0]) > Number(resolution[1])){
                                    isRow = true
                                }else{
                                    isRow = false
                                }
                            }
                            
                            el.isRow = isRow
                            el.d = this.$route.query.d
                            this.videoDetail = el
                            
                            if(this.mediaType == 5){
                                this.$nextTick(() => {
                                    this.$refs.video.volume  = 0.5

                                    this.$refs.video.addEventListener('ended', () => {
                                        this.showPlayBtn = true
                                    })

                                    this.$refs.video.addEventListener('timeupdate', (e) => {
                                        // console.log(e)
                                        this.currentTime = this.s2hms(this.$refs.video.currentTime)
                                        this.audioPercent = ((this.$refs.video.currentTime / this.$refs.video.duration) * 100) + '%'
                                    })
                                })
                            }else{
                                this.showWriteVideo = true;
                            }
                        }
                    }
                    // this.showPlayBtn = true
                    // this.materialList[this.articleId].file_id = data
                    // this.showEmpty = false;
                    // this.showUpload = false;
                    // this.showProgress = false;
                    // this.showVideo = true
                    // let resolution = el.content.resolution.split('x')
                    // let isRow = false;
                    // let duration = this.hms2s(el.content.duration)
                    // this.duration = this.s2hms(duration)
                    // if(Number(resolution[0]) > Number(resolution[1])){
                    //     isRow = true
                    // }else{
                    //     isRow = false
                    // }
                    // el.isRow = isRow
                    // el.d = this.$route.query.d
                    // this.videoDetail = el

                    // if(this.mediaType == 5){
                    //     this.$nextTick(() => {
                    //         this.$refs.video.volume  = 0.5

                    //         this.$refs.video.addEventListener('ended', () => {
                    //             this.showPlayBtn = true
                    //         })

                    //         this.$refs.video.addEventListener('timeupdate', (e) => {
                    //             // console.log(e)
                    //             this.currentTime = this.s2hms(this.$refs.video.currentTime)
                    //             this.audioPercent = ((this.$refs.video.currentTime / this.$refs.video.duration) * 100) + '%'
                    //         })
                    //     })
                    // }else{
                    //     this.showWriteVideo = true;
                    // }
                }else if(el.id == data && el.type == 1){
                    this.materialList[this.articleId].file_id = data
                    this.showEmpty = false;
                    this.showUpload = false;
                    this.showProgress = false;
                    this.showVideo = true

                    el.isRow = true
                    el.d = this.$route.query.d
                    this.videoDetail = el
                }else if(el.id == data && el.type == 3){
                    if(this.logoList.length == 1){
                        let info = {
                            content_id: this.$route.query.d,
                            file_id: data,
                            logo_key: this.logoList[0].logo_key
                        }
                        common
                        .myFetch(apis.knewstranscode, info)
                        .then(r => {
                            if (r) {
                                this.materialList[this.articleId].file_id = r.id
                                this.selectIndex = 0
                                this.getPlatformDrop(r.id)
                            }
                        });
                    }else if(this.logoList.length > 1){
                        let videoInfo = ''
                        this.$MediaPlatformWater(this.logoList,videoInfo,this.selectPlatform, this.mediaType).then(res1 => {
                            if(res1 != 99999){
                                let info = {
                                    content_id: this.$route.query.d,
                                    file_id: data,
                                    logo_key: this.logoList[res1].logo_key
                                }
                                common
                                .myFetch(apis.knewstranscode, info)
                                .then(r => {
                                    if (r) {
                                        this.materialList[this.articleId].file_id = r.id
                                        this.selectIndex = res1
                                        this.getPlatformDrop(r.id)
                                    }
                                });
                            }
                        })
                    }
                }
            })
            // console.log(data)
        },
        drop(ev){
            ev.preventDefault();
            var data=ev.dataTransfer.getData("id");

            this.mediaPublishDetail.files.forEach(el => {
                if(el.id == data && el.type == 2){
                    let info = JSON.parse(this.materialList[this.articleId].push_platform)
                    // console.log(157,info)
                    if(info[0].p_key == 'new_media_knews' || info[0].p_key == 'five_star_sports_cms' || (info[0].p_key == 'playlist' && this.mediaType == 5)){
                        let videoInfo = ''
                        if(el.content && el.content.resolution){
                            let arr = el.content.resolution.split('x')
                            if(arr[0] > arr[1]){
                                videoInfo = '16:9'
                            }else{
                                videoInfo = '9:16'
                            }
                        }
                        this.$MediaPlatformWater(this.logoList,videoInfo,this.selectPlatform).then(res1 => {
                            if(res1 != 99999){
                                let info = {
                                    content_id: this.$route.query.d,
                                    file_id: data,
                                    logo_key: this.logoList[res1].logo_key
                                }
                                common
                                .myFetch(apis.knewstranscode, info)
                                .then(r => {
                                    if (r) {
                                        this.materialList[this.articleId].file_id = r.id
                                        this.selectIndex = res1
                                        this.getPlatformDrop(r.id)
                                        // this.handleAutoSave()
                                        // this.selectIndex = res1
                                        // this.materialList[this.articleId].file_id = r.id
                                        // this.showEmpty = false;
                                        // this.showUpload = false;
                                        // this.showProgress = false;
                                        // this.showVideo = true
                                        // console.log(el,this.materialList[this.articleId])
                                        // let resolution = el.content.resolution.split('x')
                                        // let isRow = false;
                                        // let duration = this.hms2s(el.content.duration)
                                        // this.duration = this.s2hms(duration)
                                        // if(Number(resolution[0]) > Number(resolution[1])){
                                        //     isRow = true
                                        // }else{
                                        //     isRow = false
                                        // }
                                        // el.isRow = isRow
                                        // el.d = this.$route.query.d
                                        // this.videoDetail = el
                                        
                                        // if(this.mediaType == 5){
                                        //     this.$nextTick(() => {
                                        //         this.$refs.video.volume  = 0.5

                                        //         this.$refs.video.addEventListener('ended', () => {
                                        //             this.showPlayBtn = true
                                        //         })

                                        //         this.$refs.video.addEventListener('timeupdate', (e) => {
                                        //             // console.log(e)
                                        //             this.currentTime = this.s2hms(this.$refs.video.currentTime)
                                        //             this.audioPercent = ((this.$refs.video.currentTime / this.$refs.video.duration) * 100) + '%'
                                        //         })
                                        //     })
                                        // }else{
                                        //     this.showWriteVideo = true;
                                        // }
                                    }
                                });
                            }else{
                                this.showWriteVideo = false;
                                this.materialList[this.articleId].file_id = '';
                                this.videoDetail = {}
                                this.handleAutoSave()
                            }
                        })
                    }else{
                        if(info[0].p_key == 'dy'){
                            let info = {
                                content_id: this.$route.query.d,
                                file_id: data
                            }
                            common
                            .myFetch(apis.dytranscode, info)
                            .then(r => {
                                if (r) {
                                    console.log(r)
                                    this.materialList[this.articleId].file_id = r.id
                                    this.selectIndex = 0
                                    this.getPlatformDrop(r.id)
                                }
                            });
                        }else{
                            this.materialList[this.articleId].file_id = data
                            this.showEmpty = false;
                            this.showUpload = false;
                            this.showProgress = false;
                            this.showVideo = true
                            console.log(el,this.materialList[this.articleId])
                            let resolution = el.content.resolution.split('x')
                            let isRow = false;
                            let duration = this.hms2s(el.content.duration)
                            this.duration = this.s2hms(duration)
                            if(Number(resolution[0]) > Number(resolution[1])){
                                isRow = true
                            }else{
                                isRow = false
                            }
                            el.isRow = isRow
                            el.d = this.$route.query.d
                            this.videoDetail = el
                            
                            if(this.mediaType == 5){
                                this.$nextTick(() => {
                                    this.$refs.video.volume  = 0.5

                                    this.$refs.video.addEventListener('ended', () => {
                                        this.showPlayBtn = true
                                    })

                                    this.$refs.video.addEventListener('timeupdate', (e) => {
                                        // console.log(e)
                                        this.currentTime = this.s2hms(this.$refs.video.currentTime)
                                        this.audioPercent = ((this.$refs.video.currentTime / this.$refs.video.duration) * 100) + '%'
                                    })

                                    this.$refs.video.addEventListener('play', () => {
                                        this.showPlayBtn = false
                                    })

                                    this.$refs.video.addEventListener('pause', () => {
                                        this.showPlayBtn = true
                                    })
                                })
                            }else{
                                this.showWriteVideo = true;
                            }
                        }
                    }
                }else if(el.id == data && el.type == 1 && this.mediaType == 7){
                    let info = JSON.parse(this.materialList[this.articleId].push_platform)

                    if(info[0].p_key == 'playlist'){
                        this.materialList[this.articleId].file_id = data
                        this.showEmpty = false;
                        this.showUpload = false;
                        this.showProgress = false;
                        this.showVideo = true
                        el.d = this.$route.query.d
                        this.videoDetail = el

                        this.handleSaved()
                    }
                }else if(el.id == data && el.type == 3 && this.mediaType == 8){
                    let info = JSON.parse(this.materialList[this.articleId].push_platform)

                    if(info[0].p_key == 'playlist'){
                        let videoInfo = ''

                        if(this.logoList.length == 1){
                            let info = {
                                content_id: this.$route.query.d,
                                file_id: data,
                                logo_key: this.logoList[0].logo_key
                            }
                            common
                            .myFetch(apis.knewstranscode, info)
                            .then(r => {
                                if (r) {
                                    this.materialList[this.articleId].file_id = r.id
                                    this.selectIndex = 0
                                    this.getPlatformDrop(r.id)
                                }
                            });
                        }else{
                            this.$MediaPlatformWater(this.logoList,videoInfo,this.selectPlatform, this.mediaType).then(res1 => {
                                if(res1 != 99999){
                                    let info = {
                                        content_id: this.$route.query.d,
                                        file_id: data,
                                        logo_key: this.logoList[res1].logo_key
                                    }
                                    common
                                    .myFetch(apis.knewstranscode, info)
                                    .then(r => {
                                        if (r) {
                                            this.materialList[this.articleId].file_id = r.id
                                            this.selectIndex = res1
                                            this.getPlatformDrop(r.id)
                                        }
                                    });
                                }
                            })
                        }
                    }
                }
            })
            // console.log(data)
        },
        allowDrop(ev){
            ev.preventDefault();
        },
        imgEdit() {
            console.log(123)
        },
        imgAdd(e) {
            console.log(e)
        },
        showVideoClip() {
            // console.log()
            if(this.showVideo){
                if(this.videoDetail && this.videoDetail.transcode_finish){
                    this.$VideoClip(this.videoDetail).then(e => {
                        // console.log(e)
                        if(e){
                            this.cover_tsp = e.list[0].time
                            let info = {
                                id: this.articleId,
                                file_id: e.list[0].file_id
                            }
                            common
                            .myFetch(apis.newMediaPlatformSetCover, info)
                            .then(r => {
                                if (r) {
                                    this.cover = e.list[0].cover
                                    this.getPlatform()
                                    this.handleAutoSave()
                                    // console.log(r)
                                }
                            });
                        }
                    })
                }else{
                    this.$toast('视频转码中')
                }
            }else{
                this.$toast('请上传视频')
            }
        },
        setposter(file_id) {
            let info = {
                id: this.articleId,
                file_id: file_id,
                poster: ''
            }
            common.myFetch(apis.setposter, info).then(r => {
                if (r) {
                    this.$toast(r)
                    this.getPlatform()
                }
            });
        },
        async showMaterialListPostBox() {
            let id = this.id;
            this.isCover = true
            let config = {
                subject_id: id, //文稿的id
                subject_type: 5,
                showMore: !this.isCover,
                materialChannel: this.materialChannel,
                showPhotoEdit: true,
                create: this.$store.state.create,
                quickEdit: this.$store.state.quickEdit,
                d: this.id,
                link: true,
                logoList: this.logoList,
                selectPlatform: this.selectPlatform
            };
            this.$MediaListBox(config).then(async (res) => {
                if (res) {
                    console.log(res,this.isCover)
                    this.postCover = res.cover
                    this.showPostUpload = false;
                    this.setposter(res.id)
                }
            });
        },
        async showMaterialListBox() {
            console.log('12222', this.uploadTitle,this.showWriteUpload,this.topPic,this.needWater)
            if(this.uploadTitle == '上传图片' && this.showWriteUpload && !this.topPic && !this.needWater){
                let id = this.id;
                let config = {
                    subject_id: id, //文稿的id
                    subject_type: 5,
                    showMore: true,
                    materialChannel: this.materialChannel,
                    showPhotoEdit: true,
                    create: this.$store.state.create,
                    quickEdit: this.$store.state.quickEdit,
                    d: this.id,
                    link: true,
                    logoList: this.logoList,
                    selectPlatform: this.selectPlatform
                };
                console.log('1', config)
                this.$MulMediaListBox(config).then(res => {
                    if(res){
                        // console.log(res)
                        if(res.length > 0){
                            res.forEach(el => {
                                let info = {
                                    file_ids: el.id,
                                    subject_type: 5,
                                    subject_id: this.articleId
                                };
                                common.myFetch(apis.File_bind, info).then(r => {
                                    if (r) {
                                        // console.log(987)
                                        if(this.selectPlatform == 'five_star_sports_cms'){
                                            this.normalInstance.execCommand(
                                            "inserthtml",
                                            `<p></p><p data-fileId="${r.id}" contenteditable="false" class="imgContainer"><span contenteditable="false" class='img'><span contenteditable="false" class="relative"><img contenteditable="false" src="${
                                                r.url
                                                }" style="max-width: 100%; height: auto;" draggable="false"/></span></span></span><p></p></p>`
                                        );
                                        }else{
                                            this.normalInstance.execCommand(
                                            "inserthtml",
                                            `<p></p><p data-fileId="${r.id}" contenteditable="false" class="imgContainer"><span contenteditable="false" class='img'><span contenteditable="false" class="relative"><img contenteditable="false" src="${
                                                r.url
                                                }" style="max-width: 100%; height: auto;" draggable="false"/><span class="imgBtnsEdit" data-fileId="${r.id}"><i>1</i>编辑</span><span class="imgBtnsAdd" data-fileId="${r.id}"><i>1</i>加水印</span><span class="imgDescribe" data-fileId="${r.id}"><i>1</i>图片描述</span><span contenteditable="false" data-fileId="${r.id}" class=centerTxt></span></span></span></span><p></p></p>`
                                        );
                                        }
                                        
                                        this.getPlatform()
                                    }
                                });
                            })

                            
                            this.showWriteUpload = false;
                            this.topPic = false
                        }
                    }
                })
            }else{
                let id = this.id;
                if(this.mediaType == 6 && this.uploadTitle == '上传图片'){
                    this.isCover = true
                }
                let config = {
                    subject_id: id, //文稿的id
                    subject_type: 5,
                    showMore: !this.isCover,
                    materialChannel: this.materialChannel,
                    showPhotoEdit: true,
                    create: this.$store.state.create,
                    quickEdit: this.$store.state.quickEdit,
                    d: this.id,
                    link: true,
                    logoList: this.logoList,
                    selectPlatform: this.selectPlatform,
                    mediaType: this.mediaType
                };
                console.log('2222', config)
                this.$MediaListBox(config).then(async (res) => {
                    if (res) {
                        console.log('--------',res,this.isCover)
                        if(this.isCover){
                            if(this.mediaType == 6 && this.uploadTitle == '上传图片' && !this.topPic && this.showWriteUpload){
                                if(this.needWater){
                                    this.$WaterEdit(this.selectPlatform).then(el => {
                                        if(el) {
                                            // console.log(e.list[0],res.id)
                                            el.file_id = res.id
                                            el.id = this.$route.query.d
                                            common.myFetch(apis.addwatermark, el).then(r => {
                                                if (r) {
                                                    console.log(r)
                                                    this.normalInstance.execCommand(
                                                        "inserthtml",
                                                        `<p></p><p data-fileId="${r.id}" contenteditable="false" class="imgContainer"><span contenteditable="false" class='img'><span contenteditable="false" class="relative"><img contenteditable="false" src="${
                                                            r.url
                                                            }" style="max-width: 100%; height: auto;" draggable="false"/><span class="imgBtnsEdit" data-fileId="${r.id}"><i>1</i>编辑</span><span class="imgBtnsAdd" data-fileId="${r.id}"><i>1</i>加水印</span><span class="imgDescribe" data-fileId="${r.id}"><i>1</i>图片描述</span><span contenteditable="false" data-fileId="${r.id}" class=centerTxt></span></span></span><p></p></p>`
                                                    );
                                                    this.getPlatform()
                                                    this.showWriteUpload = false;
                                                    this.topPic = false

                                                }
                                            });
                                        }else{
                                            this.showWriteUpload = false;
                                            this.topPic = false
                                        }
                                    })
                                }else{
                                    let info = {
                                        file_ids: res.id,
                                        subject_type: 5,
                                        subject_id: this.articleId
                                    };
                                    common.myFetch(apis.File_bind, info).then(r => {
                                        if (r) {
                                            console.log(987)
                                            this.normalInstance.execCommand(
                                                "inserthtml",
                                                `<p></p><p data-fileId="${r.id}" contenteditable="false" class="imgContainer"><span contenteditable="false" class='img'><span contenteditable="false" class="relative"><img contenteditable="false" src="${
                                                    r.url
                                                    }" style="max-width: 100%; height: auto;" draggable="false"/><span class="imgBtnsEdit" data-fileId="${r.id}"><i>1</i>编辑</span><span class="imgBtnsAdd" data-fileId="${r.id}"><i>1</i>加水印</span><span class="imgDescribe" data-fileId="${r.id}"><i>1</i>图片描述</span><span contenteditable="false" data-fileId="${r.id}" class=centerTxt></span></span></span></span><p></p></p>`
                                            );
                                            this.getPlatform()
                                            this.showWriteUpload = false;
                                            this.topPic = false

                                        }
                                    });
                                }
                                this.needWater = false;
                            }else if(this.mediaType == 6 && this.uploadTitle == '上传图片' && this.topPic){
                                let info = {
                                    file_ids: res.id,
                                    subject_type: 5,
                                    subject_id: id
                                };
                                common.myFetch(apis.File_bind, info).then(r => {
                                    if (r) {
                                        this.top_video_cover = res.cover
                                        this.videoDetail.cover = res.cover
                                        this.getPlatform()
                                        this.showWriteUpload = false;
                                        this.topPic = false
                                    }
                                });
                            }else{
                                this.setCover(res.id,res.cover)
                                this.getPlatform()
                            }
                        }else{
                            // console.log(8887765,res,this.mediaType)
                            if(this.mediaType == 6){
                                this.selectIndex = 999
                                this.selectName = '请选择'
                                this.showWriteVideo = true;
                                this.showWriteUpload = false;
                                this.topPic = false
                            }
                            this.selectIndex = res.index
                            if(this.logoList && this.logoList.length > 0 && this.logoList[res.index] && this.logoList[res.index].logo_title){
                                this.selectName = this.logoList[res.index].logo_title;
                            }
                            this.materialList[this.articleId].file_id = res.id;
                            if(this.selectPlatform == 'dy'){
                                // this.cover = ''
                                this.materialList[this.articleId].cover_tsp = 0
                                this.cover_tsp = 0;
                                // this.cover = this.defaultCover
                                // let info = {
                                //     id: this.articleId,
                                //     file_id: ''
                                // }
                                // common
                                // .myFetch(apis.newMediaPlatformSetCover, info)
                                // .then(r => {
                                //     if (r) {
                                //         this.cover = this.defaultCover
                                //         // this.getPlatform()
                                //         // console.log(r)
                                //     }
                                // });
                            }
                            if(this.selectPlatform == 'bilibili' && this.$refs.video){
                                console.log('bilibilibilibili')
                                this.$refs.video.src = ''
                                this.$refs.video.load()
                            }
                            if(this.selectPlatform == 'five_star_sports_cms' && this.mediaType == 6){
                                this.normalInstance.execCommand(
                                    "inserthtml",
                                    `<p></p><p data-type="video" data-fileId="${res.id}" contenteditable="false" class="uploadVideo mask"><span class="codeProgress"></span></p><p></p>`
                                );
                            }
                            console.log(5000,res.id)
                            await this.uploadSave()
                            this.showEmpty = false;
                            this.showVideo = true;
                            this.showUpload = false;
                            this.showProgress = false;
                            this.showWriteUpload = false;
                            this.getPlatform(res.id)
                            if(this.isSubmitUpload){
                                let info = {
                                    id: this.id
                                }
                                common.myFetch(apis.newMediaPlatformReleasecheck, info).then(res => {
                                    if(res){
                                        if(res.showErr){
                                            this.errMsg = res.msg
                                            this.showPreTipsContent = true
                                        }else if(res.needReBind){
                                            let p_key = JSON.parse(this.materialList[this.articleId].push_platform)[0].p_key
                                            this.$MediaPlatformAccount(p_key)
                                        }else{
                                            this.releaseArticle()
                                        }
                                    }
                                })
                            }
                        }
                    }
                });   
            }
        },
        async showLibraryMaterialListBox(item) {
            if(this.uploadTitle == '上传图片' && this.showWriteUpload && !this.topPic && !this.needWater){
                // 多选图片
                let id = this.id;
                let config = {
                    subject_id: id, //文稿的id
                    subject_type: 5,
                    showMore: true,
                    materialChannel: this.materialChannel,
                    showPhotoEdit: true,
                    create: this.$store.state.create,
                    quickEdit: this.$store.state.quickEdit,
                    d: this.id,
                    link: true,
                    logoList: this.logoList,
                    selectPlatform: this.selectPlatform
                };
                item && item.click && item.click({
                    config,
                    multiple: true,
                    type: 1
                }).then(result=>{
                    item && item.close && item.close()
                    this.libraryMaterialListBoxMultipleCallback(result.selectedItems);
                })
                
            }else {
                let id = this.id;
                if(this.mediaType == 6 && this.uploadTitle == '上传图片'){
                    this.isCover = true
                }
                let config = {
                    subject_id: id, //文稿的id
                    subject_type: 5,
                    showMore: !this.isCover,
                    materialChannel: this.materialChannel,
                    showPhotoEdit: true,
                    create: this.$store.state.create,
                    quickEdit: this.$store.state.quickEdit,
                    d: this.id,
                    link: true,
                    logoList: this.logoList,
                    selectPlatform: this.selectPlatform,
                    mediaType: this.mediaType
                };

                // 单选视频或者图片或者音频，isCover = true 为图片
                /**
                 * type = 8 音频
                    type = 7 图片
                    type = 5 视频
                 */
                let _type = 2
                if(this.mediaType == 8){
                    _type = 3
                }else if(this.mediaType == 5){
                    _type = 2
                }else if(this.mediaType == 7){
                    _type = 1
                }
                item && item.click && item.click({
                    config,
                    multiple: false,
                    type: this.isCover ? 1: _type
                }).then(libraryResult =>{
                    console.log('--------ooooooo',libraryResult , config)
                    if(_type == 2 || _type == 3 || _type == 1){
                        console.log('tttttt-----11111')
                            if(this.isCover) {
                                item && item.close && item.close()
                                this.libraryMaterialListBoxCallback({id: libraryResult.ids, cover: libraryResult.cover});
                            }else if(config.selectPlatform != 'b_plus' && config.selectPlatform != 'dy' && config.mediaType != 7){
                            // console.log(999,this.list)
                            let videoInfo = libraryResult.ratioString

                            if(config.logoList.length == 1){
                                    let param = {
                                        file_ids: libraryResult.ids,
                                        ...config,
                                        logo_key: config.logoList[0].logo_key
                                    };

                                    common
                                        .myFetch(apis.File_bind, param)
                                        .then(result => {
                                        console.log("File_add 关联稿件", result);
                                        // 成功响应
                                        // return false;
                                        if (result) {
                                            this.$toast("添加素材成功");
                                            item && item.close && item.close()
                                            this.libraryMaterialListBoxCallback({id: result.id, index: 0});
                                        }
                                        })
                                        .catch(e => {
                                        console.log("关联素材到文稿失败 e", e);
                                    });
                            }else{
                                this.$MediaPlatformWater(config.logoList,videoInfo,config.selectPlatform,config.mediaType).then(res => {
                                if(res != 99999){
                                    let param = {
                                        file_ids: libraryResult.ids,
                                        ...config,
                                        logo_key: config.logoList[res].logo_key
                                    };

                                    // console.log(param)
                                    // return false;
                                    common
                                        .myFetch(apis.File_bind, param)
                                        .then(result => {
                                        console.log("File_add 关联稿件", result);
                                        // 成功响应
                                        // return false;
                                        if (result) {
                                            this.$toast("添加素材成功");
                                            item && item.close && item.close()
                                            this.libraryMaterialListBoxCallback({id: result.id, index: res});
                                        }
                                        })
                                        .catch(e => {
                                        console.log("关联素材到文稿失败 e", e);
                                    });
                                }
                                })
                            }
                            }else{
                                    let param = {
                                    file_ids: libraryResult.ids,
                                    ...config,
                                    };

                                    if(config.selectPlatform == 'dy' && config.logoList && config.logoList.length > 0){
                                    param.logo_key = config.logoList[0].logo_key
                                    common
                                        .myFetch(apis.File_bind, param)
                                        .then(result => {
                                        // console.log("File_add 关联稿件", result);
                                        // 成功响应
                                        // return false;
                                        if (result) {
                                            this.$toast("添加素材成功");
                                            item && item.close && item.close()
                                            this.libraryMaterialListBoxCallback({id: result.id, index: 0});
                                        }
                                        })
                                        .catch(e => {
                                        console.log("关联素材到文稿失败 e", e);
                                    });
                                    }else{
                                    common
                                        .myFetch(apis.File_bind, param)
                                        .then(result => {
                                        // console.log("File_add 关联稿件", result);
                                        // 成功响应
                                        // return false;
                                        if (result) {
                                            this.$toast("添加素材成功");
                                            item && item.close && item.close()
                                            this.libraryMaterialListBoxCallback({id: result.id, index: 999});
                                        }
                                        })
                                        .catch(e => {
                                        console.log("关联素材到文稿失败 e", e);
                                    });
                                    }

                                    // console.log(param)
                                    // return false;
                            }
                    }else{
                        console.log('tttttt-----22222')
                        const status = true;
                        if(status){
                            let param = {
                            file_ids: libraryResult.ids,
                            ...config
                            };

                            // console.log(param)
                            // return false;
                            common
                            .myFetch(apis.File_bind, param)
                            .then(result => {
                                console.log("File_add 关联稿件", result);
                                // 成功响应
                                if (result) {
                                this.$toast("添加素材成功");
                                item && item.close && item.close()
                                console.log('sdfsdfsdfdsf-------------',libraryResult)
                                this.libraryMaterialListBoxCallback(libraryResult.ids);
                                }
                            })
                            .catch(e => {
                                console.log("关联素材到文稿失败 e", e);
                            });
                        }
                    }
                })
            }
        },
        async showLibraryMaterialListPostBox(item){
            let id = this.id;
            this.isCover = true
            let config = {
                subject_id: id, //文稿的id
                subject_type: 5,
                showMore: !this.isCover,
                materialChannel: this.materialChannel,
                showPhotoEdit: true,
                create: this.$store.state.create,
                quickEdit: this.$store.state.quickEdit,
                d: this.id,
                link: true,
                logoList: this.logoList,
                selectPlatform: this.selectPlatform
            };

            item && item.click && item.click({
                config,
                multiple: false,
                type: this.isCover ? 1: 2
            }).then(result=>{
                const {ids: id, cover}=result
                if(config.showPhotoEdit){
          let media = {
            id: id,
            cover: cover
          }
          item && item.close && item.close()
                this.libraryMaterialListPostBoxCallback(media);
        }else{
          let param = {
            file_ids: result.ids,
            ...config
          };

          let media = {
            id: id,
            cover: cover
          }
          // console.log(param)
          // return false;
          common
            .myFetch(apis.File_bind, param)
            .then(result => {
              console.log("File_add 关联稿件", result);
              // 成功响应
              if (result) {
                this.$toast("添加素材成功");
                item && item.close && item.close()
                this.libraryMaterialListPostBoxCallback(media);
              }
            })
            .catch(e => {
              console.log("关联素材到文稿失败 e", e);
          });
        }
            })
            
        },

        async libraryMaterialListBoxCallback(res){
            if(this.isCover){
                            if(this.mediaType == 6 && this.uploadTitle == '上传图片' && !this.topPic && this.showWriteUpload){
                                if(this.needWater){
                                    this.$WaterEdit(this.selectPlatform).then(el => {
                                        if(el) {
                                            // console.log(e.list[0],res.id)
                                            el.file_id = res.id
                                            el.id = this.$route.query.d
                                            common.myFetch(apis.addwatermark, el).then(r => {
                                                if (r) {
                                                    console.log(r)
                                                    this.normalInstance.execCommand(
                                                        "inserthtml",
                                                        `<p></p><p data-fileId="${r.id}" contenteditable="false" class="imgContainer"><span contenteditable="false" class='img'><span contenteditable="false" class="relative"><img contenteditable="false" src="${
                                                            r.url
                                                            }" style="max-width: 100%; height: auto;" draggable="false"/><span class="imgBtnsEdit" data-fileId="${r.id}"><i>1</i>编辑</span><span class="imgBtnsAdd" data-fileId="${r.id}"><i>1</i>加水印</span><span class="imgDescribe" data-fileId="${r.id}"><i>1</i>图片描述</span><span contenteditable="false" data-fileId="${r.id}" class=centerTxt></span></span></span><p></p></p>`
                                                    );
                                                    this.getPlatform()
                                                    this.showWriteUpload = false;
                                                    this.topPic = false

                                                }
                                            });
                                        }else{
                                            this.showWriteUpload = false;
                                            this.topPic = false
                                        }
                                    })
                                }else{
                                    let info = {
                                        file_ids: res.id,
                                        subject_type: 5,
                                        subject_id: this.articleId
                                    };
                                    common.myFetch(apis.File_bind, info).then(r => {
                                        if (r) {
                                            console.log(987)
                                            this.normalInstance.execCommand(
                                                "inserthtml",
                                                `<p></p><p data-fileId="${r.id}" contenteditable="false" class="imgContainer"><span contenteditable="false" class='img'><span contenteditable="false" class="relative"><img contenteditable="false" src="${
                                                    r.url
                                                    }" style="max-width: 100%; height: auto;" draggable="false"/><span class="imgBtnsEdit" data-fileId="${r.id}"><i>1</i>编辑</span><span class="imgBtnsAdd" data-fileId="${r.id}"><i>1</i>加水印</span><span class="imgDescribe" data-fileId="${r.id}"><i>1</i>图片描述</span><span contenteditable="false" data-fileId="${r.id}" class=centerTxt></span></span></span></span><p></p></p>`
                                            );
                                            this.getPlatform()
                                            this.showWriteUpload = false;
                                            this.topPic = false

                                        }
                                    });
                                }
                                this.needWater = false;
                            }else if(this.mediaType == 6 && this.uploadTitle == '上传图片' && this.topPic){
                                let info = {
                                    file_ids: res.id,
                                    subject_type: 5,
                                    subject_id: this.id
                                };
                                common.myFetch(apis.File_bind, info).then(r => {
                                    if (r) {
                                        this.top_video_cover = res.cover
                                        this.videoDetail.cover = res.cover
                                        this.getPlatform()
                                        this.showWriteUpload = false;
                                        this.topPic = false
                                    }
                                });
                            }else{
                                this.setCover(res.id,res.cover)
                                this.getPlatform()
                            }
                        }else{
                            // console.log(8887765,res,this.mediaType)
                            if(this.mediaType == 6){
                                this.selectIndex = 999
                                this.selectName = '请选择'
                                this.showWriteVideo = true;
                                this.showWriteUpload = false;
                                this.topPic = false
                            }
                            this.selectIndex = res.index
                            if(this.logoList && this.logoList.length > 0 && this.logoList[res.index] && this.logoList[res.index].logo_title){
                                this.selectName = this.logoList[res.index].logo_title;
                            }
                            this.materialList[this.articleId].file_id = res.id;
                            if(this.selectPlatform == 'dy'){
                                // this.cover = ''
                                this.materialList[this.articleId].cover_tsp = 0
                                this.cover_tsp = 0;
                                // this.cover = this.defaultCover
                                // let info = {
                                //     id: this.articleId,
                                //     file_id: ''
                                // }
                                // common
                                // .myFetch(apis.newMediaPlatformSetCover, info)
                                // .then(r => {
                                //     if (r) {
                                //         this.cover = this.defaultCover
                                //         // this.getPlatform()
                                //         // console.log(r)
                                //     }
                                // });
                            }
                            if(this.selectPlatform == 'bilibili' && this.$refs.video){
                                console.log('bilibilibilibili')
                                this.$refs.video.src = ''
                                this.$refs.video.load()
                            }
                            if(this.selectPlatform == 'five_star_sports_cms' && this.mediaType == 6){
                                this.normalInstance.execCommand(
                                    "inserthtml",
                                    `<p></p><p data-type="video" data-fileId="${res.id}" contenteditable="false" class="uploadVideo mask"><span class="codeProgress"></span></p><p></p>`
                                );
                            }
                            console.log(5000,res.id)
                            await this.uploadSave()
                            this.showEmpty = false;
                            this.showVideo = true;
                            this.showUpload = false;
                            this.showProgress = false;
                            this.showWriteUpload = false;
                            this.getPlatform(res.id)
                            if(this.isSubmitUpload){
                                let info = {
                                    id: this.id
                                }
                                common.myFetch(apis.newMediaPlatformReleasecheck, info).then(res => {
                                    if(res){
                                        if(res.showErr){
                                            this.errMsg = res.msg
                                            this.showPreTipsContent = true
                                        }else if(res.needReBind){
                                            let p_key = JSON.parse(this.materialList[this.articleId].push_platform)[0].p_key
                                            this.$MediaPlatformAccount(p_key)
                                        }else{
                                            this.releaseArticle()
                                        }
                                    }
                                })
                            }
                        }
        },
        libraryMaterialListPostBoxCallback(res){
            this.postCover = res.cover
            this.showPostUpload = false;
            this.setposter(res.id)
        },
        libraryMaterialListBoxMultipleCallback(res){
            if(res){
                        // console.log(res)
                        if(res.length > 0){
                            res.forEach(el => {
                                let info = {
                                    file_ids: el.id,
                                    subject_type: 5,
                                    subject_id: this.articleId
                                };
                                common.myFetch(apis.File_bind, info).then(r => {
                                    if (r) {
                                        // console.log(987)
                                        if(this.selectPlatform == 'five_star_sports_cms'){
                                            this.normalInstance.execCommand(
                                            "inserthtml",
                                            `<p></p><p data-fileId="${r.id}" contenteditable="false" class="imgContainer"><span contenteditable="false" class='img'><span contenteditable="false" class="relative"><img contenteditable="false" src="${
                                                r.url
                                                }" style="max-width: 100%; height: auto;" draggable="false"/></span></span></span><p></p></p>`
                                        );
                                        }else{
                                            this.normalInstance.execCommand(
                                            "inserthtml",
                                            `<p></p><p data-fileId="${r.id}" contenteditable="false" class="imgContainer"><span contenteditable="false" class='img'><span contenteditable="false" class="relative"><img contenteditable="false" src="${
                                                r.url
                                                }" style="max-width: 100%; height: auto;" draggable="false"/><span class="imgBtnsEdit" data-fileId="${r.id}"><i>1</i>编辑</span><span class="imgBtnsAdd" data-fileId="${r.id}"><i>1</i>加水印</span><span class="imgDescribe" data-fileId="${r.id}"><i>1</i>图片描述</span><span contenteditable="false" data-fileId="${r.id}" class=centerTxt></span></span></span></span><p></p></p>`
                                        );
                                        }
                                        
                                        this.getPlatform()
                                    }
                                });
                            })

                            
                            this.showWriteUpload = false;
                            this.topPic = false
                        }
                    }
        },

        goCreate() {
            if(this.mediaPublishDetail.status == 1 || this.mediaPublishDetail.status == 3 || this.mediaPublishDetail.status == 7) return
            this.$MediaPlatform(this.id).then(e => {
                if(e){
                    this.getPlatform()
                }
            })
        },
        handleStart(f) {
            this.selectIndex = 999
            this.selectName = '请选择'
            if(this.mediaType == 5 || this.mediaType == 7 || this.mediaType == 8){
                this.showEmpty = false;
                this.showVideo = false;
                this.showUpload = false;
                this.showProgress = true;
                this.uploadInfo.title = f
            }else{
                this.showWriteUpload = false;
                this.topPic = false
                this.showWriteVideo = true;
                this.uploadInfo.title = f
                this.showProgress = true;
            }
        },
        handleStart1(f) {
            console.log(888888888,f)
            this.selectIndex = 999
            this.selectName = '请选择'
            if(this.mediaType == 5 || this.mediaType == 7 || this.mediaType == 8){
                this.showEmpty = false;
                this.showVideo = false;
                this.showUpload = false;
                this.showProgress = true;
                this.uploadInfo.title = f.name
                this.newUploadFileId = f.tid
            }else{
                if(this.selectPlatform == 'five_star_sports_cms'){
                    this.showWriteUpload = false;
                    this.topPic = false
                    this.normalInstance.execCommand(
                        "inserthtml",
                        `<p></p><p data-type="video" data-fid="${f.tid}" contenteditable="false" class="uploadVideo mask"><span class="progress"><span></span></span></p><p></p>`
                    );
                }else{
                    this.showWriteUpload = false;
                    this.topPic = false
                    this.showWriteVideo = true;
                    this.uploadInfo.title = f.name
                    this.newUploadFileId = f.tid
                    this.showProgress = true;
                }
            }
        },
        handleProgress(f) {
            // console.log(f)
            if(this.mediaType == 5){
                this.fileId = f.id
                this.uploadInfo.progress = f.percent
            }else{
                this.fileId = f.id
                this.uploadInfo.progress = f.percent

                if(this.selectPlatform == 'five_star_sports_cms'){
                    let dom = this.normalWindow.document.querySelector(`[data-fid="${f.tid}"] .progress span`)
                    if(dom){
                        dom.style.width = f.percent + '%'
                    }
                }
            }
        },
        handleIndexComplete(index) {
            console.log(index)
            this.selectIndex = index
        },
        async handleComplete(f) {
            console.log(f)
            
            if(this.mediaType == 5 || this.mediaType == 7 || this.mediaType == 8){
                if(this.selectPlatform == 'dy'){
                    this.materialList[this.articleId].cover_tsp = 0
                    this.cover_tsp = 0
                    this.getCover()
                    // this.cover = this.defaultCover
                    // let info = {
                    //     id: this.articleId,
                    //     file_id: ''
                    // }
                    // common
                    // .myFetch(apis.newMediaPlatformSetCover, info)
                    // .then(r => {
                    //     if (r) {
                    //         this.cover = this.defaultCover
                    //         // this.getPlatform()
                    //         // console.log(r)
                    //     }
                    // });
                }
                if(f){
                    // this.selectIndex = 999
                    // this.selectName = '请选择'
                    this.materialList[this.articleId].file_id = f;
                    await this.uploadSave()
                    this.showEmpty = false;
                    this.showVideo = true;
                    this.showUpload = false;
                    this.showProgress = false;
                    this.showWriteUpload = false;
                    this.getPlatform(f)



                    if(this.isSubmitUpload){
                        let info = {
                            id: this.id
                        }
                        common.myFetch(apis.newMediaPlatformReleasecheck, info).then(res => {
                            if(res){
                                if(res.showErr){
                                    this.errMsg = res.msg
                                    this.showPreTipsContent = true
                                }else if(res.needReBind){
                                    let p_key = JSON.parse(this.materialList[this.articleId].push_platform)[0].p_key
                                    this.$MediaPlatformAccount(p_key)
                                }else{
                                    this.releaseArticle()
                                }
                            }
                        })
                    }
                }else{
                    // this.selectIndex = 999
                    // this.selectName = '请选择'
                    this.materialList[this.articleId].file_id = '';
                    this.showProgress = false;
                    this.showUpload = true;
                    this.showVideo = false;
                    this.handleAutoSave()
                }
            }else if(this.selectPlatform == 'five_star_sports_cms'){
                let dom = this.normalWindow.document.querySelector(`[data-fid="${f.tid}"]`)
                console.log(5555,dom,f.tid)
                if(dom){
                    let progressDom = dom.querySelector(`.progress`)

                    if(progressDom){
                        progressDom.remove()
                        dom.setAttribute('data-fileId', f.fileId)
                        let codeProgress = `<span class="codeProgress"></span>`
                        dom.innerHTML += codeProgress
                    }
                }

                this.materialList[this.articleId].file_id = f.fileId;
                await this.uploadSave()
                this.showProgress = false;
                this.getPlatform(f.fileId)
            }else{
                if(f){
                    // this.selectIndex = 999
                    // this.selectName = '请选择'
                    this.materialList[this.articleId].file_id = f;
                    await this.uploadSave()
                    this.showProgress = false;
                    this.getPlatform(f)

                    if(this.isSubmitUpload){
                        let info = {
                            id: this.id
                        }
                        common.myFetch(apis.newMediaPlatformReleasecheck, info).then(res => {
                            if(res){
                                if(res.showErr){
                                    this.errMsg = res.msg
                                    this.showPreTipsContent = true
                                }else if(res.needReBind){
                                    let p_key = JSON.parse(this.materialList[this.articleId].push_platform)[0].p_key
                                    this.$MediaPlatformAccount(p_key)
                                }else{
                                    this.releaseArticle()
                                }
                            }
                        })
                    }
                }else{
                    // this.selectIndex = 999
                    // this.selectName = '请选择'
                    this.showWriteVideo = false;
                    this.materialList[this.articleId].file_id = '';
                    this.handleAutoSave()
                }
                
                // if(this.uploadTitle == '上传视频'){
                //     this.$MediaPlatformWater(this.logoList).then(res => {
                //         if(res != 99999){
                //             this.selectIndex = res
                //             this.materialList[this.articleId].file_id = f;
                //             this.showProgress = false;
                //             this.getPlatform(f)
                //             if(this.isSubmitUpload){
                //                 this.releaseArticle()
                //             }
                //         }else{
                //             this.showWriteVideo = false;
                //             this.materialList[this.articleId].file_id = '';
                //             this.handleAutoSave()
                //         }
                //     })
                // }else{
                //     console.log(88,this.selectIndex)
                //     this.materialList[this.articleId].file_id = f;
                //     this.showProgress = false;
                //     this.getPlatform(f)
                //     if(this.isSubmitUpload){
                //         this.releaseArticle()
                //     }
                // }
            }
        },
        localUpload() {
            console.log(this.uploadTitle, this.mediaType)
            // this.showWriteUpload = false;
            this.showMiniUpload = false;
            if(this.uploadTitle == '上传图片'){
                if(this.showWriteUpload && !this.topPic && !this.needWater){
                    this.mulCoverUpload()
                }else{
                    this.coverUpload()
                }
            }else if(this.mediaType == 8){
                if(this.libraryMediaList && this.libraryMediaList.length > 0) {
                    // 有统一内容库权限
                    this.libraryDirInstance.open({
                        folderType: '0'
                    }).then(res=>{
                        this.libraryDirInfo = res
                        let uploadBtn = document.getElementById('httpUpBtnAudio')
                        uploadBtn.click();
                        this.showWriteUpload = false;
                    })
                }else {
                    let uploadBtn = document.getElementById('httpUpBtnAudio')
                    uploadBtn.click();
                    this.showWriteUpload = false;
                }
            }else if(this.mediaType == 7){
                if(this.libraryMediaList && this.libraryMediaList.length > 0) {
                    // 有统一内容库权限
                    this.libraryDirInstance.open({
                        folderType: '0'
                    }).then(res=>{
                        this.libraryDirInfo = res
                        let uploadBtn = document.getElementById('httpUpBtnImg')
                        uploadBtn.click();
                        this.showWriteUpload = false;
                    })
                }else {
                    let uploadBtn = document.getElementById('httpUpBtnImg')
                    uploadBtn.click();
                    this.showWriteUpload = false;
                }
            }else{
                // let uploadBtn = document.getElementById('httpUpBtn')
                
                if(this.libraryMediaList && this.libraryMediaList.length > 0) {
                    // 有统一内容库权限
                    this.libraryDirInstance.open({
                        folderType: '0'
                    }).then(res=>{
                        this.libraryDirInfo = res
                        let uploadBtn = document.getElementById('httpUpBtnPreWater')
                        uploadBtn.click();
                        this.showWriteUpload = false;
                    })
                }else {
                    let uploadBtn = document.getElementById('httpUpBtnPreWater')
                    uploadBtn.click();
                    this.showWriteUpload = false;
                }
            }
        },
        getArticleOnlyTag(id) {

            let info = {
                id: id
            }

            common
            .myFetch(apis.newMediaPlatformInfo, info)
            .then(r => {
                if (r) {
                    let platformNum = 0
                    if(r.detail.platforms.length > 0){
                        r.detail.platforms.forEach(el => {
                            if(el.list.length > 0){
                                el.list.forEach(els => {
                                    platformNum ++
                                })
                            }
                        })
                    }

                    this.platformNum = platformNum
                    this.$nextTick(() => {
                        this.tags = r.detail.tags
                        this.task_id = r.detail.task_id
                        this.tagName = ''
                        this.specialTagName = ''
                        this.subTagName = []
                        this.inputTags = []
                        if(r.detail.platform_key == "b_plus"){
                            if(r.detail.tag_lists.tagName){
                                this.tagName = r.detail.tag_lists.tagName
                                this.subTagName = r.detail.tag_lists.subTagName
                                this.inputTags = r.detail.tag_lists.inputTags
                                let tags = [r.detail.tag_lists.tagName,...r.detail.tag_lists.subTagName,...r.detail.tag_lists.inputTags]
                                this.tags = tags
                            }else{
                                this.tagName = ''
                                this.subTagName = []
                                this.inputTags = []
                            }
                        }else if((r.detail.platform_key != "b_plus" && r.detail.platform_key != "dy" && r.detail.platform_key != "five_star_sports_cms" && r.detail.platform_key != "bilibili" && this.mediaType == 5) || (this.mediaType == 6 && r.detail.platform_key != "five_star_sports_cms")){

                            if(r.detail.tag_lists.location && r.detail.tag_lists.location.length > 0){
                                r.detail.tag_lists.location.forEach(item => {
                                    item.list.forEach(el => {
                                        if(el.selected){
                                            this.tagName = item.tab+'-'+el.name
                                        }
                                    })
                                })

                                if(!this.tagName){
                                    r.detail.tag_lists.location.forEach(item => {
                                        if(item.selected){
                                            this.tagName = item.tab
                                        }
                                    })
                                }
                            }

                            

                            if(r.detail.tag_lists.special && r.detail.tag_lists.special.length > 0) {
                                r.detail.tag_lists.special.forEach(item => {
                                    item.list.forEach(el => {
                                        if(el.selected){
                                            this.specialTagName = item.tab+'-'+el.name
                                        }
                                    })
                                })

                                if(!this.specialTagName){
                                    r.detail.tag_lists.special.forEach(item => {
                                        if(item.selected){
                                            this.specialTagName = item.tab
                                        }
                                    })
                                }
                            }


                            let tagArr = []

                            if(r.detail.input_tags){
                                tagArr = r.detail.input_tags.split(',')
                                this.inputTags = tagArr
                            }
                            

                            let tags = [this.tagName,this.specialTagName,...tagArr]
                            this.tags = tags

                            this.writeTagList = r.detail.tag_lists
                            
                        }
                    })
                }
            });
            },
        getArticle(id) {

            this.articleId = id

            let info = {
                id: id
            }

            common
            .myFetch(apis.newMediaPlatformInfo, info)
            .then(r => {
                if (r) {
                    this.setAutoSave()
                    console.log('rrrrrrr---34344',r)
                    this.articleDetail = r.detail
                    this.task_id = r.detail.task_id
                    this.mediaType = Number(r.detail.type)
                    this.show_info = r.detail.show_info
                    this.show_poster = r.detail.show_poster
                    this.show_reporter = r.detail.show_reporter

                    let platformNum = 0
                    if(r.detail.platforms.length > 0){
                        r.detail.platforms.forEach(el => {
                            if(el.list.length > 0){
                                el.list.forEach(els => {
                                    platformNum ++
                                })
                            }
                        })
                    }

                    this.platformNum = platformNum

                    this.is_last_audit = r.detail.is_last_audit || 0

                    if(!this.materialList[id]){
                        this.materialList[id] = {
                            id: id,
                            title: r.title || '',
                            push_platform: r.push_platform,
                            logo_key: '',
                            info: '',
                            tags: '',
                            pid: this.id,
                            file_id: '',
                            from: '',
                            has_copyright: 1,
                            imgTxt: {},
                            cover_tsp: 0
                        }
                    }

                    if(this.articleDetail.reject_remark){
                        this.errMessage = this.articleDetail.reject_remark
                    }

                    this.$nextTick(() => {
                        if(r.detail.poster){
                            this.postCover = r.detail.poster
                        }else{
                            this.postCover = ''
                        }

                        this.materialList[this.articleId].title = r.detail.title;

                        this.videoSummary = r.detail.info

                        if(this.selectPlatform == 'dy'){
                            
                            this.$refs.specialContent.innerHTML = r.detail.info
                            // console.log(786, this.articleId, this.$refs.specialContent.innerText )
                            this.materialList[this.articleId].title = this.$refs.specialContent.innerText || '无作品描述'
                        }
                    
                        this.showEmpty = false;
                        this.showVideo = false;
                        this.showUpload = true;
                        this.showProgress = false;
                        this.showPlayBtn = true;
                        this.push_third_publish = r.detail.push_third_publish || 1;
                        this.tags = r.detail.tags
                        this.cover = r.detail.cover
                        this.release_config = r.detail.release_config
                        this.showSetting = true;
                        this.showMaterial = true;
                        this.titleInput = r.detail.title;
                        this.originInput = r.detail.title;
                        this.logoList = r.detail.logos
                        this.knews_column = r.detail.knews_column
                        this.source = r.detail.from
                        this.reporter = r.detail.reporter
                        this.materialList[this.articleId].file_id = r.detail.type == 8 ? r.detail.audio_id : r.detail.type == 7 ? r.detail.image_id : r.detail.video_id
                        this.materialList[this.articleId].push_platform = r.detail.push_platform
                        this.editor = r.detail.editor
                        this.responsible_editor = r.detail.responsible_editor
                        this.video_editor = r.detail.video_editor
                        this.art_editor = r.detail.art_editor
                        this.cameraman = r.detail.cameraman
                        this.courier = r.detail.courier

                        this.selectIndex = 999
                        this.selectIndex1 = 999
                        this.selectName = '请选择'
                        this.selectName1 = '请选择'
                        this.viceTitle = r.detail.second_title
                        this.showWriteVideo = false;
                        this.tagName = ''
                        this.specialTagName = ''
                        this.subTagName = []
                        this.inputTags = []
                        this.share_title = r.detail.share_title
                        this.share_content = r.detail.share_content

                        if(r.detail.partition_id && this.biliPartition && this.biliPartition.length > 0){
                            // this.partition_id = Number(r.detail.partition_id)
                            let arr = []
                            this.biliPartition.forEach(el => {
                                if(el.children && el.children.length > 0){
                                    el.children.forEach(el1 => {
                                        if(el1.id == r.detail.partition_id){
                                            arr.push(Number(el1.parent))
                                            arr.push(Number(el1.id))
                                        }
                                    })
                                }
                            })

                            this.partition_id = arr
                        }
                        
                        if(r.detail.partition_name){
                            this.partition_name = r.detail.partition_name
                        }   

                        if(r.detail.b_type){
                            this.b_type = r.detail.b_type
                        }
                        
                        if(r.detail.is_share){
                            this.is_share = r.detail.is_share
                        }

                        if(r.detail.share_text){
                            this.share_text = r.detail.share_text
                        }

                        if(r.detail.playlistRemark){
                            this.playlistRemark = r.detail.playlistRemark
                        }else{
                            this.playlistRemark = ''
                        }

                        if(r.detail.platform_key == "five_star_sports_cms"){
                            this.postCover = r.detail.share_cover
                        }
                        if(r.detail.platform_key != "b_plus" && r.detail.platform_key != "dy" && r.detail.platform_key != "five_star_sports_cms"  && r.detail.platform_key != "five_star_sports_cms" && this.mediaType == 6 && !this.firstLoad){
                            // console.log(754)
                            this.setImgContent()
                        }

                        if(r.detail.platform_key == 'five_star_sports_cms' && this.mediaType == 6 && !this.firstLoad){
                            this.setVideoContent()
                        }

                        if(r.detail.platform_key == "b_plus"){
                            if(r.detail.tag_lists.tagName){
                                this.tagName = r.detail.tag_lists.tagName
                                this.subTagName = r.detail.tag_lists.subTagName
                                this.inputTags = r.detail.tag_lists.inputTags
                                let tags = [r.detail.tag_lists.tagName,...r.detail.tag_lists.subTagName,...r.detail.tag_lists.inputTags]
                                this.tags = tags
                            }else{
                                this.tagName = ''
                                this.subTagName = []
                                this.inputTags = []
                            }
                        }else if((r.detail.platform_key != "b_plus" && r.detail.platform_key != "five_star_sports_cms" && r.detail.platform_key != "dy" && r.detail.platform_key != "bilibili" && this.mediaType == 5) || (this.mediaType == 6 && r.detail.platform_key != "five_star_sports_cms")){
                            if(r.detail.copy_right.length > 0){
                                r.detail.copy_right.forEach(el => {
                                    if(el.selected){
                                        this.bqIndex = el.key
                                    }
                                })
                            }

                            if(r.detail.tag_lists.location && r.detail.tag_lists.location.length > 0){
                                r.detail.tag_lists.location.forEach(item => {
                                    item.list.forEach(el => {
                                        if(el.selected){
                                            this.tagName = item.tab+'-'+el.name
                                        }
                                    })
                                })

                                if(!this.tagName){
                                    r.detail.tag_lists.location.forEach(item => {
                                        if(item.selected){
                                            this.tagName = item.tab
                                        }
                                    })
                                }
                            }

                            

                            if(r.detail.tag_lists.special && r.detail.tag_lists.special.length > 0) {
                                r.detail.tag_lists.special.forEach(item => {
                                    item.list.forEach(el => {
                                        if(el.selected){
                                            this.specialTagName = item.tab+'-'+el.name
                                        }
                                    })
                                })

                                if(!this.specialTagName){
                                    r.detail.tag_lists.special.forEach(item => {
                                        if(item.selected){
                                            this.specialTagName = item.tab
                                        }
                                    })
                                }
                            }


                            let tagArr = []

                            if(r.detail.input_tags){
                                tagArr = r.detail.input_tags.split(',')
                                this.inputTags = tagArr
                            }
                            

                            let tags = [this.tagName,this.specialTagName,...tagArr]
                            this.tags = tags

                            this.writeTagList = r.detail.tag_lists
                            // this.normalContent = ''
                            this.normalContent = r.detail.content

                            console.log(22222,this.normalContent)
                            // this.$nextTick(() => {
                            //     this.setImgContent(r.detail.content)
                            // })
                            
                        }

                        if(r.detail.platform_key == "five_star_sports_cms"){
                            this.normalContent = r.detail.content
                        }

                        // let duration = this.hms2s(r.detail)
                        r.detail.logos.forEach((el,index) => {
                            if(el.selected){
                                this.selectIndex = index
                                this.selectName = el.logo_title
                            }
                        })

                        if(r.detail.knews_column && r.detail.knews_column.length > 0){
                            r.detail.knews_column.forEach((el,index) => {
                                if(el.selected){
                                    this.selectIndex1 = index
                                    this.selectName1 = el.title
                                }
                            })
                        }

                        if(r.detail.platform_key == 'bilibili' && r.detail.logo_key){
                            r.detail.logos.forEach((el,index) => {
                                if(el.logo_key == r.detail.logo_key){
                                    this.selectIndex = index
                                    this.selectName = el.logo_title
                                }
                            })
                        }

                        // console.log(98777)

                        this.uploadTitle = '上传视频'
                        this.mediaPublishDetail.files.forEach(el => {
                            console.log(98777222222,el.id, r.detail.image_id)
                            if((el.id == r.detail.video_id && (r.detail.type == 6 || r.detail.type == 5)) || (el.id == r.detail.image_id && r.detail.type == 7) || (el.id == r.detail.audio_id && r.detail.type == 8)){
                                console.log(98777111111)
                                this.showEmpty = false;
                                this.showVideo = true;
                                this.showUpload = false;
                                this.showProgress = false;
                                this.showWriteVideo = true;
                                
                                this.showPlayBtn = true;
                                this.currentTime = '00:00';
                                this.duration = '00:00';
                                this.audioPercent = '0%';
                                let resolution = []
                                if(el.content && el.content.resolution){
                                    resolution = el.content.resolution.split('x')
                                }
                                let isRow = false;
                                let duration = 0
                                if(el.content && el.content.duration){
                                    duration = this.hms2s(el.content.duration)
                                }
                                this.duration = this.s2hms(duration)
                                if(Number(resolution[0]) > Number(resolution[1])){
                                    isRow = true
                                }else{
                                    isRow = false
                                }
                                el.isRow = isRow
                                el.d = this.$route.query.d
                                this.videoDetail = el

                                this.$nextTick(() => {
                                    if(this.$refs.video && r.detail.type == '5'){
                                        this.$refs.video.removeEventListener('ended',() => {})
                                        this.$refs.video.removeEventListener('timeupdate',() => {})
                                        this.$refs.video.volume  = 0.5

                                        this.$refs.video.addEventListener('ended', () => {
                                            this.showPlayBtn = true
                                        })

                                        this.$refs.video.addEventListener('timeupdate', (e) => {
                                            console.log(e)
                                            this.currentTime = this.s2hms(this.$refs.video.currentTime)
                                            this.audioPercent = ((this.$refs.video.currentTime / this.$refs.video.duration) * 100) + '%'
                                        })

                                        this.$refs.video.addEventListener('play', () => {
                                            this.showPlayBtn = false
                                        })

                                        this.$refs.video.addEventListener('pause', () => {
                                            this.showPlayBtn = true
                                        })
                                    }

                                    if(this.$refs.audio && r.detail.type == '8'){
                                        this.$refs.audio.removeEventListener('ended',() => {})
                                        this.$refs.audio.removeEventListener('timeupdate',() => {})
                                        this.$refs.audio.volume  = 0.5

                                        this.$refs.audio.addEventListener('ended', () => {
                                            this.showPlayBtn = true
                                        })

                                        this.$refs.audio.addEventListener('timeupdate', (e) => {
                                            console.log(e)
                                            this.currentTime = this.s2hms(this.$refs.audio.currentTime)
                                            this.audioPercent = ((this.$refs.audio.currentTime / this.$refs.video.duration) * 100) + '%'
                                        })

                                        this.$refs.audio.addEventListener('play', () => {
                                            this.showPlayBtn = false
                                        })

                                        this.$refs.audio.addEventListener('pause', () => {
                                            this.showPlayBtn = true
                                        })
                                    }
                                })
                            }
                        })

                        this.$nextTick(() => {
                            if(this.$refs.video){
                                this.$refs.video.pause();
                            }

                            if(this.$refs.aduio){
                                this.$refs.aduio.pause();
                            }


                            if(this.selectPlatform == 'dy'){
                                this.cover_tsp = r.detail.cover_tsp
                                // this.$refs.specialContent.innerHTML = r.detail.info;
                                // this.materialList[this.articleId].title = this.$refs.specialContent.innerText || '无作品描述'
                                this.topicNumber = this.$refs.specialContent.innerText.length;
                                this.mediaPublishDetail.platforms.forEach(el => {
                                    el.list.forEach(val => {
                                        if(val.id == this.articleId){
                                            val.title = this.$refs.specialContent.innerText
                                        }
                                    })
                                })
                            }
                        })
                    })
                }
            });
        },
        getPlatform(fileId) {
            let info = {
                id: this.id
            }
            common
            .myFetch(apis.newMediaPlatformInfo, info)
            .then(async r => {
                if (r) {
                    let platformNum = 0
                    this.showNotice = r.need_notice
                    this.task_id = r.detail.task_id
                    this.auto_available = r.detail.auto_available
                    if(r.detail.files.length > 0){
                        r.detail.files.forEach(el => {
                            el.showBtn = false;
                        })
                    }

                    if(r.detail.platforms.length > 0){
                        r.detail.platforms.forEach(el => {
                            if(el.list.length > 0){
                                el.list.forEach(els => {
                                    platformNum ++
                                })
                            }
                        })
                    }

                    this.platformNum1 = platformNum

                    this.mediaPublishDetail = r.detail

                    if(r.detail.platform_key == 'bilibili'){
                        await this.getBiliPartition(r.detail.column_key)
                    }

                    this.$nextTick(() => {
                        this.setAutoSave()
                        if(!this.articleId){
                            let mainList = document.getElementsByClassName('channel-container')[0];
                            let list = mainList.getElementsByClassName('article-container');
                            if(list.length > 0){
                                list[0].getElementsByClassName('left')[0].click()
                            }
                            // console.log(list.length)
                        }
                    })

                    if(fileId){
                        r.detail.files.forEach(el => {
                            if(el.id == fileId){
                                console.log(1111111,el)
                                // this.videoDetail = el
                                if(this.$refs.video){
                                    this.$refs.video.pause();
                                    this.$refs.video.removeEventListener('ended',() => {
                                        
                                    })
                                    this.$refs.video.removeEventListener('timeupdate',() => {
                                        
                                    })
                                }

                                if(this.$refs.audio){
                                    this.$refs.audio.pause();
                                    this.$refs.audio.removeEventListener('ended',() => {
                                        
                                    })
                                    this.$refs.audio.removeEventListener('timeupdate',() => {
                                        
                                    })
                                }
                                // this
                                this.showPlayBtn = true;
                                this.currentTime = '00:00';
                                this.duration = '00:00';
                                this.audioPercent = '0%';
                                let resolution = []
                                if(el.content && el.content.resolution){
                                    resolution = el.content.resolution.split('x')
                                }
                                let isRow = false;
                                let duration = 0
                                if(el.content && el.content.duration){
                                    duration = this.hms2s(el.content.duration)
                                }
                                this.duration = this.s2hms(duration)
                                if(Number(resolution[0]) > Number(resolution[1])){
                                    isRow = true
                                }else{
                                    isRow = false
                                }
                                el.isRow = isRow
                                el.d = this.$route.query.d
                                this.videoDetail = el
                                // console.log(this.videoDetail)
                                this.$nextTick(() => {
                                    if(this.$refs.video){
                                        this.$refs.video.volume  = 0.5

                                        this.$refs.video.addEventListener('ended', () => {
                                            this.showPlayBtn = true
                                        })

                                        this.$refs.video.addEventListener('timeupdate', (e) => {
                                            // console.log(e)
                                            this.currentTime = this.s2hms(this.$refs.video.currentTime)
                                            this.audioPercent = ((this.$refs.video.currentTime / this.$refs.video.duration) * 100) + '%'
                                        })

                                        this.$refs.video.addEventListener('play', () => {
                                            this.showPlayBtn = false
                                        })

                                        this.$refs.video.addEventListener('pause', () => {
                                            this.showPlayBtn = true
                                        })
                                    }

                                    if(this.$refs.audio){
                                        this.$refs.audio.volume  = 0.5

                                        this.$refs.audio.addEventListener('ended', () => {
                                            this.showPlayBtn = true
                                        })

                                        this.$refs.audio.addEventListener('timeupdate', (e) => {
                                            // console.log(e)
                                            this.currentTime = this.s2hms(this.$refs.audio.currentTime)
                                            this.audioPercent = ((this.$refs.audio.currentTime / this.$refs.audio.duration) * 100) + '%'
                                        })

                                        this.$refs.audio.addEventListener('play', () => {
                                            this.showPlayBtn = false
                                        })

                                        this.$refs.audio.addEventListener('pause', () => {
                                            this.showPlayBtn = true
                                        })
                                    }
                                })
                            }
                        })
                    }

                    let picNum = this.mediaPublishDetail.files.filter((el) => {
                        return el.type == 1
                    }).length

                    let videoNum = this.mediaPublishDetail.files.filter((el) => {
                        return el.type == 2
                    }).length

                    let audioNum = this.mediaPublishDetail.files.filter((el) => {
                        return el.type == 3
                    }).length

                    if(picNum > 0 && videoNum == 0 && audioNum == 0){
                        this.selectType = 1
                    }else if(picNum == 0 && videoNum > 0 && audioNum == 0){
                        this.selectType = 2
                    }else if(picNum == 0 && videoNum == 0 && audioNum > 0){
                        this.selectType = 3
                    }else if(picNum > 0 && videoNum > 0 && audioNum > 0){
                        this.selectType = 1
                    }
                }
            });
        },
        getPlatformDrop(fileId) {
            this.handleSaved()
            let info = {
                id: this.id
            }
            common
            .myFetch(apis.newMediaPlatformInfo, info)
            .then(r => {
                if (r) {
                    if(r.detail.files.length > 0){
                        r.detail.files.forEach(el => {
                            el.showBtn = false;
                        })
                    }

                    let platformNum = 0
                    if(r.detail.platforms.length > 0){
                        r.detail.platforms.forEach(el => {
                            if(el.list.length > 0){
                                el.list.forEach(els => {
                                    platformNum ++
                                })
                            }
                        })
                    }

                    this.platformNum = platformNum

                    this.mediaPublishDetail = r.detail

                    this.task_id = r.detail.task_id

                    r.detail.files.forEach(el => {
                        if(el.id == fileId && el.type == 2 && fileId == this.materialList[this.articleId].file_id){
                            this.showEmpty = false;
                            this.showUpload = false;
                            this.showProgress = false;
                            this.showVideo = true
                            console.log(el,this.materialList[this.articleId])
                            if(el.content && el.content.duration){
                                let duration = this.hms2s(el.content.duration)
                                this.duration = this.s2hms(duration)
                            }
                            if(el.content && el.content.resolution){
                                let resolution = el.content.resolution.split('x')
                                let isRow = false;
                                if(Number(resolution[0]) > Number(resolution[1])){
                                    isRow = true
                                }else{
                                    isRow = false
                                }
                                el.isRow = isRow
                            }
                            el.d = this.$route.query.d
                            this.videoDetail = el

                            if(this.selectPlatform == 'dy'){
                                // this.cover = ''
                                this.materialList[this.articleId].cover_tsp = 0
                                this.cover_tsp = 0;
                                this.getCover()
                                // this.cover = this.defaultCover
                                // let info = {
                                //     id: this.articleId,
                                //     file_id: ''
                                // }
                                // common
                                // .myFetch(apis.newMediaPlatformSetCover, info)
                                // .then(r => {
                                //     if (r) {
                                //         this.cover = this.defaultCover
                                //         // this.getPlatform()
                                //         // console.log(r)
                                //     }
                                // });
                            }
                            
                            if(this.mediaType == 5){
                                this.$nextTick(() => {
                                    this.$refs.video.volume  = 0.5

                                    this.$refs.video.addEventListener('ended', () => {
                                        this.showPlayBtn = true
                                    })

                                    this.$refs.video.addEventListener('timeupdate', (e) => {
                                        // console.log(e)
                                        this.currentTime = this.s2hms(this.$refs.video.currentTime)
                                        this.audioPercent = ((this.$refs.video.currentTime / this.$refs.video.duration) * 100) + '%'
                                    })

                                    this.$refs.video.addEventListener('play', () => {
                                        this.showPlayBtn = false
                                    })

                                    this.$refs.video.addEventListener('pause', () => {
                                        this.showPlayBtn = true
                                    })
                                })
                            }else if(this.mediaType == 8){
                                this.$nextTick(() => {
                                    this.$refs.audio.volume  = 0.5

                                    this.$refs.audio.addEventListener('ended', () => {
                                        this.showPlayBtn = true
                                    })

                                    this.$refs.audio.addEventListener('timeupdate', (e) => {
                                        // console.log(e)
                                        this.currentTime = this.s2hms(this.$refs.audio.currentTime)
                                        this.audioPercent = ((this.$refs.audio.currentTime / this.$refs.audio.duration) * 100) + '%'
                                    })

                                    this.$refs.audio.addEventListener('play', () => {
                                        this.showPlayBtn = false
                                    })

                                    this.$refs.audio.addEventListener('pause', () => {
                                        this.showPlayBtn = true
                                    })
                                })
                            }else{
                                this.showWriteVideo = true;
                            }
                        }else if(el.id == fileId && el.type == 1 && fileId == this.materialList[this.articleId].file_id){
                            this.showEmpty = false;
                            this.showUpload = false;
                            this.showProgress = false;
                            this.showVideo = true

                            if(el.content && el.content.duration){
                                let duration = this.hms2s(el.content.duration)
                                this.duration = this.s2hms(duration)
                            }
                            
                            if(el.content && el.content.resolution){
                                let resolution = el.content.resolution.split('x')
                                let isRow = false;
                                if(Number(resolution[0]) > Number(resolution[1])){
                                    isRow = true
                                }else{
                                    isRow = false
                                }
                                el.isRow = isRow
                            }
                            el.d = this.$route.query.d
                            this.videoDetail = el
                            this.showWriteVideo = true;
                        }else if(el.id == fileId && el.type == 3 && fileId == this.materialList[this.articleId].file_id){
                            this.showEmpty = false;
                            this.showUpload = false;
                            this.showProgress = false;
                            this.showVideo = true

                            if(el.content && el.content.duration){
                                let duration = this.hms2s(el.content.duration)
                                this.duration = this.s2hms(duration)
                            }

                            if(el.content && el.content.resolution){
                                let resolution = el.content.resolution.split('x')
                                let isRow = false;
                                if(Number(resolution[0]) > Number(resolution[1])){
                                    isRow = true
                                }else{
                                    isRow = false
                                }
                                el.isRow = isRow
                            }
                            el.d = this.$route.query.d
                            this.videoDetail = el

                            this.$nextTick(() => {
                                this.$refs.audio.volume  = 0.5

                                this.$refs.audio.addEventListener('ended', () => {
                                    this.showPlayBtn = true
                                })

                                this.$refs.audio.addEventListener('timeupdate', (e) => {
                                    // console.log(e)
                                    this.currentTime = this.s2hms(this.$refs.audio.currentTime)
                                    this.audioPercent = ((this.$refs.audio.currentTime / this.$refs.audio.duration) * 100) + '%'
                                })

                                this.$refs.audio.addEventListener('play', () => {
                                    this.showPlayBtn = false
                                })

                                this.$refs.audio.addEventListener('pause', () => {
                                    this.showPlayBtn = true
                                })
                            })
                        }
                    })
                }
            });
        },
        renameTitle() {
            if(this.originInput != this.titleInput){
                this.mediaPublishDetail.platforms.forEach(el => {
                    el.list.forEach(val => {
                        if(val.id == this.articleId){
                            val.title = this.titleInput
                            this.originInput = this.titleInput
                        }
                    })
                })
                this.autoSaveNoLoad(this.articleId)
            }
        },
        watchViceTitle() {
            let str = this.viceTitle;
            this.getLength1(str);
        },
        watchTitle() {
            let str = this.titleInput;
            this.getLength(str);
        },
        getLength(str) {
            var n = null;
            for (var i = 0; i < str.length; i++) {
                if (str.charCodeAt(i) >= 0 && str.charCodeAt(i) <= 256) {
                n += 0.5;
                } else {
                n += 1;
                }
            }

            if(this.selectPlatform == 'dy' || this.selectPlatform == 'b_plus'){
                if (n <= 60) {
                    this.saveTitleInput = this.titleInput;
                } else {
                    this.titleInput = this.saveTitleInput;
                }
            }

            this.wordNum = Math.ceil(n);
        },
        getLength1(str) {
            var n = null;
            for (var i = 0; i < str.length; i++) {
                if (str.charCodeAt(i) >= 0 && str.charCodeAt(i) <= 256) {
                n += 0.5;
                } else {
                n += 1;
                }
            }

            this.wordNum1 = Math.ceil(n);
        },
        delArticle(id) {
            let config = {
                title: '确认要删除该稿件吗？',
                content: '此操作将永久删除该稿件，是否继续？',
                btn1: '确定',
                btn2: '取消',
                showIcon: true
            }

            this.$MediaPlatformNotify(config).then(e => {
                if(e) {
                    delete this.materialList[Number(id)]
                    this.articleId = null
                    let info = {
                        id: id
                    };

                    common
                    .myFetch(apis.newMediaPlatformMyDel, info)
                    .then(r => {
                        if (r) {
                            if(this.$refs.video){
                                this.$refs.video.pause();
                            }
                            this.showEmpty = true;
                            this.showVideo = false;
                            this.showUpload = false;
                            this.showProgress = false;
                            this.showPlayBtn = true;
                            this.titleInput = '';
                            // this.mediaPublishDetail.platforms[index].list.push(r)
                            this.getPlatform()
                        }
                    });
                }
            })
        },
        delColumn(index) {
            let length = this.mediaPublishDetail.platforms[index].list.length
            let config = {
                title: '确认要删除该栏目吗？',
                content: '该栏目下有'+length+'篇稿件，是否继续删除？',
                btn1: '确定',
                btn2: '取消',
                showIcon: true
            }

            this.$MediaPlatformNotify(config).then(e => {
                if(e) {
                    let info = {
                        id: this.id,
                        column_key: this.mediaPublishDetail.platforms[index].c_key
                    };

                    common
                    .myFetch(apis.newMediaPlatformDelcolumn, info)
                    .then(r => {
                        if (r) {
                            console.log(r)
                            if(this.$refs.video){
                                this.$refs.video.pause();
                            }
                            this.showEmpty = true;
                            this.showVideo = false;
                            this.showUpload = false;
                            this.showProgress = false;
                            this.showPlayBtn = true;
                            // this.mediaPublishDetail.platforms[index].list.push(r)
                            this.getPlatform()
                        }
                    });
                }
            })
        },
        newArticle(content_type, index) {
            let platforms = []
            let contentType = []
            console.log(this.mediaPublishDetail.platforms[index])
            // this.mediaPublishDetail.platforms[index].content_types.forEach(el => {
            //     contentType.push(el.content_type)
            // })
            contentType.push(content_type)
            contentType = contentType.join(',')
            platforms.push({
                p_key: this.mediaPublishDetail.platforms[index].p_key,
                c_key: this.mediaPublishDetail.platforms[index].c_key,
                content_type: contentType
            })

            let materialList = this.materialList

            let info = {
                type: 5,
                platforms: JSON.stringify(platforms),
                main_id: this.id,
                submit_type: 0
            };

            common
            .myFetch(apis.newMediaPlatformCreate, info)
            .then(r => {
                if (r) {
                    console.log(r)
                    materialList[r.report_id] = {
                        id: r.report_id,
                        title: r.title || '',
                        push_platform: JSON.stringify(platforms),
                        logo_key: '',
                        info: '',
                        tags: '',
                        pid: this.id,
                        file_id: '',
                        from: '',
                        has_copyright: 1,
                        top_video_cover: '',
                        imgTxt: {},
                        cover_tsp: 0,
                        push_third_publish: 1,
                        editor: '',
                        responsible_editor: '',
                        video_editor: '',
                        art_editor: '',
                        cameraman: '',
                        courier: ''
                    }
                    this.materialList = materialList
                    console.log(this.materialList)
                    // this.mediaPublishDetail.platforms[index].list.push(r)
                    this.getPlatform()
                }
            });
        },
        recalc() {
            var clientWidth = document.documentElement.clientWidth;

            if (!clientWidth) {

                return;
            }

            var p = 100 * (clientWidth / 1334);

            var rightP = 100 * (clientWidth / 1920);

            if(rightP < 100){
                rightP = 100
            }

            this.rightP = rightP

            this.fontSizeWrite = p

            if(p<97.3){
                p=97.3
            }else if(p>110){
                p=110
            }

            this.fontSize = p
        },
        clickJumpHeight(e) {
            let clientY = this.$refs.volLine.getBoundingClientRect().y;
            let height = this.$refs.volLine.getBoundingClientRect().height;
            let top = 0;
            let volPercent = 0;

            if (e.clientY - clientY <= 0) {
                top = "100%";
            } else if (e.clientY - clientY >= this.$refs.volLine.getBoundingClientRect().height) {
                top = "0%";
            } else {
                volPercent = (100 - (((e.clientY - clientY) / height) * 100).toFixed(2)).toFixed(0);
                top = 100 - (((e.clientY - clientY) / height) * 100).toFixed(2) + "%";
            }

            this.volTop = volPercent;
            this.volPercent = top;

            // this.$refs.sliderLeft.style.width = left;

            // this.timeNavi();

            this.isVolMouseClick = false;
        },
        slideVolMouseMove(e) {
            // return false;
            if (this.isVolMouseClick) {
                let clientY = this.$refs.volLine.getBoundingClientRect().y;
                let height = this.$refs.volLine.getBoundingClientRect().height;
                let top = 0;
                let volPercent = 0;
                console.log(e.clientY - clientY )
                if (e.clientY - clientY <= 0) {
                    top = "100%";
                    volPercent = 100
                } else if (e.clientY - clientY >= this.$refs.volLine.getBoundingClientRect().height) {
                    top = "0%";
                    volPercent = 0
                } else {
                    volPercent = (100 - (((e.clientY - clientY) / height) * 100).toFixed(2)).toFixed(0);
                    top = 100 - (((e.clientY - clientY) / height) * 100).toFixed(2) + "%";
                }

                console.log(top)

                this.volTop = volPercent;
                this.volPercent = top;
            }
        },
        clickJump(e) {
            let clientX = this.$refs.line.getBoundingClientRect().x;
            let width = this.$refs.line.getBoundingClientRect().width;
            let left = 0;
            let percent = 0;

            if (e.clientX - clientX <= 0) {
                left = "0%";
            } else if (e.clientX - clientX >= this.$refs.line.getBoundingClientRect().width) {
                left = "100%";
            } else {
                percent = (((e.clientX - clientX) / width) * 100).toFixed(2);
                left = (((e.clientX - clientX) / width) * 100).toFixed(2) + "%";
            }

            this.percent = percent;
            this.audioPercent = left;

            if(this.mediaType == 8){
                this.$refs.audio.currentTime = this.$refs.audio.duration*percent/100
            }else{
                this.$refs.video.currentTime = this.$refs.video.duration*percent/100
            }
            // console.log(this.percent)

            // this.$refs.sliderLeft.style.width = left;

            this.timeNavi();

            this.isMouseClick = false;
        },
        timeNavi() {
            if (this.isMouseClick) {
                let percent = this.percent / 100;
                let time = (percent * this.duration).toFixed(2);
                // this.$refs.audioDom.currentTime = time;
                // this.$refs.audioDom.play();
                this.isPlay = true;
                this.isMouseClick = false;
            }
        },
        timeStop() {
            this.isPlay = false;
            // this.$refs.audioDom.pause();
        },
        slideMouseMove(e) {
            // return false;
            if (this.isMouseClick) {
                let clientX = this.$refs.line.getBoundingClientRect().x;
                let width = this.$refs.line.getBoundingClientRect().width;
                let left = 0;
                let percent = 0;

                if (e.clientX - clientX <= 0) {
                left = "0%";
                } else if (e.clientX - clientX >= this.$refs.line.getBoundingClientRect().width) {
                left = "100%";
                } else {
                percent = (((e.clientX - clientX) / width) * 100).toFixed(2);
                left = (((e.clientX - clientX) / width) * 100).toFixed(2) + "%";
                }

                // this.nowTime = this.s2hms(
                //     (this.$refs.audioDom.duration * percent) / 100
                // );

                this.percent = percent;
                this.audioPercent = left;

                // this.$refs.sliderLeft.style.width = left;
            }
        },
        s2hms(time) {
            var min = Math.floor(time % 3600);
            var hh =
                Math.floor(time / 3600) < 10
                ? "0" + Math.floor(time / 3600)
                : Math.floor(time / 3600);
            var mm =
                Math.floor(min / 60) < 10
                ? "0" + Math.floor(min / 60)
                : Math.floor(min / 60);
            var ss = time % 60 < 10 ? "0" + parseInt(time % 60) : parseInt(time % 60);
            if(Number(hh) > 0){
                mm = Number(hh)*60 + Number(mm)
            }
            return mm + ":" + ss;
            // console.log(hh + ":" + mm + ":"+ ss)
        },
        hms2s(time) {
            var hour = time.split(':')[0];
            var min = time.split(':')[1];
            var sec = time.split(':')[2];
            return Number(hour*3600) + Number(min*60) + Number(sec);
        },
        getUser() {
            common.myFetch(apis.Usr_menu, {}).then(r => {
                if (r) {
                    // console.log(r);
                    let create = {}
                    create.interview = r.create.interview;
                    create.material = r.create.material;
                    create.publish = r.create.publish;
                    create.report = r.create.report;
                    create.new_media = r.create.new_media;
                    this.$store.commit("setCreate", create);
                }
            });
        },
        getCover() {
            let info = {
                id: this.articleId
            };

            common
            .myFetch(apis.newMediaPlatformGetCover, info)
            .then(r => {
                if (r) {
                    // console.log(r)
                    this.cover = r.cover
                }
            });
        },
        getTranscode() {
            console.log('code')
            this.getPlatform()
            this.getCover()
        },
        getnewMediaTranscode(res){
            console.log(res)
            // this.materialList[this.articleId].file_id = res.content.id
            this.getCover()
            this.getPlatformDrop(res.content.id)

            if(this.selectPlatform == 'five_star_sports_cms' && this.mediaType == 6){
                let dom = this.normalWindow.document.querySelectorAll(`[data-fileid="${res.content.id}"]`)

                if(dom && dom.length > 0){
                    dom.forEach(el => {
                        let codeProgress = el.querySelector('.codeProgress')
                        if(codeProgress){
                            codeProgress.remove()
                            el.classList.remove('mask')
                            el.setAttribute('contenteditable', true)
                            el.innerHTML += `<video controls controlsList="nodownload" contextmenu="none" src="${res.content.url}"></video>`
                        }  
                    })
                }
            }
            // this.mediaPublishDetail.files.forEach(el => {
            //     if(el.id == res.content.id){
            //         el.transcode_finish = true
            //     }
            // })
            // this.videoDetail.transcode_finish = true
            // let resolution = res.content.content.data.resolution.split('x')
            // let isRow = false;
            // let duration = this.hms2s(res.content.content.data.duration)
            // this.duration = this.s2hms(duration)
            // if(Number(resolution[0]) > Number(resolution[1])){
            //     isRow = true
            // }else{
            //     isRow = false
            // }
            // this.videoDetail.isRow = isRow
            // this.videoDetail.d = this.$route.query.d
            // this.videoDetail.content = res.content.content
            // if(this.mediaType == 5){
            //     this.$nextTick(() => {
            //         this.$refs.video.volume  = 0.5

            //         this.$refs.video.removeEventListener('ended', () => {
            //             this.showPlayBtn = true
            //         })

            //         this.$refs.video.addEventListener('ended', () => {
            //             this.showPlayBtn = true
            //         })

            //         this.$refs.video.removeEventListener('timeupdate', (e) => {
            //             // console.log(e)
            //             this.currentTime = this.s2hms(this.$refs.video.currentTime)
            //             this.audioPercent = ((this.$refs.video.currentTime / this.$refs.video.duration) * 100) + '%'
            //         })

            //         this.$refs.video.addEventListener('timeupdate', (e) => {
            //             // console.log(e)
            //             this.currentTime = this.s2hms(this.$refs.video.currentTime)
            //             this.audioPercent = ((this.$refs.video.currentTime / this.$refs.video.duration) * 100) + '%'
            //         })
            //     })
            // }else{
            //     this.showWriteVideo = true;
            // }
        },
        setBtag() {

            if(this.mediaPublishDetail.status != 1){
                this.handleAutoSave()
            }
            
            let info = {
                platform_key: this.selectPlatform,
                column_key: this.selectColumn,
                id: this.articleId,
                isWrite: (this.selectPlatform != 'b_plus' && this.mediaType == 5) || this.mediaType == 6 ? true : false,
                writeTagList: this.writeTagList,
                inputTags: this.inputTags,
                content: this.normalContent,
                mediaType: this.mediaType
            }
            this.$MediaPlatformTag(info).then(e => {
                if(e){
                    console.log(e)
                    if((this.selectPlatform != 'b_plus' && this.mediaType == 5) || this.mediaType == 6){
                        this.tagName = e.tagId
                        this.specialTagName = e.sub_tagId
                        this.inputTags = e.tagListArr
                        let tags = [e.tagId,e.sub_tagId,...e.tagListArr]
                        this.tags = tags;
                    }else{
                        this.tagName = e.firstTagName
                        this.subTagName = e.secondTagName
                        this.inputTags = e.tagListArr
                        let tags = [e.firstTagName,...e.secondTagName,...e.tagListArr]
                        this.tags = tags;
                    }
                    this.getArticleOnlyTag(this.articleId)
                }
            })
        },
        setAutoSave() {
            if(this.auto_available == '1'){
                this.autoSaveInterval = this.autoSaveInterval || setInterval(() => {
                    this.handleAutoSave()
                }, 30000);
            }
        },
        setAutoLock() {
            this.autoLockInterval = this.autoLockInterval || setInterval(() => {
                this.handleAutoLock()
            }, 30000);
        },
        showSaveTip() {
            // 显示自动保存提示
            this.showAutoSave = true;

            setTimeout(() => {
                this.showAutoSave = false;
            }, 2000);
        },
        replaceBr(key) { 
            key = key.replace(/<\/?.+?>/g,"<br/>"); 
            key = key.replace(/[\r\n]/g, "<br/>"); 
            return key; 
        },
        insertHtmlAtCaret(html) {
            var ss = window.getSelection() || null;
            var sel, range;
            if (ss) {
                sel = ss;
                if (sel.getRangeAt && sel.rangeCount) {
                    range = sel.getRangeAt(0);
                    range.deleteContents && range.deleteContents();
                    var el = document.createElement("div");
                    el.innerHTML = html;
                    var frag = document.createDocumentFragment(),
                        node, lastNode;
                    while ((node = el.firstChild)) {
                        lastNode = frag.appendChild(node);
                    }
                    range.insertNode(frag);
                    if (lastNode) {
                        range = range.cloneRange();
                        range.setStartAfter(lastNode);
                        range.collapse(true);
                        sel.removeAllRanges();
                        sel.addRange(range);
                    }
                } else {
                    console.log('添加到最后', sel);
                    // IE < 9
                    let div1 = document.getElementById("div");
                    div1.innerHTML = div1.innerHTML + html
                }
            } else if (document.selection && document.selection.type != "Control") {
                document.selection.createRange().pasteHTML(html);
            }
        },
        showCloseTips(content) {
            // console.log(content)
            let params = JSON.parse(content.content)
            let status = false;
            if(params.child_list.length > 0){
                params.child_list.forEach(el => {
                    this.mediaPublishDetail.platforms.forEach(item => {
                        if(item.list.length > 0){
                            item.list.forEach(items => {
                                if((el.id == items.id && !this.isNowPage)){
                                    status = true
                                }else if((el.id == items.id && params.from != 'pc')){
                                    status = true
                                }
                            })
                        }
                    })
                })
            }

            // this.mediaPublishDetail.platforms.forEach(el => {
            //     el.list.forEach(items => {
            //         if(items.id == this.articleId){
            //             this.$auditDialog({type: 'notice', title: '溫馨提示', content1: '当前稿件已发布', content2: '', btn1: '确定', btn2: ''}).then(res => {

            //             })
            //         }
            //     })
            // })
            
            if(status){
                if(this.autoSaveInterval){
                    clearInterval(this.autoSaveInterval)
                    this.autoSaveInterval = null
                }
                this.$auditDialog({type: 'notice', title: '温馨提示', content1: params.title, content2: '', btn1: '确定', btn2: ''}).then(res => {
                    if(res){
                        if(window.opener != null || window.history.length == 1){
                            window.close()
                        }else{
                            common.jump('/mediaPublishLibrary/xinmeitifabuku')
                        }
                    }
                })
            }
        },
        // 加载子应用
        loadSubApp() {
            const timeStr = Date.now();
            const entryPath =
                process.env.NODE_ENV === "production"
                ? `${window.origin}/libraryCustom/`
                : "//localhost:5176";

            const parentInstance = {
                getUserKeys: () => {
                    return common.userKeys();
                },
                getCommon: () => {
                    return common;
                },
                getSystemConfig: () => {
                    return this.$_syscfg;
                },
                getThis: () => {
                    return this;
                },
                getCustomType: () => {
                    return 'mediaPublish';
                },
                customMediaPublish: {
                    setList: (list) => {
                        this.libraryMediaList = list
                    },
                    setLibraryDirInstance: (instance)=>{
                        this.libraryDirInstance = instance
                    }
                }
                
            }

            this.microApp = loadMicroApp(
                {
                    name: "unified-content-library_custom",
                    entry: entryPath + "?time=" + timeStr,
                    container: this.$refs.unifiedContentLibraryCustomRef,
                    props: { parentInstance: parentInstance, }
                },
                {
                    sandbox: {
                    experimentalStyleIsolation: true // 样式隔离
                    }
                }
                );
      
        },

        // 上传素材绑定统一内容库
        onLibraryBind(r) {
            if(this.libraryMediaList && this.libraryMediaList.length > 0) {
                if(r && r.list && r.list.length > 0) {
                    const id = r.list[0].file_id
                    common.myFetch(apis.File_bind_library, {
                        file_id_list: id,
                        to_folder_id: this.libraryDirInfo.id,
                        source_info: this.libraryDirInfo.sourceInfo,
                        doc_id: '',
                        folder_type: '0',
                    })

                }
            }
        }
    },
    beforeDestroy() {
        let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
        window.removeEventListener(resizeEvt, this.recalc, false);
        if(this.autoSaveInterval){
            clearInterval(this.autoSaveInterval)
            this.autoSaveInterval = null
        }

        // 组件销毁时手动卸载微应用
        if (this.microApp) {
            this.microApp.unmount();
            this.microApp = null;
            console.log('微应用已卸载');
        }
    },
    mounted() {
        this.loadSubApp()
        // this.$PreviewBili(2626)
        let that = this;
        var agent = navigator.userAgent.toLowerCase();
        if(agent.indexOf("chrome") > 0) {
            this.isChrome = true
        }else{
            this.isChrome = false
        }
        this.defaultImg = this.$_syscfg.default_img
        let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';

        window.addEventListener(resizeEvt, this.recalc, false);

        document.addEventListener('click',function(e){
            if(that.$refs.middleWater){
                if(that.$refs.middleWater.contains(e.target)) return;
                that.showWriteSelect = false    
            }
        })

        var hiddenProperty = 'hidden' in document ? 'hidden' :
        'webkitHidden' in document ? 'webkitHidden' :    
        'mozHidden' in document ? 'mozHidden' :    
        null;
        var visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange');
        var onVisibilityChange = () => {
            if (!document[hiddenProperty]) {    
                console.log('页面**');
                this.isNowPage = true;
            }else{
                this.isNowPage = false;
                console.log('页面非**')
            }
        }
        document.addEventListener(visibilityChangeEvent, onVisibilityChange);
 

        this.$refs.specialContent.addEventListener('paste',(event) => {
            // event.preventDefault();//先去除默认事件
            if (event.clipboardData || event.originalEvent) {
                var clipboardData = (event.clipboardData || window.clipboardData);
                var val = clipboardData.getData('text/plain');
                // var re=/(\n(?=(\n+)))+/g
                var str = this.replaceBr(val)
                event.preventDefault();
                // console.log(str)
                this.insertHtmlAtCaret(str)
            }
        })

        this.recalc()

        common.handleSocket(this.getTranscode, "transcode");

        common.handleSocket(this.getnewMediaTranscode, "new_media_transcode");

        common.handleSocket(this.getAudit, "auditComplete");

        document.onkeydown = function (e) {
            if(e.keyCode == 8 && !that.canAddTopic){
                let el = document.querySelectorAll('[data-topic="'+that.topicNum+'"]')
                if(el[0]){
                    that.canAddTopic = true;
                }
            }else if(e.keyCode == 13 && !that.canAddTopic){
                e.preventDefault()
                let el = document.querySelectorAll('[data-topic="'+that.topicNum+'"]')
                if(el[0]){
                    // let text = el[0].innerText + ' '
                    // el[0].innerText = text
                    el[0].setAttribute("contenteditable", "false");
                    el[0].className = 'on'
                    that.topicNum = that.topicNum + 1;
                    that.canAddTopic = true;
                }
                console.log(999,el)
            }else if(e.keyCode == 32 && !that.canAddTopic){
                e.preventDefault()
                let el = document.querySelectorAll('[data-topic="'+that.topicNum+'"]')
                if(el[0]){
                    // let text = el[0].innerText + ' '
                    // el[0].innerText = text
                    el[0].setAttribute("contenteditable", "false");
                    el[0].className = 'on'
                    that.topicNum = that.topicNum + 1;
                    that.canAddTopic = true;
                }
                // console.log(999,el)
            }
        }

        this.handleAutoLock()

        this.setAutoLock()
        
        
        common.handleSocket(this.showCloseTips, "newmedia_edit");
    },
    created() {
        // console.log(this.$store.state)
        this.isNew = !this.$route.query.d;
        this.id = this.$route.query.d;
        this.getPlatform()
        this.getUser()
        let c = {
            platformType: 'b'
        }
        // this.loadConfig().then(() => {
        //     // console.log('success')
        //     // this.$refs.mediaPublishUpload.setConfig()
        //     this.$refs.mediaPublishUpload.getNewUploadConfig()
        //     // this.$refs.coverUpload.setConfig()
        //     this.$refs.coverUpload.getNewUploadConfig()
        //     this.$refs.postUpload.getNewUploadConfig()
        //     // this.$refs.postUpload.setConfig()
        //     // this.$refs.mulCoverUpload.setConfig()
        //     this.$refs.mulCoverUpload.getNewUploadConfig()
        //     // console.log(this.$refs.preWaterUpload)
        //     // this.$refs.preWaterUpload.setConfig()
        //     this.$refs.preWaterUpload.getNewUploadConfig()
        // })

        this.loadNewConfig().then(res => {
            // console.log('loadNewConfig',res)
            this.$refs.mediaPublishUpload.getNewUploadConfig(res)
            this.$refs.coverUpload.getNewUploadConfig(res)
            this.$refs.postUpload.getNewUploadConfig(res)
            this.$refs.mulCoverUpload.getNewUploadConfig(res)
            this.$refs.preWaterUpload.getNewUploadConfig(res)
            this.$refs.audioUpload.getNewUploadConfig(res)
            this.$refs.imgUpload.getNewUploadConfig(res)
        }).catch(err => {
            this.$toast(err)
        })
        // this.$MediaPlatformTag()
    }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/global.less";
    .blur {
        width: 100%;
        height: 100%;
        filter: blur(5px);
        background-position: center center !important;
        background-size: 100% 100% !important;
    }

    .backDrop {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(5px);
    }
    .pic {
        flex-shrink: 0;
        width: 100%;
        height: 100%;
        border-radius: 4px;
        overflow: hidden;
        position: relative;
        cursor: pointer;
        .tags {
          position: absolute;
          padding: 4px 10px;
          background-color: rgba(0, 0, 0, 0.5);
          border-radius: 4px 0 16px 0;
          img {
            margin-left: 8px;
            cursor: pointer;
          }
          img:first-child {
            margin-left: 0;
          }
        }
        .main {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: contain;
          background: transparent;
        }
        .play {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          margin: auto;
          // box-shadow:4px 4px 10px 0 rgba(5,10,15,0.05);
        }
    }

    .m5 {
        position: absolute;
        top: 0;
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
    }

    .m6 {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
    }
    .TB-container {
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        z-index: 1000;

        .bg {
            position: absolute;
            z-index: -1;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(50, 59, 75, 0.3);
            backdrop-filter: blur(1.6px);
        }

        .TB-content {
            position: relative;
            display: flex;
            flex-direction: column;
            width: 480px;
            height: 440px;
            background: #F9F9F9;
            box-shadow: 4px 4px 10px 0px rgba(5,10,15,0.05);
            border-radius: 4px;
            padding: 20px 30px 24px;
            box-sizing: border-box;

            .title {
                font-size: 24px;
                line-height: 33px;
                color: #050F0F;
                margin-bottom: 20px;
                // font-weight: bold;
            }

            .content {
                position: relative;
                width: 100%;
                flex: 1;
                min-height: 0;
                background: rgba(185,195,195,0.15);
                border-radius: 4px;
                overflow: hidden;
                margin-bottom: 24px;
                padding: 20px;
                box-sizing: border-box;
                overflow-y: auto;

                &::-webkit-scrollbar {
                    width: 4px;
                }
                &::-webkit-scrollbar-thumb {
                    background: rgba(#dcdcdc, 0.3);
                    border-radius: 4px;
                }

                & > ul {
                    display: flex;
                    flex-direction: column;
                    margin-bottom: 20px;

                    & > li {
                        display: flex;
                        flex-direction: column;
                        border-bottom: 1px solid #DCDCDC;
                        box-sizing: border-box;
                        margin-bottom: 20px;

                        &:nth-last-of-type(1) {
                            margin-bottom: 0;
                        }

                        .t {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            user-select: none;
                            cursor: pointer;
                            margin-bottom: 15px;

                            & > span {
                                font-size: 14px;
                                line-height: 20px;
                                color: #323B4B;
                                margin-right: 6px;
                            }

                            div {
                                position: relative;
                                width: 16px;
                                height: 16px;
                                background: url('../../assets/img/mediaPublish/notify.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;

                                &:hover {
                                    width: 16px;
                                    height: 16px;
                                    background: url('../../assets/img/mediaPublish/noticeOn.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;

                                    p {
                                        display: flex;
                                    }
                                }

                                p {
                                    position: absolute;
                                    top: 22px;
                                    left: -20px;
                                    display: none;
                                    flex-direction: row;
                                    justify-content: center;
                                    align-items: center;
                                    width: 136px;
                                    height: 32px;
                                    background: rgba(0,15,15,0.8);
                                    border-radius: 4px;
                                    font-size: 12px;
                                    color: #FFFFFF;

                                    span {
                                        color: #41B48C;
                                    }
                                }
                            }
                        }

                        ul {
                            display: flex;
                            flex-direction: column;

                            li {
                                display: flex;
                                align-items: center;
                                margin-bottom: 24px;

                                p {
                                    flex: 1;
                                    min-width: 0;
                                    font-size: 13px;
                                    line-height: 18px;
                                    color: #41B48C;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                }
                                &.article {
                                    i {
                                        display: block;
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/mediaPublish/fileOn.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 8px;
                                    }
                                }

                                &.video {
                                    i {
                                        display: block;
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/mediaPublish/fileVideoOn.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 8px;
                                    }
                                }

                                &.pic {
                                    i {
                                        display: block;
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/mediaPublish/filePicOn.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 8px;
                                    }
                                }

                                &.voice {
                                    i {
                                        display: block;
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/mediaPublish/fileVoiceOn.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 8px;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .btns {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                width: 100%;

                .btn {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 120px;
                    height: 32px;
                    background: #B9C3C3;
                    border-radius: 4px;
                    color: #FFFFFF;
                    user-select: none;
                    cursor: pointer;

                    &.g {
                        background: #41B48C;
                        margin-right: 20px;
                    }
                }
            }

            .close {
                position: absolute;
                top: 20px;
                right: 30px;
                display: block;
                width: 24px;
                height: 24px;
                background: url('../../assets/img/common/editPicClose.svg') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                user-select: none;
                cursor: pointer;
            }
        }
    }
    .describe-container {
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        z-index: 1000;

        .bg {
            position: absolute;
            z-index: -1;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(50, 59, 75, 0.3);
            backdrop-filter: blur(1.6px);
        }

        .describe-content {
            position: relative;
            display: flex;
            flex-direction: column;
            width: 498px;
            height: 294px;
            background: #F9F9F9;
            box-shadow: 4px 4px 10px 0px rgba(5,10,15,0.05);
            border-radius: 4px;
            padding: 20px 30px 24px;
            box-sizing: border-box;

            .title {
                font-size: 24px;
                line-height: 33px;
                color: #050F0F;
                margin-bottom: 20px;
                // font-weight: bold;
            }

            .content {
                position: relative;
                width: 100%;
                height: 140px;
                background: rgba(185,195,195,0.2);
                border-radius: 4px;
                overflow: hidden;
                margin-bottom: 24px;

                textarea {
                    width: 100%;
                    height: 100%;
                    resize: none;
                    background: transparent;
                    padding: 15px;
                    box-sizing: border-box;
                    font-size: 16px;
                    line-height: 30px;

                    &::placeholder {
                        color: #C4CBD1;
                    }
                }

                span {
                    position: absolute;
                    bottom: 6px;
                    right: 14px;
                    font-size: 12px;
                    line-height: 17px;
                    color: #829191;
                }
            }

            .btns {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                width: 100%;

                .btn {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 120px;
                    height: 32px;
                    background: #B9C3C3;
                    border-radius: 4px;
                    color: #FFFFFF;
                    user-select: none;
                    cursor: pointer;

                    &.g {
                        background: #41B48C;
                        margin-right: 20px;
                    }
                }
            }

            .close {
                position: absolute;
                top: 20px;
                right: 30px;
                display: block;
                width: 24px;
                height: 24px;
                background: url('../../assets/img/common/editPicClose.svg') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                user-select: none;
                cursor: pointer;
            }
        }
    }
    .tips-container {
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        z-index: 100000003;

        .bg {
            position: absolute;
            z-index: -1;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(50, 59, 75, 0.3);
            backdrop-filter: blur(1.6px);
        }

        .tips-content {
            display: flex;
            flex-direction: column;
            width: 432px;
            background: #FFFFFF;
            box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
            border-radius: 4px;
            padding: 32px 32px 24px;
            box-sizing: border-box;

            .title {
                font-size: 16px;
                line-height: 24px;
                color: #323B4B;
                font-weight: bold;
                margin-bottom: 12px;
            }

            &>div {
                &:nth-of-type(1) {
                    margin-bottom: 14px;
                }
            }

            .noKnews {
                font-size: 14px;
                line-height: 22px;
                color: #666666;

                span {
                    color: #41B48C;
                }
            }

            .Knews {
                font-size: 14px;
                line-height: 22px;
                color: #666666;

                span {
                    color: #41B48C;
                }
            }

            .btns {
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                align-items: center;
                margin-top: 24px;

                p {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 65px;
                    height: 32px;
                    font-size: 14px;
                    background: #B9C3C3;
                    color: #FFF;
                    border-radius: 4px;
                    user-select: none;
                    cursor: pointer;

                    &.green {
                        background: #41B48C;
                        margin-right: 8px;
                    }
                }
            }
        }
    }

    .insertMedia-container {
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        z-index: 100000000;

        .bg {
            position: absolute;
            z-index: -1;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(50, 59, 75, 0.3);
            backdrop-filter: blur(1.6px);
        }

        .media-container {
            position: relative;
            display: flex;
            flex-direction: column;
            width: 548px;
            height: 280px;
            background: #FFFFFF;
            box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
            border-radius: 4px;
            padding: 20px 30px;
            box-sizing: border-box;

            &.hasLibrary {
                width: auto;
                ul.upload-f-list {
                    li {
                        margin: 0 25px;

                        &:nth-of-type(2) {
                            margin: 0 25px;
                        }
                    }
                }
            }

            .title {
                font-size: 24px;
                line-height: 33px;
                color: #323B4B;
                font-weight: bold;
            }

            .notice {
                &.on {
                    left: 158px;
                }

                position: absolute;
                top: 29px;
                left: 132px;
                display: flex;
                align-items: center;

                i {
                    display: block;
                    width: 14px;
                    height: 14px;
                    background: url('../../assets/img/mediaPublish/notice.png') no-repeat;
                    background-size: 100% 100%;
                    background-position: center center;
                    margin-right: 8px;
                }

                font-size: 14px;
                line-height: 22px;
                color: #666666;
            }

            .close {
                position: absolute;
                top: 20px;
                right: 30px;
                display: block;
                width: 24px;
                height: 24px;
                background: url('../../assets/img/common/editPicClose.svg') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                user-select: none;
                cursor: pointer;
            }

            ul {
                display: flex;
                flex-direction: row;
                justify-content: center;
                margin-top: 39px;
                &.upload-f-list {
                    justify-content: space-around;
                    li {
                        &:nth-of-type(2) {
                            margin: 0;
                        }
                    }
                }

                li {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    width: 106px;
                    height: 128px;
                    background: rgba(241, 243, 244, 0.4);
                    border-radius: 15px;
                    user-select: none;
                    cursor: pointer;

                    &:hover {
                        background: rgba(241, 243, 244, 0.8);
                    }

                    &:nth-of-type(2) {
                        margin: 0 50px;
                    }

                    i {
                        display: block;
                        width: 22px;
                        height: 22px;
                        background: url('../../assets/img/mediaPublish/plusIcon.png') no-repeat;
                        background-size: 100% 100%;
                        background-position: center center;
                        margin-bottom: 8px;
                    }

                    p {
                        font-size: 13px;
                        line-height: 18px;
                        color: #666666;
                    }
                }
            }
        }
    }

    .large-container {
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;

        .bg {
            position: absolute;
            z-index: -1;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(50, 59, 75, 0.3);
            backdrop-filter: blur(1.6px);
        }
    }
    .container {
        display: flex;
        flex-direction: column;
        overflow-y: hidden;
        background: #F1F3F4;

        .learnMask {
            position: relative;
            width: 100%;
            height: 100%;
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background: rgba(50, 59, 75, 0.3);
            border-radius: 2px;
            backdrop-filter: blur(1.6px);
            display: flex;
            justify-content: center;
            flex-direction: column;
            z-index: 1008;

            .learn {
                position: absolute;
                top: 103px;
                left: 175px;
            }

            .top {
                display: flex;
                flex-direction: row;
                margin-bottom: 16px;

                i {
                    display: block;
                    width: 30px;
                    height: 30px;
                    background: #FFFFFF;
                    border-radius: 50%;
                    background-image: url('../../assets/img/mediaPublish/addOn.png');
                    background-position: center center;
                    background-repeat: no-repeat;
                    background-size: 16px 16px;
                    margin-right: 19px;
                }

                img {
                    width: 139px;
                    height: 89px;
                }
            }

            .content {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                width: 460px;
                height: 200px;
                background: #FFFFFF;
                box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                border-radius: 4px;

                .left {
                    img {
                        width: 157px;
                        height: 115px;
                    }
                }

                .right {
                    display: flex;
                    flex-direction: column;
                    
                    .title {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        margin-left: 23px;

                        img {
                            width: 12px;
                            height: 16px;
                            margin-right: 14px;
                        }

                        p {
                            font-size: 22px;
                            line-height: 30px;
                            color: #323B4B;
                            font-weight: bold;
                        }
                    }

                    .article {
                        padding-left: 27px;
                        box-sizing: border-box;
                        width: 200px;
                        font-size: 16px;
                        line-height: 27px;
                        color: #666666;
                        margin-left: 23px;
                        margin-top: 10px;

                        img {
                            width: 18px;
                            height: 18px;
                            vertical-align: middle;
                        }
                    }

                    .btn {
                        width: 88px;
                        height: 32px;
                        background: #41B48C;
                        border-radius: 4px;
                        font-size: 14px;
                        font-weight: bold;
                        color: #FFFFFF;
                        line-height: 32px;
                        text-align: center;
                        margin-top: 10px;
                        margin-left: 124px;
                        user-select: none;
                        cursor: pointer;
                    }
                }
            }
        }

        .headline {
            position: relative;
            z-index: 9999999;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            min-width: 1134px;
            height: 52px;
            background: #FFFFFF;
            box-shadow: 0px 1px 0px 0px #EEEEEE;
            padding: 0 14px 0 0px;
            box-sizing: border-box;

            .left-container {
                display: flex;
                flex-direction: row;
                align-items: center;
                width: calc(100% - 360px);

                .back {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    user-select: none;
                    cursor: pointer;
                    // margin-right: 158px;
                    width: 234px;
                    height: 52px;
                    background-position: center center;
                    background-size: contain;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }

                    // p {
                    //     font-size: 14px;
                    //     line-height: 20px;
                    //     color: #323B4B;
                    //     font-weight: bold;
                    // }
                }

                .title-container {
                    display: flex;
                    position: relative;
                    width: 60%;
                    margin-left: 26px;

                    & > .t {
                        font-size: 16px;
                        color: #323B4B;
                        font-weight: bold;
                    }

                    &.on {
                        &:after {
                            display: block;
                            content: '*';
                            position: absolute;
                            top: 50%;
                            left: -15px;
                            font-size: 20px;
                            color: red;
                            transform: translate(0%, -50%);
                        }
                    }

                    .title {
                        flex: 1;
                        min-width: 0;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        overflow: hidden;

                        p {
                            font-size: 16px;
                            line-height: 22px;
                            font-weight: bold;
                            max-width: calc(100% - 32px);
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }

                        img {
                            width: 22px;
                            height: 22px;
                            margin-left: 10px;
                            user-select: none;
                            cursor: pointer;
                        }
                    }

                    .input {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        width: 100%;
                        height: 40px;
                        // padding-bottom: 6px;
                        padding: 0 10px;
                        border: 1px solid #41B48C;
                        border-radius: 5px;
                        box-sizing: border-box;

                        .disabled {
                            cursor: no-drop;
                        }

                        &.un {
                            border: 1px solid #FF555A;

                            p {
                                span {
                                    color: #FF555A;
                                }
                            }
                        }

                        input {
                            width: calc(100% - 54px);
                            height: 22px;
                            font-size: 16px;
                            line-height: 22px;
                            color: #323B4B;
                            font-weight: bold;
                        }

                        p {
                            width: 44px;
                            margin-left: 10px;                      
                            color: #829191;
                            font-size: 14px;
                            line-height: 22px;
                            font-weight: bold;
                        }
                    }
                }
            }

            .right-container {
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                align-items: center;
                min-width: 326px;
                margin-left: 34px;

                .auto-submit {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    margin-right: 34px;

                    i {
                        display: block;
                        width: 16px;
                        height: 16px;
                        background: rgba(130, 145, 145, 0.15);
                        border-radius: 8px;
                        margin-right: 8px;
                        user-select: none;
                        cursor: pointer;

                        &.on {
                            position: relative;
                            background: #41B48C;

                            &::after {
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                display: block;
                                content: '';
                                width: 6px;
                                height: 6px;
                                background: #FFFFFF;
                                border-radius: 20px;
                                margin-top: -3px;
                                margin-left: -3px;
                            }
                        }
                    }

                    p {
                        font-size: 13px;
                        line-height: 18px;
                        color: #323B4B;
                        font-weight: 500;
                    }
                }

                .btn {
                    width: 88px;
                    height: 32px;
                    line-height: 32px;
                    text-align: center;
                    // background: rgba(185, 195, 195, 0.2);
                    border: 1px solid #41B48C;
                    color: #41B48C;
                    border-radius: 4px;
                    margin-right: 14px;
                    font-size: 14px;
                    font-weight: bold;
                    // color: #829191;
                    user-select: none;
                    cursor: pointer;
                    box-sizing: border-box;

                    &:hover {
                        .btnHover
                    }   

                    &.green {
                        background: #41B48C;
                        color: #FFFFFF;
                        margin-right: 0;
                    }

                    &.grey {
                        border: 1px solid #A8B3B38C;
                        background: rgba(168, 179, 179, 0.1);
                        color: #A8B3B3;
                    }
                }
            }
        }

        .content-container {
            display: flex;
            flex-direction: row;
            width: 100%;
            height: calc(100vh - 52px);

            .left-container {
                min-width: 234px;
                height: 100%;
                background: #FAFBFC;
                padding: 14px 0px;
                box-sizing: border-box;

                .addBtn {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    width: 214px;
                    height: 28px;
                    line-height: 28px;
                    background: rgba(65, 180, 140, 0.1);
                    border-radius: 4px;
                    border: 1px solid #41B48C;
                    box-sizing: border-box;
                    margin: 0 auto;
                    user-select: none;
                    cursor: pointer;
                    
                    &.grey {
                        border: 1px solid #A8B3B38C;
                        background: rgba(168, 179, 179, 0.1);

                        p {
                            font-size: 14px;
                            font-weight: bold;
                            color: #A8B3B3;
                        }
                    }

                    &.green {
                        &:hover {
                            .btnHover
                        }
                    }

                    img {
                        width: 14px;
                        height: 14px;
                        margin-right: 6px;
                    }

                    p {
                        font-size: 14px;
                        font-weight: bold;
                        color: #41B48C;
                    }
                }

                .channel-container {
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    height: calc(100% - 28px);

                    &.auto {
                        overflow-y: auto;
                    }

                    &::-webkit-scrollbar {
                        width: 0px;
                    }
                    &::-webkit-scrollbar-thumb {
                        background: rgba(#dcdcdc, 0.3);
                        border-radius: 4px;
                    }

                    & > li {
                        padding-top: 14px;
                        box-sizing: border-box;

                        .channel {
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            align-items: center;
                            padding: 0 10px;
                            box-sizing: border-box;

                            &.on {
                                padding-bottom: 14px;
                            }

                            &:hover {
                                .right {
                                    p {
                                        display: none;
                                    }

                                    .btnIcon {
                                        display: flex;
                                    }
                                }
                            }

                            .left {
                                display: flex;
                                flex-direction: row;
                                align-items: center;

                                img {
                                    width: 20px;
                                    height: 20px;
                                    margin-right: 8px;
                                }

                                p {
                                    width: 134px;
                                    font-size: 13px;
                                    line-height: 18px;
                                    color: #323B4B;
                                    font-weight: bold;
                                    overflow: hidden;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                }
                            }

                            .right {
                                font-size: 12px;
                                line-height: 17px;
                                color: #829191;

                                .btnIcon {
                                    display: none;
                                    flex-direction: row;
                                    align-items: center;

                                    i {
                                        display: block;
                                        width: 16px;
                                        height: 16px;
                                        user-select: none;
                                        cursor: pointer;

                                        &.add {
                                            position: relative;
                                            background: url('../../assets/img/mediaPublish/add.png') no-repeat;
                                            background-position: center center;
                                            background-size: 100% 100%;
                                            margin-right: 10px;

                                            &:hover {
                                                background: url('../../assets/img/mediaPublish/addOn.png') no-repeat;
                                                background-position: center center;
                                                background-size: 100% 100%;

                                                // ul {
                                                //     display: flex;
                                                // }

                                                &>div {
                                                    display: flex;
                                                }
                                            }

                                            &>div {
                                                position: absolute;
                                                top: 0px;
                                                right: -30px;
                                                display: none;
                                                flex-direction: column;
                                                // width: 100px;

                                                p {
                                                    display: flex;
                                                    // width: 100px;
                                                    height: 20px;
                                                    // background: #000;
                                                }

                                                ul {
                                                
                                                    width: max-content;
                                                    display: flex;
                                                    flex-direction: column;
                                                    padding: 10px 15px;
                                                    box-sizing: border-box;
                                                    background: rgba(0, 0, 0, 0.8);
                                                    border-radius: 4px;
                                                    z-index: 99;

                                                    li {
                                                        font-size: 12px;
                                                        line-height: 17px;
                                                        color: #FFFFFF;
                                                        margin-bottom: 10px;
                                                        font-weight: bold;
                                                        text-align: center;
                                                        user-select: none;
                                                        cursor: pointer;

                                                        &:hover {
                                                            color: #41B48C;
                                                        }

                                                        &:nth-last-of-type(1) {
                                                            margin-bottom: 0;
                                                        }
                                                    }
                                                }
                                            }
                                        }

                                        &.del {
                                            background: url('../../assets/img/mediaPublish/del.png') no-repeat;
                                            background-position: center center;
                                            background-size: 100% 100%;
                                            z-index: 9;

                                            &:hover {
                                                background: url('../../assets/img/mediaPublish/delOn.png') no-repeat;
                                                background-position: center center;
                                                background-size: 100% 100%;
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        .article-container {
                            display: flex;
                            flex-direction: column;
                            width: 100%;
                            background: #F3F5F6;
                            padding: 10px;
                            box-sizing: border-box;

                            & > li {
                                display: flex;
                                flex-direction: row;
                                justify-content: space-between;
                                align-items: center;
                                margin-bottom: 10px;

                                &:nth-last-of-type(1) {
                                    margin-bottom: 0;
                                }

                                &.on {
                                    .left {
                                        i {
                                            display: block;
                                            width: 20px;
                                            height: 20px;
                                            background: url('../../assets/img/mediaPublish/fileOn.png') no-repeat;
                                            background-position: center center;
                                            background-size: 100% 100%;
                                            margin-right: 8px;

                                            &.video {
                                                background: url('../../assets/img/mediaPublish/fileVideoOn.png') no-repeat;
                                                background-position: center center;
                                                background-size: 100% 100%;
                                            }

                                            &.pic {
                                                background: url('../../assets/img/mediaPublish/filePicOn.png') no-repeat;
                                                background-position: center center;
                                                background-size: 100% 100%;
                                            }

                                            &.voice {
                                                background: url('../../assets/img/mediaPublish/fileVoiceOn.png') no-repeat;
                                                background-position: center center;
                                                background-size: 100% 100%;
                                            }
                                        }
                                    
                                        p {
                                            color: #41B48C;
                                        }
                                    }

                                    // .right {
                                    //     i {
                                    //         display: block;
                                    //     }
                                    // }
                                }

                                &:hover {
                                    .left {
                                        i {
                                            display: block;
                                            width: 20px;
                                            height: 20px;
                                            background: url('../../assets/img/mediaPublish/fileOn.png') no-repeat;
                                            background-position: center center;
                                            background-size: 100% 100%;
                                            margin-right: 8px;

                                            &.video {
                                                background: url('../../assets/img/mediaPublish/fileVideoOn.png') no-repeat;
                                                background-position: center center;
                                                background-size: 100% 100%;
                                            }

                                            &.pic {
                                                background: url('../../assets/img/mediaPublish/filePicOn.png') no-repeat;
                                                background-position: center center;
                                                background-size: 100% 100%;
                                            }

                                            &.voice {
                                                background: url('../../assets/img/mediaPublish/fileVoiceOn.png') no-repeat;
                                                background-position: center center;
                                                background-size: 100% 100%;
                                            }
                                        }
                                    
                                        p {
                                            color: #41B48C;
                                        }
                                    }

                                    .right {
                                        i {
                                            display: block;
                                        }
                                    }
                                }

                                .left {
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;

                                    i {
                                        display: block;
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../assets/img/mediaPublish/file.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 8px;

                                        &.video {
                                           background: url('../../assets/img/mediaPublish/fileVideo.png') no-repeat; 
                                            background-position: center center;
                                            background-size: 100% 100%;
                                        }

                                        &.pic {
                                           background: url('../../assets/img/mediaPublish/filePic.png') no-repeat; 
                                            background-position: center center;
                                            background-size: 100% 100%;
                                        }

                                        &.voice {
                                           background: url('../../assets/img/mediaPublish/fileVoice.png') no-repeat; 
                                            background-position: center center;
                                            background-size: 100% 100%;
                                        }
                                    }

                                    p {
                                        width: 158px;
                                        font-size: 13px;
                                        line-height: 18px;
                                        color: #323B4B;
                                        overflow: hidden;
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                    }
                                }

                                .right {
                                    position: relative;

                                    i {
                                        display: none;
                                        width: 8px;
                                        height: 10px;
                                        background: url('../../assets/img/mediaPublish/more.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        user-select: none;
                                        cursor: pointer;
                                    }

                                    div {
                                        display: block;
                                        position: absolute;
                                        top: 15px;
                                        right: 0px;
                                        z-index: 9;
                                        width: 78px;
                                        height: 37px;
                                        line-height: 37px;
                                        text-align: center;
                                        font-size: 12px;
                                        font-weight: bold;
                                        color: #FFFFFF;
                                        background: rgba(0, 0, 0, 0.8);
                                        border-radius: 4px;
                                        user-select: none;
                                        cursor: pointer;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .empty-container {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                flex: 1;
                height: 100%;

                img {
                    width: 457px;
                    height: 234px;
                }
            }

            .middle-container {
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                // width: calc(100vw - 234px - 342px);
                flex: 1;
                height: 100%;
                min-width: 0;

                .imgMask {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    width: 6.5em !important;
                    height: 3.66em !important;
                    margin: 0 !important;
                    transform: translate(-50%, -50%);
                }

                .audioMask {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    width: 6.5em !important;
                    height: 3.66em !important;
                    margin: 0 !important;
                    transform: translate(-50%, -50%);
                    background: url('../../assets/img/mediaPublish/audioMask.png') no-repeat;
                    background-position: center;
                    background-size: 2.12em 2.12em;
                    background-color: #ebeeef;
                }

                .write-container {
                    width: 100%;
                    height: 100%;
                    padding: 10px;
                    box-sizing: border-box;
                    overflow-y: auto;

                    &::-webkit-scrollbar {
                        width: 0px;
                    }
                    &::-webkit-scrollbar-thumb {
                        background: transparent;
                        border-radius: 0px;
                    }

                    .ueditor {
                        background: #FFF;
                        // padding: 0 60px;
                        box-sizing: border-box;
                        margin-bottom: 100px;
                    }

                    .writeVideoUpload-container {
                        width: 100%;
                        height: 0.8em;
                        margin-bottom: 10px;
                        background: #FFFFFF;      
                        border-radius: 4px;

                        .Upload-container {
                            display: flex;
                            width: 100%;
                            height: 100%;
                            padding: 0.17em 0.2em 0.18em;
                            box-sizing: border-box;

                            &>div {
                                display: flex;
                                flex-direction: row;
                                justify-content: space-between;
                                align-items: center;
                                width: 100%;

                                .left {
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;

                                    .cover {
                                        display: flex;
                                        width: 0.8em;
                                        height: 0.45em;
                                        position: relative;
                                        margin-right: 0.14em;

                                        & > img {
                                            position: absolute;
                                            top: 0;
                                            left: 0;
                                            width: 0.8em;
                                            height: 0.45em;
                                            border-radius: 2px;
                                            box-sizing: border-box;
                                            object-fit: contain;
                                        }

                                        .encode {
                                            position: absolute;
                                            top: 0;
                                            left: 0;
                                            z-index: 9999;
                                            display: flex;
                                            justify-content: center;
                                            align-items: center;
                                            width: 100%;
                                            height: 100%;
                                            background: rgba(0,0,0,0.4);

                                            img {
                                                width: 16px;
                                                height: 13px;
                                                margin-right: 6px;
                                            }

                                            span {
                                                font-size: 12px;
                                                color: #FFF;
                                            }
                                        }
                                    }

                                    

                                    .changeCover {
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;
                                        position: absolute;
                                        bottom: 0;
                                        left: 0;
                                        width: 0.8em;
                                        height: 0.16em;
                                        background: rgba(0, 0, 0, 0.7);
                                        border-radius: 0px 0px 2px 2px;
                                        user-select: none;
                                        cursor: pointer;

                                        &:hover {
                                            i {
                                                color: #41B48C;
                                            }
                                        }
                                    
                                        i {
                                            font-size: 0.12em;
                                            color: #FFF;
                                        }
                                    }

                                    .info {
                                        display: flex;
                                        flex-direction: column;
                                        justify-content: center;

                                        .top {
                                            font-size: 0.14em;
                                            color: #323B4B;
                                            margin-bottom: 0.5em;
                                        }

                                        .err-info {
                                            font-size: 13px;
                                            line-height: 18px;
                                            color: #323B4B;
                                            font-weight: bold;

                                            i {
                                                color: @green;
                                                text-decoration: underline;
                                                user-select: none;
                                                cursor: pointer;
                                            }
                                        }

                                        .bottom {
                                            display: flex;
                                            flex-direction: row;
                                            align-items: center;

                                            .progress {
                                                width: 2em;
                                                height: 0.06em;
                                                background: #E6E9ED;
                                                border-radius: 1em;
                                                overflow: hidden;

                                                p {
                                                    width: 0%;
                                                    height: 0.06em;
                                                    background: @green;
                                                    border-radius: 1em;
                                                }
                                            }

                                            .num {
                                                margin-left: 0.8333em;
                                                margin-right: 0.5em;
                                                font-size: 0.12em;
                                                color: #829191;
                                            }

                                            .del {
                                                display: block;
                                                width: 12px;
                                                height: 12px;
                                                background: url('../../assets/img/mediaPublish/delIcon.png') no-repeat;
                                                background-position: center center;
                                                background-size: 100% 100%;
                                                user-select: none;
                                                cursor: pointer;
                                            }
                                        }

                                        .water {
                                            display: flex;
                                            flex-direction: row;
                                            align-items: center;

                                            & > span {
                                                font-size: 0.13em;
                                                line-height: 1.384em;
                                                color: #829191;
                                                margin-right: 0.769em;

                                                &.g {
                                                    color: #41B48C;
                                                    user-select: none;
                                                    cursor: pointer;
                                                }

                                                // &:before {
                                                //     display: inline-block;
                                                //     content: '*';
                                                //     font-size: 16px;
                                                //     color: red;
                                                // }
                                            }

                                            .water-list {
                                                position: relative;
                                                display: flex;
                                                flex-direction: row;
                                                justify-content: space-between;
                                                align-items: center;
                                                width: 1.56em;
                                                height: 0.24em;
                                                background: #F3F5F6;
                                                border-radius: 2px;

                                                &>span {
                                                    display: block;
                                                    font-size: 0.12em;
                                                    line-height: 0.706em;
                                                    color: #C4CBD1;
                                                    margin-left: 1.1666em;
                                                    flex: 1;
                                                    min-width: 0;

                                                    &.on {
                                                        color: #666;
                                                    }
                                                }

                                                &>i {
                                                    display: block;
                                                    width: 0.12em;
                                                    height: 0.08em;
                                                    background: url('../../assets/img/mediaPublish/arrow.png') no-repeat;
                                                    background-position: center center;
                                                    background-size: 100% 100%;
                                                    user-select: none;
                                                    cursor: pointer;
                                                    margin-right: 0.08em;

                                                    &.rotate {
                                                        transform: rotate(180deg);
                                                    }
                                                }

                                                .select-list {
                                                    position: absolute;
                                                    top: 35px;
                                                    left: 0;
                                                    z-index: 11111;
                                                    display: flex;
                                                    flex-direction: column;
                                                    width: 100%;
                                                    background: #FFFFFF;
                                                    box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                                                    border-radius: 4px;

                                                    li {
                                                        position: relative;
                                                        display: flex;
                                                        flex-direction: row;
                                                        justify-content: space-between;
                                                        align-items: center;
                                                        height: 30px;
                                                        padding: 0 10px 0 14px;
                                                        box-sizing: border-box;

                                                        &:hover {
                                                            background: rgba(65, 180, 140, 0.15);
                                                        
                                                            img {
                                                                display: block;
                                                            }
                                                        }

                                                        &.on {
                                                            background: rgba(65, 180, 140, 0.15);

                                                            i {
                                                                display: block;
                                                            }
                                                        }

                                                        p {
                                                            font-size: 13px;
                                                            color: #323B4B;
                                                            line-height: 30px;
                                                        }

                                                        i {
                                                            display: none;
                                                            width: 14px;
                                                            height: 11px;
                                                            background: url('../../assets/img/mediaPublish/gou.png') no-repeat;
                                                            background-position: center center;
                                                            background-size: 100% 100%;
                                                        }

                                                        &:nth-of-type(1) {
                                                            border-radius: 4px 4px 0 0;
                                                        }

                                                        &:nth-last-of-type(1) {
                                                            border-radius: 0 0 4px 4px;
                                                        }

                                                        img {
                                                            display: none;
                                                            position: absolute;
                                                            top: 40px;
                                                            right: -10px;
                                                            width: 114px;
                                                            height: 64px;
                                                            z-index: 111111;
                                                            border-radius: 4px;

                                                            &.slim {
                                                                width: 64px;
                                                                height: 114px;
                                                                right: 50px;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }

                                .right {
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;

                                    div {
                                        display: flex;
                                        flex-direction: row;
                                        align-items: center;
                                        user-select: none;
                                        cursor: pointer;

                                        &.del {
                                            i {
                                                display: block;
                                                width: 0.16em;
                                                height: 0.16em;
                                                background: url('../../assets/img/mediaPublish/del.png') no-repeat;
                                                background-position: center center;
                                                background-size: 100% 100%;
                                                user-select: none;
                                                cursor: pointer;
                                                margin-right: 0.06em;
                                            }

                                            span {
                                                font-size: 0.13em;
                                                color: #A8B3B3;
                                                font-weight: bold;
                                            }

                                            &:hover {
                                                i {
                                                    background: url('../../assets/img/mediaPublish/delOn.png') no-repeat;
                                                    background-position: center center;
                                                    background-size: 100% 100%;
                                                }

                                                span {
                                                    font-size: 0.13em;
                                                    color: @green;
                                                    font-weight: bold;
                                                }
                                            }
                                        }

                                        &.reload {
                                            margin-left: 0.2em;

                                            i {
                                                display: block;
                                                width: 0.16em;
                                                height: 0.16em;
                                                background: url('../../assets/img/mediaPublish/reload.png') no-repeat;
                                                background-position: center center;
                                                background-size: 100% 100%;
                                                user-select: none;
                                                cursor: pointer;
                                                margin-right: 0.06em;
                                            }

                                            span {
                                                font-size: 0.13em;
                                                color: #A8B3B3;
                                                font-weight: bold;
                                            }

                                            &:hover {
                                                i {
                                                    background: url('../../assets/img/mediaPublish/reloadOn.png') no-repeat;
                                                    background-position: center center;
                                                    background-size: 100% 100%;
                                                }

                                                span {
                                                    font-size: 0.13em;
                                                    color: @green;
                                                    font-weight: bold;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        .unUpload-container {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            width: 100%;
                            height: 100%;
                            background: url('../../assets/img/mediaPublish/writeBg.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 0.8em;

                            &>div {
                                display: flex;
                                flex-direction: column;
                                align-items: flex-start;

                                .btn {
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;
                                    justify-content: center;
                                    width: 7.429em;
                                    height: 2em;
                                    background-color: rgba(65, 180, 140, 0.1);
                                    border-radius: 4px;
                                    color: @green;
                                    font-size: 0.14em;
                                    font-weight: bold;
                                    border: 1px solid #41B48C;
                                    box-sizing: border-box;
                                    margin-bottom: 0.571em;
                                    user-select: none;
                                    cursor: pointer;

                                    &:hover {
                                        .btnHover
                                    } 

                                    i {
                                        display: block;
                                        width: 1.286em;
                                        height: 1.286em;
                                        background: url('../../assets/img/mediaPublish/greenUpload.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 2px;
                                    }
                                }

                                span {
                                    font-size: 0.13em;
                                    line-height: 1.384em;
                                    font-weight: 500;
                                    color: #666666;
                                }
                            }
                        }
                    }
                }

                .dy-notice {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    margin: 0.3em auto 0;

                    ul {
                        display: flex;
                        flex-direction: row;
                        align-items: center;

                        li {
                            width: 2em;
                            height: 1em;
                            background: #FFFAEB;
                            border-radius: 4px;
                            padding: 0.12em;
                            box-sizing: border-box;

                            &:nth-of-type(2) {
                                margin: 0 0.3em;
                            }

                            &>div {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                margin-bottom: 0.06em;

                                img {
                                    width: 0.14em;
                                    height: 0.14em;
                                    margin-right: 0.08em;
                                }

                                p {
                                    font-size: 0.14em;
                                    color: #666666;
                                    font-weight: bold;
                                }
                            }

                            & > p {
                                font-size: 0.12em;
                                color: #666666;
                                box-sizing: border-box;
                            }
                        }
                    }
                }

                .upload-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: 6.5em;
                    height: 3.96em;
                    padding: 0.6em 1.16em;
                    background: #FFFFFF;
                    box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                    border-radius: 4px;
                    box-sizing: border-box;
                    &.has-library-btn {
                        padding: 0.6em 0.6em;
                    }

                    .upload {
                        position: relative;
                        width: 100%;
                    }
                    .uploadIcon {
                        width: 0.48em;
                        height: 0.48em;
                        background: url('../../assets/img/mediaPublish/uploadIcon.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        // margin-bottom: 0.2em;
                        margin: 0 auto 0.2em;
                    }

                    .uploadBtn {
                        width: 100%;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;
                        flex-wrap: nowrap;
                        margin-bottom: 0.2em;

                        .btn {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            width: 1.06em;
                            height: 1.28em;
                            background: rgba(241, 243, 244, 0.4);
                            border-radius: 0.15em;
                            user-select: none;
                            cursor: pointer;

                            i {
                                display: block;
                                width: 0.22em;
                                height: 0.22em;
                                background: url('../../assets/img/mediaPublish/plusIcon.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                margin-bottom: 0.08em;
                            }

                            p {
                                font-size: 13px;
                                font-weight: 500;
                                color: #666666;
                                line-height: 18px;
                            }
                        }
                    }

                    .uploadArea {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        height: 0.6em;
                        border-radius: 15px;
                        border: 1px dashed #B9C3C3;

                        i {
                            display: block;
                            width: 0.22em;
                            height: 0.22em;
                            background: url('../../assets/img/mediaPublish/drogIcon.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                            margin-right: 10px;
                        }

                        p {
                            font-size: 13px;
                            font-weight: 500;
                            color: #666666;
                            line-height: 18px;
                        }
                    }

                    .bilibiliNotice {
                        position: absolute;
                        bottom: -1.6em;
                        left: 50%;
                        transform: translateX(-50%);
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        & > div {
                            display: flex;
                            width: 3.2em;
                            height: 0.78em;
                            background: #FFFAEB;
                            border-radius: 0.04em;
                            margin-right: 0.1em;
                            padding: 0.12em;
                            box-sizing: border-box;

                            i {
                                min-width: 0.14em;
                                height: 0.14em;
                                background: url('../../assets/img/mediaPublish/notice.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                margin-right: 0.1em;
                            }

                            div {
                                display: flex;
                                flex-direction: column;

                                p {
                                    font-family: PingFang-SC, PingFang-SC;
                                    font-weight: bold;
                                    font-size: 0.14em;
                                    line-height: 1em;
                                    color: #666666;
                                    margin-bottom: 1em;
                                }

                                span {
                                    font-family: PingFang-SC, PingFang-SC;
                                    font-weight: 500;
                                    font-size: 0.14em;
                                    line-height: 1em;
                                    color: #666666;
                                }
                            }

                            &:nth-last-of-type(1) {
                                margin-right: 0;
                            }
                        }
                    }

                    .bplusNotice {
                        position: absolute;
                        bottom: -1.6em;
                        width: 4em;
                        min-height: 0.4em;
                        background: #FFFAEB;
                        border-radius: 0.2em;
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        padding: 0.1em;
                        box-sizing: border-box;

                        i {
                            min-width: 0.14em;
                            height: 0.14em;
                            background: url('../../assets/img/mediaPublish/notice.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                            margin-right: 0.1em;
                        }

                        p {
                            font-size: 0.12em;
                            color: #666666;
                        }
                    }

                    .progress-container {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;

                        .name {
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            font-size: 14px;
                            line-height: 0.2em;
                            color: #323B4B;
                            margin: 0.2em 0 0.3em;                      
                            font-weight: 500;
                            text-align: center;
                        }

                        .btn {
                            background: rgba(185, 195, 195, 0.2);
                            border-radius: 4px;
                            text-align: center;
                            font-weight: bold;
                            color: #829191;
                            user-select: none;
                            cursor: pointer;
                        }
                    }

                    .uploadError-container {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        margin-top: 0.52em;

                        img {
                            width: 0.96em;
                            height: 0.96em;
                        }

                        .name {
                            font-size: 0.14em;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }

                        &>div {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            font-size: 0.16em;
                            line-height: 0.22em;
                            font-weight: bold;
                            color: #323B4B;

                            span {
                                text-decoration: underline;
                                color: #41B48C;
                            }
                        }
                    }
                }

                .video-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    .videoPlayer {
                        position: relative;
                        margin-bottom: 0.4em;

                        .encodeMask {
                            position: absolute;
                            top: 0;
                            left: 0;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            width: 100%;
                            height: 100%;
                            background: rgba(0,0,0,0.4);

                            .icon {
                                display: flex;
                                flex-direction: row;
                                align-items: center;

                                img {
                                    width: 30px;
                                    height: 32px;
                                    margin-right: 10px;
                                }

                                span {
                                    font-size: 14px;
                                    line-height: 20px;
                                    color: #FFFFFF;
                                    font-weight: bold;
                                }
                            }

                            &>span {
                                font-size: 13px;
                                line-height: 18px;
                                color: #FFFFFF;
                                margin: 16px 0 22px;
                            }

                            .btns {
                                width: 100%;
                                display: flex;
                                flex-direction: row;
                                justify-content: center;
                                align-items: center;

                                .btn {
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    width: 98px;
                                    height: 32px;
                                    border-radius: 4px;
                                    border: 1px solid #FFFFFF;
                                    box-sizing: border-box;
                                    user-select: none;
                                    cursor: pointer;

                                    &.g {
                                        background: #41B48C;
                                        border: 1px solid #41B48C;
                                        box-sizing: border-box;
                                        margin-right: 20px;
                                    }

                                    img {
                                        width: 16px;
                                        height: 16px;
                                        margin-right: 6px;
                                    }

                                    span {
                                        font-size: 13px;
                                        color: #FFFFFF;
                                    }
                                }
                            }
                        }

                        & > img {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            margin-left: -0.2em;
                            margin-top: -0.2em;
                            width: 0.4em;
                            height: 0.4em;
                            user-select: none;
                            cursor: pointer;
                            z-index: 9;
                        }

                        &.row {
                            width: 6.5em;
                            height: 3.66em;
                        }

                        &.column {
                            width: 2.7em;
                            height: 4.8em;
                        }
                    }

                    video {
                        width: 100%;
                        height: 100%;
                    }

                }

                .tool-container {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    width: 5.36em;
                    height: 0.44em;
                    background: #FFFFFF;
                    border-radius: 0.45em;
                    padding: 0 0.14em;
                    box-sizing: border-box;

                    & > i {
                        display: block;
                        width: 0.2em;
                        height: 0.2em;
                        user-select: none;
                        cursor: pointer;

                        &.playBtn {
                            background: url('../../assets/img/mediaPublish/playIcon.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                            user-select: none;
                            cursor: pointer;
                        }

                        &.pauseBtn {
                            background: url('../../assets/img/mediaPublish/pauseIcon.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                            user-select: none;
                            cursor: pointer;
                        }
                    }

                    .time {
                        font-size: 0.12em;
                        line-height: 1.416667em;
                        color: #323B4B;
                        font-weight: 500;
                        white-space: nowrap;
                        // margin: 0 12px;
                    }

                    .progress {
                        position: relative;
                        width: 2.8em;
                        height: 0.04em;
                        background: #E6E9ED;
                        border-radius: 0.05em;
                        margin-right: 0.14em;
                        user-select: none;

                        .progress-bg {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 0.04em;
                            border-radius: 1.5px;
                            background-color: rgba(151, 151, 151, 0.2);
                        }

                        .progress-fill {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 0%;
                            height: 0.04em;
                            border-radius: 1.5px;
                            background-color: #41B48C;

                            i {
                                position: absolute;
                                top: 50%;
                                right: -0.07em;
                                margin-top: -0.07em;
                                display: block;
                                width: 0.14em;
                                height: 0.14em;
                                border-radius: 50%;
                                background: #41B48C;
                                cursor: pointer;
                            }
                        }
                    }

                    .speed {
                        position: relative;
                        width: 0.21em;
                        height: 0.24em;

                        p {
                            display: block;
                            width: 0.21em;
                            height: 0.24em;
                            margin-right: 0.14em;

                            &.one {
                                background: url('../../assets/img/mediaPublish/1x.svg') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                user-select: none;
                                cursor: pointer;

                                &:hover {
                                    background: url('../../assets/img/mediaPublish/1xOn.svg') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                    user-select: none;
                                    cursor: pointer;
                                }
                            }

                            &.two {
                                background: url('../../assets/img/mediaPublish/2x.svg') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                user-select: none;
                                cursor: pointer;

                                &:hover {
                                    background: url('../../assets/img/mediaPublish/2xOn.svg') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                    user-select: none;
                                    cursor: pointer;
                                }
                            }
                        }

                        ul {
                            position: absolute;
                            bottom: 30px;
                            left: 50%;
                            margin-left: -27px;
                            display: flex;
                            flex-direction: column;
                            background: #FFFFFF;
                            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);

                            &::after {
                                position: absolute;
                                left: 50%;
                                bottom: -6px;
                                margin-left: -3px;
                                display: block;
                                content: '';
                                width: 0;
                                height: 0;
                                border-left: 6px solid transparent;
                                border-right: 6px solid transparent;
                                border-top: 6px solid #FFF;
                            }

                            li {
                                width: 54px;
                                height: 30px;
                                text-align: center;
                                line-height: 30px;
                                font-size: 13px;
                                color: #323B4B;
                                user-select: none;
                                cursor: pointer;

                                &:hover {
                                    background: rgba(65, 180, 140, 0.15);
                                }
                            }
                        }
                    }

                    .vol {
                        position: relative;
                        // width: 0.2em;
                        // height: 0.2em;
                        margin-left: 0.14em;
                        // background: url('../../assets/img/mediaPublish/volume.png') no-repeat;
                        // background-position: center center;
                        // background-size: 100% 100%;
                        user-select: none;
                        cursor: pointer;

                        i {
                            display: block;
                            width: 0.2em;
                            height: 0.2em;
                            // margin-left: 0.14em;
                            background: url('../../assets/img/mediaPublish/volume.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                            user-select: none;
                            cursor: pointer;
                        }

                        .volContent {
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            align-items: center;
                            position: absolute;
                            bottom: 30px;
                            left: -16px;
                            width: 42px;
                            height: 148px;
                            padding: 10px 0;
                            background: #FFFFFF;
                            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                            box-sizing: border-box;

                            .line {
                                position: relative;
                                width: 2px;
                                height: 100px;

                                .lineProgress {
                                    width: 2px;
                                    height: 100px;
                                    background: rgba(80, 85, 88, 0.29);
                                    border-radius: 5px;
                                }

                                .lineCover {
                                    position: absolute;
                                    bottom: 0;
                                    left: 0;
                                    width: 100%;
                                    height: 100%;
                                    background: #41B48C;

                                    i {
                                        position: absolute;
                                        top: -4px;
                                        left: -5px;
                                        display: block;
                                        width: 12px;
                                        height: 12px;
                                        border-radius: 50%;
                                        background: #41B48C;
                                    }
                                }
                            }

                            & > p {
                                font-size: 13px;
                                font-weight: 500;
                                color: #323B4B;
                                line-height: 18px;
                            }

                            &::after {
                                position: absolute;
                                left: 50%;
                                bottom: -6px;
                                margin-left: -5px;
                                display: block;
                                content: '';
                                width: 0;
                                height: 0;
                                border-left: 6px solid transparent;
                                border-right: 6px solid transparent;
                                border-top: 6px solid #FFF;
                            }
                        }

                        &:hover {
                            background: url('../../assets/img/mediaPublish/volumeOn.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                            user-select: none;
                            cursor: pointer;
                        }
                    }

                    .large {
                        display: block;
                        width: 0.2em;
                        height: 0.2em;
                        margin-left: 0.14em;
                        background: url('../../assets/img/mediaPublish/large.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        user-select: none;
                        cursor: pointer;

                        &:hover {
                            background: url('../../assets/img/mediaPublish/largeOn.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                            user-select: none;
                            cursor: pointer;
                        }
                    }
                }

                .btn-container {
                    position: absolute;
                    right: 30px;
                    bottom: 20%;
                    z-index: 1000;
                    display: flex;
                    flex-direction: column;

                    i {
                        display: block;
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        margin-bottom: 20px;
                        overflow: hidden;

                        &::nth-last-of-type(1) {
                            margin-bottom: 0;
                        }

                        &.TB {
                            background: url('../../assets/img/mediaPublish/TB.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                            user-select: none;
                            cursor: pointer;

                            &:hover {
                                background: url('../../assets/img/mediaPublish/TBon.png') no-repeat;
                                background-color: #FFF;
                                background-position: center center;
                                background-size: 24px 20px;
                                user-select: none;
                                cursor: pointer;
                            }
                        }

                        &.upload {
                            position: relative;

                            &.unset {
                                overflow: unset !important;
                            }
                            
                            p {
                                width: 100%;
                                height: 100%;
                                background: url('../../assets/img/mediaPublish/upload.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                user-select: none;
                                cursor: pointer;
                            }

                            &:hover {
                                p {
                                    background: url('../../assets/img/mediaPublish/uploadOn.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                    user-select: none;
                                    cursor: pointer;
                                }
                            }

                            &.on {
                                p {
                                    background: url('../../assets/img/mediaPublish/uploadOn.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                    user-select: none;
                                    cursor: pointer;
                                }
                            }

                            .materialList {
                                position: absolute;
                                top: 54px;
                                left: -30px;
                                width: 100px;
                                display: flex;
                                flex-direction: column;
                                padding: 10px 15px;
                                box-sizing: border-box;
                                background: rgba(0, 0, 0, 0.8);
                                border-radius: 4px;
                                z-index: 99;

                                li {
                                    font-size: 12px;
                                    line-height: 17px;
                                    color: #FFFFFF;
                                    margin-bottom: 10px;
                                    font-weight: bold;
                                    text-align: center;
                                    user-select: none;
                                    cursor: pointer;

                                    &:hover {
                                        color: #41B48C;
                                    }

                                    &:nth-last-of-type(1) {
                                        margin-bottom: 0;
                                    }
                                }
                            }
                        }

                        &.preview {
                            background: url('../../assets/img/mediaPublish/preview.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                            user-select: none;
                            cursor: pointer;

                            &:hover {
                                background: url('../../assets/img/mediaPublish/previewOn.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                user-select: none;
                                cursor: pointer;
                            }
                        }

                        &.share {
                            background: url('../../assets/img/mediaPublish/share.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                            user-select: none;
                            cursor: pointer;

                            &:hover {
                                background: url('../../assets/img/mediaPublish/shareOn.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                user-select: none;
                                cursor: pointer;
                            }
                        }

                        &.copy {
                            background: url('../../assets/img/mediaPublish/copy.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                            user-select: none;
                            cursor: pointer;

                            &:hover {
                                background: url('../../assets/img/mediaPublish/copyOn.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                user-select: none;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }

            .right-container {
                display: flex;
                flex-direction: column;
                width: 3.42em;
                height: 100%;
                background: #FAFBFC;
                overflow-y: auto;
                overflow-x: hidden;

                &::-webkit-scrollbar {
                    width: 0.06em;
                }
                &::-webkit-scrollbar-thumb {
                    background: #ddd;
                    border-radius: 0.06em;
                }

                .publish-setting {
                    display: flex;
                    flex-direction: column;

                    & > .title {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                        height: 0.48em;
                        padding: 0 0.14em;
                        border-bottom: 1px solid #EEEEEE;
                        box-sizing: border-box;

                        p {
                            font-size: 0.14em;
                            font-weight: bold;
                            color: #323B4B;
                            line-height: 1.429em;
                        }

                        .arrow {
                            display: block;
                            width: 0.12em;
                            height: 0.08em;
                            background: url('../../assets/img/mediaPublish/arrow.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;

                            &.rotate {
                                transform: rotate(180deg);
                            }
                        }

                        img {
                            width: 0.12em;
                            height: 0.08em;
                        }
                    }

                    .setting {
                        padding: 0.2em 0.24em;
                        border-bottom: 1px solid #EEEEEE;
                        box-sizing: border-box;

                        .row {
                            display: flex;
                            flex-direction: row;
                            margin-bottom: 0.2em;

                            .hbContainer {
                                position: relative;
                                display: flex;
                                align-items: center;

                                &.column {
                                    .l {
                                        width: 1.8em;
                                        height: 1em;
                                        margin-left: 0.14em;
                                    }

                                    .del {
                                        top: 10px;
                                        right: 20px;
                                        left: unset;
                                    }
                                }

                                .l {
                                    position: relative;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    width: 0.96em;
                                    height: 1.71em;
                                    background: #F3F5F6;
                                    border-radius: 0.04em;
                                    margin-right: 0.1em;
                                    user-select: none;
                                    cursor: pointer;

                                    &:hover {
                                        .change {
                                            display: block;
                                        }
                                    }

                                    .add {
                                        display: block;
                                        width: 22px;
                                        height: 22px;
                                        background: url('../../assets/img/mediaPublish/plusIcon.png') no-repeat;
                                        background-size: 100% 100%;
                                        background-position: center center;
                                    }

                                    .change {
                                        display: none;
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        transform: translate(-50%, -50%);
                                        width: 40px;
                                        height: 20px;
                                        line-height: 20px;
                                        text-align: center;
                                        background: rgba(0,0,0,0.5);
                                        border-radius: 2px;
                                        font-size: 12px;
                                        color: #FFF;
                                    }
                                }

                                .r {
                                    display: flex;
                                    flex-direction: column;
                                    width: 1.2em;

                                    p {
                                        font-size: 12px;
                                        line-height: 22px;
                                        color: #666666;
                                        margin-bottom: 2px;
                                    }

                                    span {
                                        font-size: 12px;
                                        line-height: 22px;
                                        color: #829191;
                                        margin-bottom: 2px;
                                    }
                                }

                                .del {
                                    position: absolute;
                                    bottom: 0;
                                    left: 106px;
                                    display: block;
                                    width: 16px;
                                    height: 16px;
                                    background: url('../../assets/img/mediaPublish/del.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                    z-index: 9;
                                    user-select: none;
                                    cursor: pointer;
                                }
                            }

                            .title {
                                position: relative;
                                font-size: 0.13em;
                                line-height: 1.846em;
                                min-width: 2em;
                                color: #666666;
                                font-weight: 500;
                                margin-right: 2.308em;

                                &.red {
                                    &::after {
                                        position: absolute;
                                        top: 0;
                                        left: -0.421em;
                                        display: block;
                                        content: '*';
                                        font-size: 1.462em;
                                        width: 0.526em;
                                        height: 0.526em;
                                        color: red;
                                    }
                                }
                            }

                            .switch {
                                display: flex;
                                align-items: center;
                                justify-content: flex-end;
                                width: 0.44em;
                                height: 0.22em;
                                background: #41B48C;
                                border-radius: 0.11em;
                                padding: 0 0.02em;
                                box-sizing: border-box;
                                user-select: none;
                                cursor: pointer;

                                &.on {
                                    justify-content: flex-start;
                                    background: #CED3D7;
                                }

                                p {
                                    width: 0.18em;
                                    height: 0.18em;
                                    background: #FFF;
                                    border-radius: 50%;
                                }
                            }

                            .bq {
                                display: flex;
                                flex-direction: row;
                                align-items: center;

                                li {
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;
                                    margin-right: 0.4em;
                                    user-select: none;
                                    cursor: pointer;

                                    &.on {
                                        p {
                                            position: relative;
                                            background: @green;
                                            opacity: 1;

                                            &:after {
                                                position: absolute;
                                                top: 50%;
                                                left: 50%;
                                                margin-left: -0.03em;
                                                margin-top: -0.03em;
                                                display: block;
                                                content: '';
                                                width: 0.06em;
                                                height: 0.06em;
                                                border-radius: 50%;
                                                background: #FFF;
                                            }
                                        }
                                    }

                                    p {
                                        width: 0.16em;
                                        height: 0.16em;
                                        border-radius: 50%;
                                        background-color: #829191;                    
                                        opacity: 0.15;
                                        margin-right: 0.08em;
                                    }

                                    span {
                                        font-size: 0.13em;
                                        line-height: 1.385em;
                                        color: #323B4B;
                                    }
                                }
                            }

                            .cover {
                                position: relative;
                                width: 1.42em;
                                height: 0.8em;
                                border-radius: 0.04em;
                                background-position: center center;
                                background-size: cover;
                                background-repeat: no-repeat;
                                // overflow: hidden;

                                .main {
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: 100%;
                                    height: 100%;
                                    object-fit: contain;
                                    background: transparent;
                                }

                                &:hover {
                                    .change {
                                        display: block;
                                    }
                                }

                                .change {
                                    display: none;
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    margin-left: -1.6667em;
                                    margin-top: -0.8333em;
                                    width: 3.333em;
                                    height: 1.6667em;
                                    background: rgba(0,0,0,0.5);
                                    border-radius: 0.16667em;
                                    font-size: 0.12em;
                                    color: #FFFFFF;
                                    line-height: 1.667em;
                                    text-align: center;
                                    user-select: none;
                                    cursor: pointer;
                                }

                                .materialList {
                                    position: absolute;
                                    top: 0.54em;
                                    left: 0.32em;
                                    display: flex;
                                    flex-direction: column;
                                    padding: 0.1em 0.15em;
                                    box-sizing: border-box;
                                    background: rgba(0, 0, 0, 0.8);
                                    border-radius: 0.04em;
                                    z-index: 99;

                                    li {
                                        font-size: 0.12em;
                                        line-height: 1.417em;
                                        color: #FFFFFF;
                                        margin-bottom: 0.8333em;
                                        font-weight: bold;
                                        text-align: center;
                                        user-select: none;
                                        cursor: pointer;

                                        &:hover {
                                            color: #41B48C;
                                        }

                                        &:nth-last-of-type(1) {
                                            margin-bottom: 0;
                                        }
                                    }
                                }
                            }

                            .input {
                                display: flex;
                                width: 2.36em;
                                height: 0.24em;
                                background: #F3F5F6;
                                border-radius: 0.02em;
                                padding: 0 0.14em;
                                box-sizing: border-box;

                                .disabled {
                                    cursor: no-drop;
                                }

                                .el-select {
                                    width: 100%;
                                    height: 100%;
                                }

                                input {
                                    width: 100%;
                                    height: 100%;
                                    background: transparent;

                                    &::-webkit-scrollbar {
                                        width: 0.04em;
                                    }
                                    &::-webkit-scrollbar-thumb {
                                        background: rgba(#dcdcdc, 0.8);
                                        border-radius: 0.04em;
                                    }
                                }
                            }

                            .selectDom {
                                position: relative;
                                display: flex;
                                flex-direction: row;
                                justify-content: space-between;
                                align-items: center;
                                width: 2.36em;
                                height: 0.24em;
                                background: #F3F5F6;
                                border-radius: 0.02em;
                                padding: 0;
                                box-sizing: border-box;
                                user-select: none;
                                cursor: pointer;

                                p {
                                    flex: 1;
                                }

                                .el-select {
                                    width: 100%;
                                    height: 100%;
                                }
                            }

                            .select {
                                position: relative;
                                display: flex;
                                flex-direction: row;
                                justify-content: space-between;
                                align-items: center;
                                width: 2.36em;
                                height: 0.24em;
                                background: #F3F5F6;
                                border-radius: 0.02em;
                                padding: 0 0.08em 0 0.14em;
                                box-sizing: border-box;
                                user-select: none;
                                cursor: pointer;

                                p {
                                    flex: 1;
                                }

                                .select-list {
                                    position: absolute;
                                    top: 0.35em;
                                    left: 0;
                                    z-index: 9;
                                    display: flex;
                                    flex-direction: column;
                                    width: 100%;
                                    background: #FFFFFF;
                                    box-shadow: 0.04em 0.04em 0.1em 0px rgba(5, 10, 15, 0.05);
                                    border-radius: 0.04em;

                                    li {
                                        position: relative;
                                        display: flex;
                                        flex-direction: row;
                                        justify-content: space-between;
                                        align-items: center;
                                        height: 0.3em;
                                        padding: 0 0.1em 0 0.14em;
                                        box-sizing: border-box;

                                        &:hover {
                                            background: rgba(65, 180, 140, 0.15);
                                        
                                            img {
                                                display: block;
                                            }
                                        }

                                        &.on {
                                            background: rgba(65, 180, 140, 0.15);

                                            i {
                                                display: block;
                                            }
                                        }

                                        p {
                                            font-size: 0.13em;
                                            color: #323B4B;
                                            line-height: 2.308em;
                                        }

                                        i {
                                            display: none;
                                            width: 0.14em;
                                            height: 0.11em;
                                            background: url('../../assets/img/mediaPublish/gou.png') no-repeat;
                                            background-position: center center;
                                            background-size: 100% 100%;
                                        }

                                        &:nth-of-type(1) {
                                            border-radius: 0.04em 0.04em 0 0;
                                        }

                                        &:nth-last-of-type(1) {
                                            border-radius: 0 0 0.04em 0.04em;
                                        }

                                        img {
                                            display: none;
                                            position: absolute;
                                            top: 0.4em;
                                            right: -0.1em;
                                            width: 1.14em;
                                            height: 0.64em;
                                            border-radius: 0.04em;

                                            &.slim {
                                                width: 0.64em;
                                                height: 1.14em;
                                                right: 0.5em;
                                            }
                                        }
                                    }
                                }

                                &.on {
                                    box-shadow: 0px 0.12em 0.23em 0px rgba(65, 180, 140, 0.06);
                                    border: 1px solid #41B48C;
                                    box-sizing: border-box;
                                }

                                p {
                                    font-size: 0.13em;
                                    line-height: 1.538em;
                                    color: #323B4B;
                                    font-weight: 500;
                                }

                                .arrow {
                                    display: block;
                                    width: 0.12em;
                                    height: 0.08em;
                                    background: url('../../assets/img/mediaPublish/arrow.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;

                                    &.rotate {
                                        transform: rotate(180deg);
                                    }
                                }
                            }
                        }

                        .column {
                            display: flex;
                            flex-direction: column;
                            margin-bottom: 0.2em;

                            & > ul {
                                & > li {
                                    max-width: 100%;

                                    p {
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                    }

                                    i {
                                        min-width: 0.1em;
                                    }
                                }
                            }

                            &.last {
                                margin-bottom: 0;
                            }

                            .unred {
                                border: 1px solid #FF555A;
                                box-sizing: border-box;

                                span {
                                    color: #FF555A;
                                }
                            }

                            .num {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                height: 0.24em;
                                background: #F3F5F6;

                                input {
                                    margin: 0;
                                    flex: 1;
                                    height: 100%;
                                }

                                div {
                                    font-size: 0.12em;
                                    color: #829191;
                                }
                            }

                            .input {
                                display: flex;
                                height: 0.24em; 

                                .disabled {
                                cursor: no-drop;
                            }
                            }

                            .title {
                                position: relative;
                                font-size: 0.13em;
                                line-height: 1.846em;
                                color: #666666;
                                font-weight: 500;
                                margin-bottom: 0.769em;

                                &.red {
                                    &::after {
                                        position: absolute;
                                        top: 0;
                                        left: -0.421em;
                                        display: block;
                                        content: '*';
                                        font-size: 1.462em;
                                        width: 0.526em;
                                        height: 0.526em;
                                        color: red;
                                    }
                                }
                            }

                            .dyTag {
                                height: 2em;
                            }

                            .textarea {
                                display: flex;
                                position: relative;
                                width: 20.857em;
                                height: 7.143em;
                                font-size: 0.14em;
                                background: #F3F5F6;
                                border-radius: 0.1429em;
                                overflow: hidden;
                                padding: 0.4286em 1em;
                                box-sizing: border-box;

                                &>div {
                                    width: 100%;
                                    height: 100%;
                                    background: transparent;
                                    outline: none;
                                    overflow-y: auto;
                                    word-break: break-all;

                                    &::-webkit-scrollbar {/*滚动条整体样式*/
                                        width: 0.04em;     /*高宽分别对应横竖滚动条的尺寸*/
                                        height: 0.02em;
                                    }
                                    &::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
                                        border-radius: 0.05em;
                                        box-shadow: inset 0 0 0.05em rgba(0,0,0,0.2);
                                        -webkit-box-shadow: inset 0 0 0.05em rgba(0,0,0,0.2);
                                        background: rgba(0,0,0,0.1);
                                    }
                                    &::-webkit-scrollbar-track {/*滚动条里面轨道*/
                                        // box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
                                        // -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
                                        border-radius: 0;
                                        background: transparent;
                                    }
                                }

                                textarea {
                                    resize: none;
                                    width: 100%;
                                    height: 100%;
                                    background: transparent;
                                    font-size: 0.9286em;
                                    line-height: 1.5385em;
                                    color: #323B4B;

                                    &::-webkit-scrollbar {
                                        width: 0.308em;
                                    }
                                    &::-webkit-scrollbar-thumb {
                                        background: rgba(#dcdcdc, 0.8);
                                        border-radius: 0.308em;
                                    }
                                }

                                p {
                                    position: absolute;
                                    bottom: 0.5em;
                                    right: 1.167em;
                                    font-size: 0.75em;
                                    line-height: 1.417em;
                                    color: #829191;
                                }
                            }

                            .topic {
                                width: 6.5em;
                                height: 1.75em;
                                line-height: 1.75em;
                                text-align: center;
                                font-weight: bold;
                                color: #41B48C;
                                font-size: 0.14em;
                                background: rgba(65, 180, 140, 0.1);
                                border-radius: 0.25em;
                                margin-top: 0.625em;
                                user-select: none;
                                cursor: pointer;
                            }

                            input {
                                width: 100%;
                                height: 100%;
                                min-height: 0.25em;
                                background: #F3F5F6;
                                border-radius: 0.16667em;
                                padding: 0 1.167em;
                                box-sizing: border-box;
                                color: #323B4B;
                                font-size: 0.12em;
                                margin-bottom: 1.333em;

                                &::placeholder {
                                    color: #C4CBD1;
                                }
                            }

                            .tagBtn {
                                width: 7.429em;
                                height: 2em;
                                background: rgba(65, 180, 140, 0.1);
                                border-radius: 0.286em;
                                border: 1px solid #41B48C;
                                font-size: 0.14em;
                                font-weight: bold;
                                color: #41B48C;
                                line-height: 2em;
                                text-align: center;
                                box-sizing: border-box;
                                user-select: none;
                                cursor: pointer;
                                margin-bottom: 1em;
                                margin-left: 2.857em;

                                &:hover {
                                    .btnHover
                                } 
                            }

                            .bTagList {
                                display: flex;
                                flex-direction: column;

                                div {
                                    display: flex;
                                    flex-direction: row;

                                    .left {
                                        min-width: 6.5em;
                                        font-size: 0.12em;
                                        line-height: 1.4167em;
                                        color: #829191;
                                    }

                                    .right {
                                        display: flex;
                                        flex-direction: row;
                                        flex-wrap: wrap;

                                        p {
                                            height: 1.846em;
                                            line-height: 1.846em;
                                            background: rgba(185, 195, 195, 0.2);
                                            border-radius: 0.308em;
                                            font-size: 0.13em;
                                            color: #323B4B;
                                            text-align: center;
                                            padding: 0 1.077em;
                                            box-sizing: border-box;
                                            margin: 0 0.462em 0.462em 0;
                                        }
                                    }
                                }
                            }

                            ul {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                flex-wrap: wrap;

                                li {
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;
                                    height: 0.24em;
                                    padding: 0 0.1em 0 0.14em;
                                    box-sizing: border-box;
                                    background: rgba(185,195,195,0.2);
                                    margin: 0 0.1em 0.1em 0px;

                                    p {
                                        font-size: 0.13em;
                                        line-height: 1.846em;
                                        color: #323B4B;
                                    }

                                    i {
                                        display: block;
                                        width: 0.1em;
                                        height: 0.1em;
                                        background: url('../../assets/img/mediaPublish/delIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-left: 0.14em;
                                        user-select: none;
                                        cursor: pointer;
                                    }
                                }
                            }
                        }

                        .showMore {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            width: 100%;
                            border-top: 1px solid #EEEEEE;
                            box-sizing: border-box;
                            padding-top: 0.09em;
                            margin-bottom: 0.2em;

                            &.on {
                                i {
                                    transform: rotate(180deg);
                                }
                            }

                            p {
                                font-size: 0.13em;
                                color: #323B4B;
                                margin-right: 0.615em;
                                user-select: none;
                                cursor: pointer;
                            }

                            i {
                                display: block;
                                width: 0.14em;
                                height: 0.14em;
                                background: url('../../assets/img/mediaPublish/doubleArrow.png') no-repeat;
                                background-size: 100% 100%;
                                background-position: center center;
                                user-select: none;
                                cursor: pointer;
                            }
                        }
                    }
                }

                .publish-material {
                    display: flex;
                    flex-direction: column;
                    flex: 1;

                    & > .title {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                        height: 0.48em;
                        padding: 0 0.14em;
                        border-bottom: 1px solid #EEEEEE;
                        box-sizing: border-box;

                        .left {
                            display: flex;
                            flex-direction: row;
                            align-items: center;

                            & > p {
                                font-size: 0.14em;
                                line-height: 1.429em;
                                color: #323B4B;
                                font-weight: bold;
                            }

                            & > div {
                                position: relative;
                                display: flex;
                                flex-direction: row;
                                align-items: center;

                                &:hover {
                                    p {
                                        display: block;
                                    }
                                }

                                i {
                                    display: block;
                                    width: 0.16em;
                                    height: 0.16em;
                                    background: url('../../assets/img/mediaPublish/notify.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                    margin-left: 0.04em;
                                    user-select: none;
                                    cursor: pointer;
                                }

                                p {
                                    position: absolute;
                                    top: 0.22em;
                                    left: -0.3em;
                                    z-index: 99;
                                    display: none;
                                    width: 1.6em;
                                    height: 0.32em;
                                    background: url('../../assets/img/mediaPublish/noti.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                    margin-left: 0.04em;
                                    user-select: none;
                                    cursor: pointer;
                                }
                            }
                        }

                        .right {
                            display: flex;
                            flex-direction: row;
                            align-items: center;

                            .num {
                                font-size: 0.16em;
                                line-height: 1.1875em;
                                color: #323B4B;
                                margin-right: 0.625em;
                                font-weight: bold;
                            }

                            i.arrow {
                                display: block;
                                width: 0.12em;
                                height: 0.08em;
                                background: url('../../assets/img/mediaPublish/arrow.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                user-select: none;
                                cursor: pointer;

                                &.rotate {
                                    transform: rotate(180deg);
                                }
                            }
                        }
                    }

                    & > .tab {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        width: 3.4em;
                        height: 0.49em;

                        div {
                            position: relative;
                            display: flex;
                            flex-direction: row;
                            justify-content: center;
                            align-items: center;
                            flex: 1;
                            line-height: 3.692em;
                            text-align: center;
                            margin: 0;
                            padding: 0;
                            background: #F9F9F9;
                            box-shadow: 0.308em 0.308em 0.769em 0px rgba(5, 10, 15, 0.05);
                            user-select: none;
                            cursor: pointer;
                            font-size: 0.13em;
                            color: #323B4B;

                            &.on {
                                border-bottom: 0.154em solid #41B48C;
                                box-sizing: border-box;
                            }

                            &:nth-last-of-type(1) {
                                &::after {
                                    display: none;
                                }
                            }

                            &::after {
                                display: block;
                                content: '';
                                position: absolute;
                                top: 50%;
                                right: 0;
                                margin-top: -0.692em;
                                width: 0.0769em;
                                height: 1.385em;
                                background: #DCDCDC;
                            }
                        }
                    }
                }
            }
        }

        .showSave {
            width: 160px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 100px;
            background-color: @green;
            position: fixed;
            top: 80px;
            left: 50%;
            margin-left: -130px;
            z-index: 1200;
            img {
            margin-right: 10px;
            }
            span {
            font-size: 14px;
            color: #fff;
            }
        }
    }
</style>
<style lang="less">
.pichide1 {
    display: none !important;
}
.edui-toolbar {
    overflow: unset !important;
}

.imgContainer {
    position: relative !important;

    .imgBtnsEdit {
        position: absolute;
        top: 0;
        right: 0
    }
}

.textarea {
    em {
        font-style: normal;

        &.on {
            display: inline-block;
            padding: 0 10px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            background: rgba(65, 180, 140, 0.1);
            border-radius: 4px;
            box-sizing: border-box;
            font-size: 14px;
            color: #41B48C;
            font-weight: bold;
            margin: 0 5px;
        }
    }
}

.write-container {
    .edui-default {
        .edui-editor-toolbarboxouter {
            border-top: none;
            background: #FFF;
        }
    }
}

.edui-default .edui-for-customImg .edui-icon {
    background-repeat: no-repeat !important;
    background-size: contain !important;
    background-position: center center;
}

.edui-default .edui-toolbar .edui-button.edui-for-customImg .edui-button-wrap .edui-icon {
    background: url(/static/UEditor/themes/default/images/pic.png) !important;
    background-repeat: no-repeat !important;
    background-size: contain !important;
    background-position: center center !important;
}

.edui-default .edui-toolbar .edui-button.edui-for-customImg .edui-state-hover .edui-button-wrap .edui-icon {
    background: url(/static/UEditor/themes/default/images/picCheck.png) !important;
    background-repeat: no-repeat !important;
    background-size: contain !important;
    background-position: center center !important;
}

.edui-for-customImg {

    &:hover {
        .domList {
            display: flex;
        }
    }

    .domList {
        position: absolute;
        top: 20px;
        left: -40px;   
        z-index: 999999999999;
        display: none;
        flex-direction: column;
        width: 145px;
        background: #FFFFFF;
        box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
        border-radius: 4px;

        span {
            width: 100%;
            height: 5px;
            background: transparent;
        }

        p {
            width: 100%;
            height: 30px;
            line-height: 30px;
            padding: 0 14px;
            box-sizing: border-box;
            font-size: 13px;
            color: #323B4B;

            &:hover {      
                background: rgba(65, 180, 140, 0.15);
            }
        }
    }
}

.edui-default .edui-for-customVideo.edui-icon {
    background-repeat: no-repeat !important;
    background-size: contain !important;
    background-position: center center;
}

.edui-default .edui-toolbar .edui-button.edui-for-customVideo .edui-button-wrap .edui-icon {
    background: url(/static/UEditor/themes/default/images/video.png) !important;
    background-repeat: no-repeat !important;
    background-size: contain !important;
    background-position: center center !important;
}

.edui-default .edui-toolbar .edui-button.edui-for-customVideo .edui-state-hover .edui-button-wrap .edui-icon {
    background: url(/static/UEditor/themes/default/images/videoCheck.png) !important;
    background-repeat: no-repeat !important;
    background-size: contain !important;
    background-position: center center !important;
}

.edui-for-customVideo {

    margin: 1px 2px !important;

    &:hover {
        .domList {
            display: flex;
        }
    }

    .domList {
        position: absolute;
        top: 20px;
        left: -40px;   
        z-index: 999999999999;
        display: none;
        flex-direction: column;
        width: 145px;
        background: #FFFFFF;
        box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
        border-radius: 4px;

        span {
            width: 100%;
            height: 5px;
            background: transparent;
        }

        p {
            width: 100%;
            height: 30px;
            line-height: 30px;
            padding: 0 14px;
            box-sizing: border-box;
            font-size: 13px;
            color: #323B4B;

            &:hover {      
                background: rgba(65, 180, 140, 0.15);
            }
        }
    }
}


.right-container {
    .publish-setting {
        .row {
            .el-select {
                
                .el-input {
                    width: 100%;
                    height: 100%;
                    background: transparent;
                    border: none;
                    box-shadow: none;

                    input {
                        width: 100%;
                        height: 100%;
                        background: transparent;
                        border: none;
                        box-shadow: none;
                    }

                    .el-input__suffix {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
            }
        }
    }
}

.publishSelectDom {
    width: 236px !important;
    height: 24px !important;

    .el-input {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;

        input {
            width: 100%;
            height: 100%;
            background: transparent;
            border: none;
            box-shadow: none;
        }

        .el-input__suffix {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .el-select-dropdown__item.selected {
        color: #41B48C;
    }
}

.publishSelectPoper {
    .is-active {
        color: #41B48C !important;
    }
    .in-active-path {

        color: #41B48C !important;

        .el-cascader-node__label {
            color: #41B48C;
        }
    }
}
</style>